var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegisterHero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 681.033,
    height: 454.763,
    viewBox: "0 0 681.033 454.763",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "registerHero",
    transform: "translate(-28.147 -24.27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9604",
    "data-name": "Group 9604"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9522",
    "data-name": "Group 9522"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9521",
    "data-name": "Group 9521"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9433",
    "data-name": "Group 9433"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9432",
    "data-name": "Group 9432"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9431",
    "data-name": "Group 9431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9430",
    "data-name": "Group 9430"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9429",
    "data-name": "Group 9429"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9428",
    "data-name": "Group 9428"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9427",
    "data-name": "Group 9427"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_456",
    "data-name": "Rectangle 456",
    width: 180.259,
    height: 83.133,
    transform: "translate(479.271 343.017)",
    fill: "#f5f5f5"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9440",
    "data-name": "Group 9440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9439",
    "data-name": "Group 9439"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9438",
    "data-name": "Group 9438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9437",
    "data-name": "Group 9437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9436",
    "data-name": "Group 9436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9435",
    "data-name": "Group 9435"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9434",
    "data-name": "Group 9434"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6163",
    "data-name": "Path 6163",
    d: "M655.239,422.232H483.4V347.391H655.239Zm-170.721-1.121h169.6v-72.6h-169.6Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9447",
    "data-name": "Group 9447"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9446",
    "data-name": "Group 9446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9445",
    "data-name": "Group 9445"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9444",
    "data-name": "Group 9444"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9443",
    "data-name": "Group 9443"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9442",
    "data-name": "Group 9442"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9441",
    "data-name": "Group 9441"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_457",
    "data-name": "Rectangle 457",
    width: 44.037,
    height: 83.133,
    transform: "translate(659.53 343.017)",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9455",
    "data-name": "Group 9455"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9454",
    "data-name": "Group 9454"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9453",
    "data-name": "Group 9453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9452",
    "data-name": "Group 9452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9451",
    "data-name": "Group 9451"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9450",
    "data-name": "Group 9450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9449",
    "data-name": "Group 9449"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9448",
    "data-name": "Group 9448"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6164",
    "data-name": "Path 6164",
    d: "M483.957,370.552H654.678a.226.226,0,0,0,0-.452H483.957a.226.226,0,0,0,0,.452Z",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9463",
    "data-name": "Group 9463"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9462",
    "data-name": "Group 9462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9461",
    "data-name": "Group 9461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9460",
    "data-name": "Group 9460"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9459",
    "data-name": "Group 9459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9458",
    "data-name": "Group 9458"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9457",
    "data-name": "Group 9457"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9456",
    "data-name": "Group 9456"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6165",
    "data-name": "Path 6165",
    d: "M569.875,370.326a186.968,186.968,0,0,0,.059-22.582.23.23,0,0,0-.46,0,186.968,186.968,0,0,0,.058,22.582.172.172,0,0,0,.343,0Z",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9470",
    "data-name": "Group 9470"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9469",
    "data-name": "Group 9469"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9468",
    "data-name": "Group 9468"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9467",
    "data-name": "Group 9467"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9466",
    "data-name": "Group 9466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9465",
    "data-name": "Group 9465"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9464",
    "data-name": "Group 9464"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6166",
    "data-name": "Path 6166",
    d: "M615.828,359.035a2.326,2.326,0,1,1-2.326-2.326A2.326,2.326,0,0,1,615.828,359.035Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9477",
    "data-name": "Group 9477"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9476",
    "data-name": "Group 9476"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9475",
    "data-name": "Group 9475"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9474",
    "data-name": "Group 9474"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9473",
    "data-name": "Group 9473"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9472",
    "data-name": "Group 9472"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9471",
    "data-name": "Group 9471"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6167",
    "data-name": "Path 6167",
    d: "M526.233,359.035a2.326,2.326,0,1,1-2.326-2.326A2.326,2.326,0,0,1,526.233,359.035Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9484",
    "data-name": "Group 9484"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9483",
    "data-name": "Group 9483"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9482",
    "data-name": "Group 9482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9481",
    "data-name": "Group 9481"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9480",
    "data-name": "Group 9480"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9479",
    "data-name": "Group 9479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9478",
    "data-name": "Group 9478"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6168",
    "data-name": "Path 6168",
    d: "M571.643,384.811a2.326,2.326,0,1,1-2.325-2.325A2.325,2.325,0,0,1,571.643,384.811Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9491",
    "data-name": "Group 9491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9490",
    "data-name": "Group 9490"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9489",
    "data-name": "Group 9489"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9488",
    "data-name": "Group 9488"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9487",
    "data-name": "Group 9487"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9486",
    "data-name": "Group 9486"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9485",
    "data-name": "Group 9485"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6169",
    "data-name": "Path 6169",
    d: "M500.822,426.15l-9.281,52.193h5.22l17.111-52.193Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9498",
    "data-name": "Group 9498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9497",
    "data-name": "Group 9497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9496",
    "data-name": "Group 9496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9495",
    "data-name": "Group 9495"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9494",
    "data-name": "Group 9494"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9493",
    "data-name": "Group 9493"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9492",
    "data-name": "Group 9492"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6170",
    "data-name": "Path 6170",
    d: "M646.776,426.15l7.761,52.283h-5.22L633.725,426.15Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9505",
    "data-name": "Group 9505"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9504",
    "data-name": "Group 9504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9503",
    "data-name": "Group 9503"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9502",
    "data-name": "Group 9502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9501",
    "data-name": "Group 9501"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9500",
    "data-name": "Group 9500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9499",
    "data-name": "Group 9499"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6171",
    "data-name": "Path 6171",
    d: "M681.623,426.15l8.793,52.283H685.2L668.573,426.15Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9512",
    "data-name": "Group 9512"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9511",
    "data-name": "Group 9511"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9510",
    "data-name": "Group 9510"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9509",
    "data-name": "Group 9509"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9508",
    "data-name": "Group 9508"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9507",
    "data-name": "Group 9507"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9506",
    "data-name": "Group 9506"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6172",
    "data-name": "Path 6172",
    d: "M571.487,408.339a2.326,2.326,0,1,1-2.325-2.326A2.325,2.325,0,0,1,571.487,408.339Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9520",
    "data-name": "Group 9520"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9519",
    "data-name": "Group 9519"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9518",
    "data-name": "Group 9518"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9517",
    "data-name": "Group 9517"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9516",
    "data-name": "Group 9516"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9515",
    "data-name": "Group 9515"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9514",
    "data-name": "Group 9514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9513",
    "data-name": "Group 9513"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6173",
    "data-name": "Path 6173",
    d: "M483.957,396.3H654.678a.227.227,0,0,0,0-.453H483.957a.227.227,0,0,0,0,.453Z",
    fill: "#e0e0e0"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9603",
    "data-name": "Group 9603"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9530",
    "data-name": "Group 9530"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9529",
    "data-name": "Group 9529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9528",
    "data-name": "Group 9528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9527",
    "data-name": "Group 9527"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9526",
    "data-name": "Group 9526"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9525",
    "data-name": "Group 9525"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9524",
    "data-name": "Group 9524"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9523",
    "data-name": "Group 9523"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_458",
    "data-name": "Rectangle 458",
    width: 11.095,
    height: 54.502,
    transform: "translate(605.067 303.708) rotate(89.698)",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9579",
    "data-name": "Group 9579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9538",
    "data-name": "Group 9538"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9537",
    "data-name": "Group 9537"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9536",
    "data-name": "Group 9536"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9535",
    "data-name": "Group 9535"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9534",
    "data-name": "Group 9534"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9533",
    "data-name": "Group 9533"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9532",
    "data-name": "Group 9532"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9531",
    "data-name": "Group 9531"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_459",
    "data-name": "Rectangle 459",
    width: 17.24,
    height: 60.746,
    transform: "translate(611.582 325.546) rotate(89.697)",
    fill: "#f5f5f5"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9546",
    "data-name": "Group 9546"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9545",
    "data-name": "Group 9545"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9544",
    "data-name": "Group 9544"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9543",
    "data-name": "Group 9543"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9542",
    "data-name": "Group 9542"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9541",
    "data-name": "Group 9541"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9540",
    "data-name": "Group 9540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9539",
    "data-name": "Group 9539"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6174",
    "data-name": "Path 6174",
    d: "M599.97,342.666a63.23,63.23,0,0,1-.295-8.62,63.206,63.206,0,0,1,.295-8.62,63.188,63.188,0,0,1,.3,8.62A63.212,63.212,0,0,1,599.97,342.666Z",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9554",
    "data-name": "Group 9554"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9553",
    "data-name": "Group 9553"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9552",
    "data-name": "Group 9552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9551",
    "data-name": "Group 9551"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9550",
    "data-name": "Group 9550"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9549",
    "data-name": "Group 9549"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9548",
    "data-name": "Group 9548"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9547",
    "data-name": "Group 9547"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6175",
    "data-name": "Path 6175",
    d: "M602.522,342.666a63.23,63.23,0,0,1-.295-8.62,63.206,63.206,0,0,1,.295-8.62,63.188,63.188,0,0,1,.3,8.62A63.212,63.212,0,0,1,602.522,342.666Z",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9562",
    "data-name": "Group 9562"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9561",
    "data-name": "Group 9561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9560",
    "data-name": "Group 9560"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9559",
    "data-name": "Group 9559"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9558",
    "data-name": "Group 9558"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9557",
    "data-name": "Group 9557"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9556",
    "data-name": "Group 9556"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9555",
    "data-name": "Group 9555"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6176",
    "data-name": "Path 6176",
    d: "M560.067,342.666a63.212,63.212,0,0,1-.3-8.62,63.188,63.188,0,0,1,.3-8.62,63.206,63.206,0,0,1,.295,8.62A63.23,63.23,0,0,1,560.067,342.666Z",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9570",
    "data-name": "Group 9570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9569",
    "data-name": "Group 9569"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9568",
    "data-name": "Group 9568"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9567",
    "data-name": "Group 9567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9566",
    "data-name": "Group 9566"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9565",
    "data-name": "Group 9565"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9564",
    "data-name": "Group 9564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9563",
    "data-name": "Group 9563"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6177",
    "data-name": "Path 6177",
    d: "M562.619,342.666a63.212,63.212,0,0,1-.3-8.62,63.188,63.188,0,0,1,.3-8.62,63.206,63.206,0,0,1,.295,8.62A63.23,63.23,0,0,1,562.619,342.666Z",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9578",
    "data-name": "Group 9578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9577",
    "data-name": "Group 9577"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9576",
    "data-name": "Group 9576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9575",
    "data-name": "Group 9575"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9574",
    "data-name": "Group 9574"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9573",
    "data-name": "Group 9573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9572",
    "data-name": "Group 9572"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9571",
    "data-name": "Group 9571"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6178",
    "data-name": "Path 6178",
    d: "M568.187,334.323c0-.165,6.128-.3,13.687-.3s13.688.133,13.688.3-6.127.3-13.688.3S568.187,334.488,568.187,334.323Z",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9602",
    "data-name": "Group 9602"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9587",
    "data-name": "Group 9587"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9586",
    "data-name": "Group 9586"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9585",
    "data-name": "Group 9585"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9584",
    "data-name": "Group 9584"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9583",
    "data-name": "Group 9583"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9582",
    "data-name": "Group 9582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9581",
    "data-name": "Group 9581"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9580",
    "data-name": "Group 9580"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_460",
    "data-name": "Rectangle 460",
    width: 11.095,
    height: 74.96,
    transform: "translate(634.426 314.352) rotate(89.697)",
    fill: "#ebebeb"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9594",
    "data-name": "Group 9594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9593",
    "data-name": "Group 9593"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9592",
    "data-name": "Group 9592"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9591",
    "data-name": "Group 9591"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9590",
    "data-name": "Group 9590"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9589",
    "data-name": "Group 9589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9588",
    "data-name": "Group 9588"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6179",
    "data-name": "Path 6179",
    d: "M623.752,324.071a3.589,3.589,0,1,1,3.543-3.588A3.566,3.566,0,0,1,623.752,324.071Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9601",
    "data-name": "Group 9601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9600",
    "data-name": "Group 9600"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9599",
    "data-name": "Group 9599"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9598",
    "data-name": "Group 9598"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9597",
    "data-name": "Group 9597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9596",
    "data-name": "Group 9596"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9595",
    "data-name": "Group 9595"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_461",
    "data-name": "Rectangle 461",
    width: 2.218,
    height: 50.177,
    transform: "translate(614.01 319.374) rotate(90)",
    fill: "#e0e0e0"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10126",
    "data-name": "Group 10126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9963",
    "data-name": "Group 9963"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9653",
    "data-name": "Group 9653"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9610",
    "data-name": "Group 9610"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9609",
    "data-name": "Group 9609"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9608",
    "data-name": "Group 9608"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9607",
    "data-name": "Group 9607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9606",
    "data-name": "Group 9606"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9605",
    "data-name": "Group 9605"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6180",
    "data-name": "Path 6180",
    d: "M48.154,111.194s-6.379,4.859-.267,11.281a.563.563,0,0,0,.4.171l55.733-.326s4.76-5.338.811-11.489Z",
    fill: "#ebebeb"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9617",
    "data-name": "Group 9617"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9616",
    "data-name": "Group 9616"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9615",
    "data-name": "Group 9615"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9614",
    "data-name": "Group 9614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9613",
    "data-name": "Group 9613"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9612",
    "data-name": "Group 9612"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9611",
    "data-name": "Group 9611"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6181",
    "data-name": "Path 6181",
    d: "M91.707,116.266c0,.062-6.94.113-15.5.113s-15.5-.051-15.5-.113,6.939-.112,15.5-.112S91.707,116.2,91.707,116.266Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9624",
    "data-name": "Group 9624"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9623",
    "data-name": "Group 9623"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9622",
    "data-name": "Group 9622"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9621",
    "data-name": "Group 9621"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9620",
    "data-name": "Group 9620"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9619",
    "data-name": "Group 9619"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9618",
    "data-name": "Group 9618"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6182",
    "data-name": "Path 6182",
    d: "M83.038,118.282c0,.063-3.263.113-7.287.113s-7.287-.05-7.287-.113,3.262-.112,7.287-.112S83.038,118.22,83.038,118.282Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9631",
    "data-name": "Group 9631"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9630",
    "data-name": "Group 9630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9629",
    "data-name": "Group 9629"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9628",
    "data-name": "Group 9628"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9627",
    "data-name": "Group 9627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9626",
    "data-name": "Group 9626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9625",
    "data-name": "Group 9625"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6183",
    "data-name": "Path 6183",
    d: "M97.4,122.142c-.036-.01.123-.64.3-1.672a23.083,23.083,0,0,0-.077-8.127c-.192-1.028-.363-1.656-.327-1.666a1.778,1.778,0,0,1,.162.429c.093.279.2.691.321,1.2a19.728,19.728,0,0,1,.077,8.188c-.107.516-.21.93-.3,1.211A1.8,1.8,0,0,1,97.4,122.142Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9638",
    "data-name": "Group 9638"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9637",
    "data-name": "Group 9637"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9636",
    "data-name": "Group 9636"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9635",
    "data-name": "Group 9635"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9634",
    "data-name": "Group 9634"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9633",
    "data-name": "Group 9633"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9632",
    "data-name": "Group 9632"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6184",
    "data-name": "Path 6184",
    d: "M101.565,110.761a1.926,1.926,0,0,1,.248.4,4.752,4.752,0,0,1,.248.5c.087.2.2.422.284.681a11.814,11.814,0,0,1,.531,1.85,12.463,12.463,0,0,1,.038,4.694,11.98,11.98,0,0,1-.5,1.858c-.084.261-.19.486-.273.686a4.662,4.662,0,0,1-.24.5,1.9,1.9,0,0,1-.242.409c-.038-.019.272-.619.6-1.649a13.386,13.386,0,0,0,.447-1.843,13.272,13.272,0,0,0-.037-4.619,13.316,13.316,0,0,0-.477-1.835C101.847,111.376,101.527,110.781,101.565,110.761Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9645",
    "data-name": "Group 9645"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9644",
    "data-name": "Group 9644"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9643",
    "data-name": "Group 9643"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9642",
    "data-name": "Group 9642"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9641",
    "data-name": "Group 9641"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9640",
    "data-name": "Group 9640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9639",
    "data-name": "Group 9639"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6185",
    "data-name": "Path 6185",
    d: "M56.948,122.216a1.746,1.746,0,0,1-.26-.373,3.979,3.979,0,0,1-.26-.464,6.679,6.679,0,0,1-.3-.641,9.748,9.748,0,0,1-.543-1.758,10.341,10.341,0,0,1,.06-4.484,9.749,9.749,0,0,1,.591-1.744,6.522,6.522,0,0,1,.315-.632,3.821,3.821,0,0,1,.272-.458,1.728,1.728,0,0,1,.27-.365c.038.023-.321.562-.711,1.518a10.91,10.91,0,0,0-.535,1.727,10.926,10.926,0,0,0-.059,4.4,10.971,10.971,0,0,0,.488,1.741C56.643,121.646,56.987,122.194,56.948,122.216Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9652",
    "data-name": "Group 9652"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9651",
    "data-name": "Group 9651"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9650",
    "data-name": "Group 9650"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9649",
    "data-name": "Group 9649"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9648",
    "data-name": "Group 9648"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9647",
    "data-name": "Group 9647"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9646",
    "data-name": "Group 9646"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6186",
    "data-name": "Path 6186",
    d: "M50.93,123.576a2.22,2.22,0,0,1-.286-.423,4.671,4.671,0,0,1-.291-.523,7.858,7.858,0,0,1-.337-.719,11.793,11.793,0,0,1-.638-1.967,12.444,12.444,0,0,1-.112-5.041,11.815,11.815,0,0,1,.55-1.994c.093-.28.212-.519.3-.733a4.835,4.835,0,0,1,.268-.536,2.24,2.24,0,0,1,.267-.435c.041.021-.316.655-.69,1.757a13.2,13.2,0,0,0-.5,1.976,13.157,13.157,0,0,0,.11,4.961,13.189,13.189,0,0,0,.583,1.952C50.585,122.935,50.97,123.553,50.93,123.576Z",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9743",
    "data-name": "Group 9743"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9701",
    "data-name": "Group 9701"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9659",
    "data-name": "Group 9659"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9658",
    "data-name": "Group 9658"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9657",
    "data-name": "Group 9657"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9656",
    "data-name": "Group 9656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9655",
    "data-name": "Group 9655"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9654",
    "data-name": "Group 9654"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6187",
    "data-name": "Path 6187",
    d: "M101.98,139.294v10.665H81.342V139.294Z",
    fill: "#ebebeb"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9665",
    "data-name": "Group 9665"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9664",
    "data-name": "Group 9664"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9663",
    "data-name": "Group 9663"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9662",
    "data-name": "Group 9662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9661",
    "data-name": "Group 9661"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9660",
    "data-name": "Group 9660"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6188",
    "data-name": "Path 6188",
    d: "M35.328,144.726c0,.094.008.188.012.282a6.112,6.112,0,0,0,6.14,5.723h61.462v-.772H88.352a5.332,5.332,0,0,1-5.333-5.332h0a5.333,5.333,0,0,1,5.333-5.333h14.59v-1.133l-61.481.208A6.149,6.149,0,0,0,35.328,144.726Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9672",
    "data-name": "Group 9672"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9671",
    "data-name": "Group 9671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9670",
    "data-name": "Group 9670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9669",
    "data-name": "Group 9669"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9668",
    "data-name": "Group 9668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9667",
    "data-name": "Group 9667"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9666",
    "data-name": "Group 9666"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6189",
    "data-name": "Path 6189",
    d: "M101.98,144.769c0,.062-4.243.113-9.476.113s-9.478-.051-9.478-.113,4.243-.112,9.478-.112S101.98,144.707,101.98,144.769Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9679",
    "data-name": "Group 9679"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9678",
    "data-name": "Group 9678"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9677",
    "data-name": "Group 9677"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9676",
    "data-name": "Group 9676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9675",
    "data-name": "Group 9675"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9674",
    "data-name": "Group 9674"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9673",
    "data-name": "Group 9673"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6190",
    "data-name": "Path 6190",
    d: "M101.681,147.173c0,.062-4.015.112-8.966.112s-8.968-.05-8.968-.112,4.014-.113,8.968-.113S101.681,147.11,101.681,147.173Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9686",
    "data-name": "Group 9686"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9685",
    "data-name": "Group 9685"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9684",
    "data-name": "Group 9684"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9683",
    "data-name": "Group 9683"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9682",
    "data-name": "Group 9682"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9681",
    "data-name": "Group 9681"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9680",
    "data-name": "Group 9680"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6191",
    "data-name": "Path 6191",
    d: "M101.98,149.37c0,.062-3.61.113-8.062.113s-8.063-.051-8.063-.113,3.609-.112,8.063-.112S101.98,149.308,101.98,149.37Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9693",
    "data-name": "Group 9693"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9692",
    "data-name": "Group 9692"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9691",
    "data-name": "Group 9691"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9690",
    "data-name": "Group 9690"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9689",
    "data-name": "Group 9689"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9688",
    "data-name": "Group 9688"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9687",
    "data-name": "Group 9687"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6192",
    "data-name": "Path 6192",
    d: "M101.98,142.61c0,.062-4.156.112-9.282.112s-9.284-.05-9.284-.112,4.156-.113,9.284-.113S101.98,142.548,101.98,142.61Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9700",
    "data-name": "Group 9700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9699",
    "data-name": "Group 9699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9698",
    "data-name": "Group 9698"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9697",
    "data-name": "Group 9697"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9696",
    "data-name": "Group 9696"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9695",
    "data-name": "Group 9695"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9694",
    "data-name": "Group 9694"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6193",
    "data-name": "Path 6193",
    d: "M101.681,140.45c0,.063-3.7.113-8.262.113s-8.263-.05-8.263-.113,3.7-.112,8.263-.112S101.681,140.388,101.681,140.45Z",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9708",
    "data-name": "Group 9708"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9707",
    "data-name": "Group 9707"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9706",
    "data-name": "Group 9706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9705",
    "data-name": "Group 9705"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9704",
    "data-name": "Group 9704"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9703",
    "data-name": "Group 9703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9702",
    "data-name": "Group 9702"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6194",
    "data-name": "Path 6194",
    d: "M42.775,138.547a13.677,13.677,0,0,0-1.306,1.553,7.9,7.9,0,0,0,.108,9.14,13.622,13.622,0,0,0,1.342,1.521,2.13,2.13,0,0,1-.444-.327,6.982,6.982,0,0,1-1.026-1.1,7.778,7.778,0,0,1-.111-9.325,7.037,7.037,0,0,1,1-1.124A2.154,2.154,0,0,1,42.775,138.547Z",
    fill: "#f5f5f5"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9715",
    "data-name": "Group 9715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9714",
    "data-name": "Group 9714"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9713",
    "data-name": "Group 9713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9712",
    "data-name": "Group 9712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9711",
    "data-name": "Group 9711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9710",
    "data-name": "Group 9710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9709",
    "data-name": "Group 9709"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6195",
    "data-name": "Path 6195",
    d: "M40.7,138.32a13.644,13.644,0,0,0-1.305,1.553,7.895,7.895,0,0,0,.108,9.139,13.577,13.577,0,0,0,1.342,1.522,2.133,2.133,0,0,1-.444-.328,7.026,7.026,0,0,1-1.027-1.1,7.78,7.78,0,0,1-.11-9.325,7.034,7.034,0,0,1,1-1.124A2.147,2.147,0,0,1,40.7,138.32Z",
    fill: "#f5f5f5"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9722",
    "data-name": "Group 9722"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9721",
    "data-name": "Group 9721"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9720",
    "data-name": "Group 9720"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9719",
    "data-name": "Group 9719"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9718",
    "data-name": "Group 9718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9717",
    "data-name": "Group 9717"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9716",
    "data-name": "Group 9716"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6196",
    "data-name": "Path 6196",
    d: "M82.459,138.547a13.807,13.807,0,0,0-1.306,1.553,7.9,7.9,0,0,0,.108,9.14,13.747,13.747,0,0,0,1.342,1.521,2.113,2.113,0,0,1-.443-.327,6.979,6.979,0,0,1-1.027-1.1,7.78,7.78,0,0,1-.11-9.325,7.04,7.04,0,0,1,1-1.124A2.154,2.154,0,0,1,82.459,138.547Z",
    fill: "#f5f5f5"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9729",
    "data-name": "Group 9729"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9728",
    "data-name": "Group 9728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9727",
    "data-name": "Group 9727"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9726",
    "data-name": "Group 9726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9725",
    "data-name": "Group 9725"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9724",
    "data-name": "Group 9724"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9723",
    "data-name": "Group 9723"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6197",
    "data-name": "Path 6197",
    d: "M80.381,138.32a13.451,13.451,0,0,0-1.306,1.553,7.895,7.895,0,0,0,.108,9.139,13.7,13.7,0,0,0,1.342,1.522,2.165,2.165,0,0,1-.444-.328,6.981,6.981,0,0,1-1.026-1.1,7.778,7.778,0,0,1-.111-9.325,7.083,7.083,0,0,1,1-1.124A2.165,2.165,0,0,1,80.381,138.32Z",
    fill: "#f5f5f5"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9735",
    "data-name": "Group 9735"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9734",
    "data-name": "Group 9734"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9733",
    "data-name": "Group 9733"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9732",
    "data-name": "Group 9732"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9731",
    "data-name": "Group 9731"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9730",
    "data-name": "Group 9730"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6198",
    "data-name": "Path 6198",
    d: "M49.769,146.225q-.029-2.169-.058-4.337a3.087,3.087,0,0,0-.153-1.117,1.051,1.051,0,0,0-.823-.695,1.65,1.65,0,0,0-1.769.838,4.116,4.116,0,0,0-.426,2.126,30.851,30.851,0,0,0,.166,3.425,3.94,3.94,0,0,0,.4,1.569,1.461,1.461,0,0,0,1.323.795,1.477,1.477,0,0,0,1.158-1.006A4.313,4.313,0,0,0,49.769,146.225Z",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9742",
    "data-name": "Group 9742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9741",
    "data-name": "Group 9741"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9740",
    "data-name": "Group 9740"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9739",
    "data-name": "Group 9739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9738",
    "data-name": "Group 9738"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9737",
    "data-name": "Group 9737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9736",
    "data-name": "Group 9736"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6199",
    "data-name": "Path 6199",
    d: "M73.64,144.978c0,.062-4.443.112-9.923.112s-9.924-.05-9.924-.112,4.442-.113,9.924-.113S73.64,144.916,73.64,144.978Z",
    fill: "#f5f5f5"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9921",
    "data-name": "Group 9921"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9851",
    "data-name": "Group 9851"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9785",
    "data-name": "Group 9785"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9749",
    "data-name": "Group 9749"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9748",
    "data-name": "Group 9748"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9747",
    "data-name": "Group 9747"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9746",
    "data-name": "Group 9746"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9745",
    "data-name": "Group 9745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9744",
    "data-name": "Group 9744"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6200",
    "data-name": "Path 6200",
    d: "M45.652,138.121l-.114-10.109h5.5l.19,10.109Z",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9756",
    "data-name": "Group 9756"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9755",
    "data-name": "Group 9755"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9754",
    "data-name": "Group 9754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9753",
    "data-name": "Group 9753"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9752",
    "data-name": "Group 9752"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9751",
    "data-name": "Group 9751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9750",
    "data-name": "Group 9750"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6201",
    "data-name": "Path 6201",
    d: "M50.716,129.81a14.6,14.6,0,0,1-2.557.113,14.613,14.613,0,0,1-2.557-.113,14.677,14.677,0,0,1,2.557-.112A14.668,14.668,0,0,1,50.716,129.81Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9763",
    "data-name": "Group 9763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9762",
    "data-name": "Group 9762"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9761",
    "data-name": "Group 9761"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9760",
    "data-name": "Group 9760"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9759",
    "data-name": "Group 9759"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9758",
    "data-name": "Group 9758"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9757",
    "data-name": "Group 9757"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6202",
    "data-name": "Path 6202",
    d: "M50.716,131.37a14.487,14.487,0,0,1-2.557.113,14.5,14.5,0,0,1-2.557-.113,14.677,14.677,0,0,1,2.557-.112A14.668,14.668,0,0,1,50.716,131.37Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9770",
    "data-name": "Group 9770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9769",
    "data-name": "Group 9769"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9768",
    "data-name": "Group 9768"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9767",
    "data-name": "Group 9767"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9766",
    "data-name": "Group 9766"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9765",
    "data-name": "Group 9765"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9764",
    "data-name": "Group 9764"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6203",
    "data-name": "Path 6203",
    d: "M50.716,132.931a14.668,14.668,0,0,1-2.557.112,14.677,14.677,0,0,1-2.557-.112,14.613,14.613,0,0,1,2.557-.113A14.6,14.6,0,0,1,50.716,132.931Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9777",
    "data-name": "Group 9777"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9776",
    "data-name": "Group 9776"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9775",
    "data-name": "Group 9775"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9774",
    "data-name": "Group 9774"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9773",
    "data-name": "Group 9773"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9772",
    "data-name": "Group 9772"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9771",
    "data-name": "Group 9771"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6204",
    "data-name": "Path 6204",
    d: "M50.716,134.491a14.6,14.6,0,0,1-2.557.113,14.613,14.613,0,0,1-2.557-.113,14.677,14.677,0,0,1,2.557-.112A14.668,14.668,0,0,1,50.716,134.491Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9784",
    "data-name": "Group 9784"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9783",
    "data-name": "Group 9783"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9782",
    "data-name": "Group 9782"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9781",
    "data-name": "Group 9781"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9780",
    "data-name": "Group 9780"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9779",
    "data-name": "Group 9779"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9778",
    "data-name": "Group 9778"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6205",
    "data-name": "Path 6205",
    d: "M50.716,136.051a14.487,14.487,0,0,1-2.557.113,14.5,14.5,0,0,1-2.557-.113,14.677,14.677,0,0,1,2.557-.112A14.668,14.668,0,0,1,50.716,136.051Z",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9791",
    "data-name": "Group 9791"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9790",
    "data-name": "Group 9790"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9789",
    "data-name": "Group 9789"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9788",
    "data-name": "Group 9788"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9787",
    "data-name": "Group 9787"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9786",
    "data-name": "Group 9786"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6206",
    "data-name": "Path 6206",
    d: "M45.246,127.744h60.992a28.651,28.651,0,0,1,0,10.927H45.507v-.743h3.711a1.753,1.753,0,0,0,1.752-1.753v-6.047a1.752,1.752,0,0,0-1.752-1.752H45.246Z",
    fill: "#ebebeb"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9822",
    "data-name": "Group 9822"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9796",
    "data-name": "Group 9796"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9795",
    "data-name": "Group 9795"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9794",
    "data-name": "Group 9794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9793",
    "data-name": "Group 9793"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9792",
    "data-name": "Group 9792"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6207",
    "data-name": "Path 6207",
    d: "M59.665,133.214h1.018a.239.239,0,0,1,.11.027.21.21,0,0,1,.109.192.246.246,0,0,1-.008.065c-.02.086-.043.173-.069.26a2.882,2.882,0,0,1-.637,1.152,1.206,1.206,0,0,1-.868.449,1.012,1.012,0,0,1-.122-.008.991.991,0,0,1-.693-.5,2.289,2.289,0,0,1-.3-1.225,3.3,3.3,0,0,1,.12-.873,2.914,2.914,0,0,1,.6-1.18,1.228,1.228,0,0,1,.916-.487.867.867,0,0,1,.386.088,1.248,1.248,0,0,1,.594.743.23.23,0,0,1,.024.1.219.219,0,0,1-.03.11.21.21,0,0,1-.189.109.247.247,0,0,1-.068-.011.209.209,0,0,1-.14-.137l-.011-.02a1.069,1.069,0,0,0-.122-.241.581.581,0,0,0-.487-.29.572.572,0,0,0-.337.123,1.792,1.792,0,0,0-.555.8,3,3,0,0,0-.241,1.148,2.054,2.054,0,0,0,.175.9.591.591,0,0,0,.531.4.727.727,0,0,0,.492-.3,2.717,2.717,0,0,0,.522-.945c-.468,0-.712,0-.73-.009-.158-.025-.24-.108-.243-.246a.213.213,0,0,1,.022-.074A.23.23,0,0,1,59.665,133.214Z",
    fill: "#fafafa"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9801",
    "data-name": "Group 9801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9800",
    "data-name": "Group 9800"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9799",
    "data-name": "Group 9799"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9798",
    "data-name": "Group 9798"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9797",
    "data-name": "Group 9797"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6208",
    "data-name": "Path 6208",
    d: "M63.128,131.227c.009.02.018.045.028.074q.065.225.718,3.78a.172.172,0,0,1,.01.054.229.229,0,0,1-.03.112.2.2,0,0,1-.182.112l-.035,0a.2.2,0,0,1-.169-.15l-.242-1.256H61.973l-.6,1.26a.4.4,0,0,1-.02.042.244.244,0,0,1-.189.107.22.22,0,0,1-.119-.035.212.212,0,0,1-.1-.184.174.174,0,0,1,.014-.066c.037-.087.1-.225.186-.414q1.315-2.871,1.573-3.389a.238.238,0,0,1,.212-.153A.233.233,0,0,1,63.128,131.227Zm-.273.846-.678,1.425h.957Z",
    fill: "#fafafa"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9806",
    "data-name": "Group 9806"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9805",
    "data-name": "Group 9805"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9804",
    "data-name": "Group 9804"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9803",
    "data-name": "Group 9803"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9802",
    "data-name": "Group 9802"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6209",
    "data-name": "Path 6209",
    d: "M66.53,135.359H64.692a.215.215,0,0,1-.118-.035.334.334,0,0,1-.1-.231v0q0-.112.507-3.763a.688.688,0,0,1,.011-.081.2.2,0,0,1,.2-.134.2.2,0,0,1,.1.025.2.2,0,0,1,.115.194c-.016.166-.057.51-.125,1.031q-.315,2.41-.329,2.544H66.51a.322.322,0,0,1,.118.022.207.207,0,0,1,.14.205.251.251,0,0,1-.011.072A.257.257,0,0,1,66.53,135.359Z",
    fill: "#fafafa"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9811",
    "data-name": "Group 9811"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9810",
    "data-name": "Group 9810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9809",
    "data-name": "Group 9809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9808",
    "data-name": "Group 9808"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9807",
    "data-name": "Group 9807"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6210",
    "data-name": "Path 6210",
    d: "M69.043,131.227a.651.651,0,0,1,.028.074q.064.225.718,3.78a.147.147,0,0,1,.01.054.229.229,0,0,1-.03.112.2.2,0,0,1-.182.112l-.035,0a.2.2,0,0,1-.168-.15l-.243-1.256H67.888l-.6,1.26a.267.267,0,0,1-.02.042.241.241,0,0,1-.189.107.223.223,0,0,1-.119-.035.214.214,0,0,1-.1-.184.174.174,0,0,1,.014-.066c.038-.087.1-.225.187-.414q1.314-2.871,1.572-3.389a.238.238,0,0,1,.212-.153A.232.232,0,0,1,69.043,131.227Zm-.273.846-.678,1.425h.957Z",
    fill: "#fafafa"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9816",
    "data-name": "Group 9816"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9815",
    "data-name": "Group 9815"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9814",
    "data-name": "Group 9814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9813",
    "data-name": "Group 9813"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9812",
    "data-name": "Group 9812"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6211",
    "data-name": "Path 6211",
    d: "M71.972,133.4q.214.6.333.921.284.786.284.829a.2.2,0,0,1-.035.111.208.208,0,0,1-.184.1.2.2,0,0,1-.182-.148c-.014-.039-.026-.07-.035-.093q-.15-.342-.491-1.295l-1.04,1.421a.256.256,0,0,1-.195.115.23.23,0,0,1-.113-.03.2.2,0,0,1-.1-.184.3.3,0,0,1,0-.046.519.519,0,0,1,.109-.178q.523-.675,1.155-1.609c-.044-.122-.086-.238-.126-.347q-.586-1.573-.587-1.625a.249.249,0,0,1,.028-.113.192.192,0,0,1,.177-.109.222.222,0,0,1,.206.122l.613,1.654,1.226-1.669a.246.246,0,0,1,.2-.1.2.2,0,0,1,.206.22.264.264,0,0,1-.022.1Z",
    fill: "#fafafa"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9821",
    "data-name": "Group 9821"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9820",
    "data-name": "Group 9820"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9819",
    "data-name": "Group 9819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9818",
    "data-name": "Group 9818"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9817",
    "data-name": "Group 9817"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6212",
    "data-name": "Path 6212",
    d: "M76.521,131.132a.22.22,0,0,1,.1.025.216.216,0,0,1,.117.188q-.451,3.565-.5,3.853a2.344,2.344,0,0,1-.394,1,1.418,1.418,0,0,1-1.808.443,1.309,1.309,0,0,1-.649-.569.243.243,0,0,1-.024-.107.213.213,0,0,1,.03-.109.209.209,0,0,1,.189-.11.215.215,0,0,1,.167.091,1.183,1.183,0,0,0,.941.536.933.933,0,0,0,.73-.371,2.023,2.023,0,0,0,.4-1.156,1.074,1.074,0,0,1-.271.288,1.1,1.1,0,0,1-.659.216.87.87,0,0,1-.123-.009.984.984,0,0,1-.7-.5,2.269,2.269,0,0,1-.306-1.225c0-.223.01-.452.03-.69q.052-.558.249-1.584a.285.285,0,0,1,.019-.063.2.2,0,0,1,.2-.15.211.211,0,0,1,.107.03.193.193,0,0,1,.109.175,8.143,8.143,0,0,1-.1.839,11.4,11.4,0,0,0-.145,1.281,2.577,2.577,0,0,0,.164,1c.126.3.307.448.545.448a.378.378,0,0,0,.073-.008,1,1,0,0,0,.55-.44,2.739,2.739,0,0,0,.455-1.013l.279-2.1a.25.25,0,0,1,.027-.093A.2.2,0,0,1,76.521,131.132Z",
    fill: "#fafafa"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9829",
    "data-name": "Group 9829"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9828",
    "data-name": "Group 9828"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9827",
    "data-name": "Group 9827"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9826",
    "data-name": "Group 9826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9825",
    "data-name": "Group 9825"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9824",
    "data-name": "Group 9824"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9823",
    "data-name": "Group 9823"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6213",
    "data-name": "Path 6213",
    d: "M103.947,138.813c-.062,0-.113-2.51-.113-5.605s.051-5.606.113-5.606.112,2.509.112,5.606S104.009,138.813,103.947,138.813Z",
    fill: "#f5f5f5"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9836",
    "data-name": "Group 9836"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9835",
    "data-name": "Group 9835"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9834",
    "data-name": "Group 9834"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9833",
    "data-name": "Group 9833"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9832",
    "data-name": "Group 9832"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9831",
    "data-name": "Group 9831"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9830",
    "data-name": "Group 9830"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6214",
    "data-name": "Path 6214",
    d: "M54.037,138.813c-.062,0-.112-2.51-.112-5.605s.05-5.606.112-5.606.113,2.509.113,5.606S54.1,138.813,54.037,138.813Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9843",
    "data-name": "Group 9843"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9842",
    "data-name": "Group 9842"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9841",
    "data-name": "Group 9841"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9840",
    "data-name": "Group 9840"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9839",
    "data-name": "Group 9839"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9838",
    "data-name": "Group 9838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9837",
    "data-name": "Group 9837"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6215",
    "data-name": "Path 6215",
    d: "M105.017,138.813c-.062,0-.112-2.51-.112-5.605s.05-5.606.112-5.606.113,2.509.113,5.606S105.079,138.813,105.017,138.813Z",
    fill: "#f5f5f5"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9850",
    "data-name": "Group 9850"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9849",
    "data-name": "Group 9849"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9848",
    "data-name": "Group 9848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9847",
    "data-name": "Group 9847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9846",
    "data-name": "Group 9846"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9845",
    "data-name": "Group 9845"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9844",
    "data-name": "Group 9844"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6216",
    "data-name": "Path 6216",
    d: "M53.037,138.813c-.062,0-.112-2.51-.112-5.605s.05-5.606.112-5.606.113,2.509.113,5.606S53.1,138.813,53.037,138.813Z",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9920",
    "data-name": "Group 9920"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9862",
    "data-name": "Group 9862"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9861",
    "data-name": "Group 9861"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9860",
    "data-name": "Group 9860"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9859",
    "data-name": "Group 9859"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9858",
    "data-name": "Group 9858"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9857",
    "data-name": "Group 9857"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9856",
    "data-name": "Group 9856"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9855",
    "data-name": "Group 9855"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9854",
    "data-name": "Group 9854"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9853",
    "data-name": "Group 9853"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9852",
    "data-name": "Group 9852"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6217",
    "data-name": "Path 6217",
    d: "M89.158,129.449l-.01-.02,6.447,5.2.057.046-.071.018-.858.226-5.442,1.428-.011,0-.011,0-4.933-2.092-1.4-.6-.368-.161-.094-.043a.149.149,0,0,1-.032-.016.158.158,0,0,1,.034.011l.1.038.373.151,1.4.581,4.943,2.067h-.021l5.44-1.436.858-.225-.014.064-6.433-5.217-.009-.007v-.012",
    fill: "#e0e0e0"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9872",
    "data-name": "Group 9872"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9871",
    "data-name": "Group 9871"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9870",
    "data-name": "Group 9870"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9869",
    "data-name": "Group 9869"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9868",
    "data-name": "Group 9868"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9867",
    "data-name": "Group 9867"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9866",
    "data-name": "Group 9866"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9865",
    "data-name": "Group 9865"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9864",
    "data-name": "Group 9864"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9863",
    "data-name": "Group 9863"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6218",
    "data-name": "Path 6218",
    d: "M95.012,133.82l.352.331.472-.1-.206.436.243.417-.479-.061-.322.36-.09-.474-.442-.195.423-.232Z",
    fill: "#e0e0e0"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9882",
    "data-name": "Group 9882"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9881",
    "data-name": "Group 9881"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9880",
    "data-name": "Group 9880"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9879",
    "data-name": "Group 9879"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9878",
    "data-name": "Group 9878"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9877",
    "data-name": "Group 9877"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9876",
    "data-name": "Group 9876"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9875",
    "data-name": "Group 9875"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9874",
    "data-name": "Group 9874"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9873",
    "data-name": "Group 9873"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6219",
    "data-name": "Path 6219",
    d: "M88.829,135.87l.24.2.3-.085-.116.29.173.26-.312-.02-.194.245-.077-.3-.293-.108.264-.167Z",
    fill: "#e0e0e0"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9892",
    "data-name": "Group 9892"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9891",
    "data-name": "Group 9891"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9890",
    "data-name": "Group 9890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9889",
    "data-name": "Group 9889"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9888",
    "data-name": "Group 9888"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9887",
    "data-name": "Group 9887"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9886",
    "data-name": "Group 9886"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9885",
    "data-name": "Group 9885"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9884",
    "data-name": "Group 9884"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9883",
    "data-name": "Group 9883"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6220",
    "data-name": "Path 6220",
    d: "M82,133.067l.383.024.237-.3.1.371.36.132-.324.206-.014.383-.3-.244-.369.1.141-.356Z",
    fill: "#e0e0e0"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9902",
    "data-name": "Group 9902"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9901",
    "data-name": "Group 9901"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9900",
    "data-name": "Group 9900"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9899",
    "data-name": "Group 9899"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9898",
    "data-name": "Group 9898"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9897",
    "data-name": "Group 9897"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9896",
    "data-name": "Group 9896"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9895",
    "data-name": "Group 9895"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9894",
    "data-name": "Group 9894"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9893",
    "data-name": "Group 9893"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6221",
    "data-name": "Path 6221",
    d: "M97.9,129.53l.383.024.237-.3.1.371.36.132-.324.205-.014.383-.3-.244-.369.1.141-.356Z",
    fill: "#e0e0e0"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9912",
    "data-name": "Group 9912"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9911",
    "data-name": "Group 9911"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9910",
    "data-name": "Group 9910"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9909",
    "data-name": "Group 9909"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9908",
    "data-name": "Group 9908"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9907",
    "data-name": "Group 9907"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9906",
    "data-name": "Group 9906"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9905",
    "data-name": "Group 9905"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9904",
    "data-name": "Group 9904"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9903",
    "data-name": "Group 9903"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6222",
    "data-name": "Path 6222",
    d: "M88.846,129.279l.244.015.151-.192.061.237.23.084-.206.131-.009.245-.188-.156-.235.067.09-.228Z",
    fill: "#e0e0e0"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9919",
    "data-name": "Group 9919"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9918",
    "data-name": "Group 9918"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9917",
    "data-name": "Group 9917"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9916",
    "data-name": "Group 9916"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9915",
    "data-name": "Group 9915"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9914",
    "data-name": "Group 9914"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9913",
    "data-name": "Group 9913"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6223",
    "data-name": "Path 6223",
    d: "M98.439,129.8c0,.024-2.086-.045-4.657-.155s-4.654-.219-4.653-.244,2.086.044,4.657.154S98.44,129.774,98.439,129.8Z",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9962",
    "data-name": "Group 9962"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9927",
    "data-name": "Group 9927"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9926",
    "data-name": "Group 9926"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9925",
    "data-name": "Group 9925"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9924",
    "data-name": "Group 9924"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9923",
    "data-name": "Group 9923"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9922",
    "data-name": "Group 9922"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6224",
    "data-name": "Path 6224",
    d: "M100.782,127.649H38.924c-.81-1.838-1.009-3.585,0-5.149h61.858A5.968,5.968,0,0,1,100.782,127.649Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9933",
    "data-name": "Group 9933"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9932",
    "data-name": "Group 9932"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9931",
    "data-name": "Group 9931"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9930",
    "data-name": "Group 9930"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9929",
    "data-name": "Group 9929"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9928",
    "data-name": "Group 9928"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_462",
    "data-name": "Rectangle 462",
    width: 33.513,
    height: 1.874,
    transform: "translate(51.733 123.971)",
    fill: "#ebebeb"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9940",
    "data-name": "Group 9940"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9939",
    "data-name": "Group 9939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9938",
    "data-name": "Group 9938"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9937",
    "data-name": "Group 9937"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9936",
    "data-name": "Group 9936"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9935",
    "data-name": "Group 9935"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9934",
    "data-name": "Group 9934"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6225",
    "data-name": "Path 6225",
    d: "M41.3,127.677a1.816,1.816,0,0,1-.488-.623,4.543,4.543,0,0,1-.328-3.725,1.818,1.818,0,0,1,.372-.7,5.791,5.791,0,0,1-.22.746,5.2,5.2,0,0,0,.317,3.605A5.878,5.878,0,0,1,41.3,127.677Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9947",
    "data-name": "Group 9947"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9946",
    "data-name": "Group 9946"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9945",
    "data-name": "Group 9945"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9944",
    "data-name": "Group 9944"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9943",
    "data-name": "Group 9943"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9942",
    "data-name": "Group 9942"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9941",
    "data-name": "Group 9941"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6226",
    "data-name": "Path 6226",
    d: "M42.637,127.677a1.8,1.8,0,0,1-.489-.623,4.538,4.538,0,0,1-.327-3.725,1.818,1.818,0,0,1,.372-.7,5.919,5.919,0,0,1-.221.746,5.218,5.218,0,0,0,.317,3.605A6,6,0,0,1,42.637,127.677Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9954",
    "data-name": "Group 9954"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9953",
    "data-name": "Group 9953"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9952",
    "data-name": "Group 9952"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9951",
    "data-name": "Group 9951"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9950",
    "data-name": "Group 9950"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9949",
    "data-name": "Group 9949"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9948",
    "data-name": "Group 9948"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6227",
    "data-name": "Path 6227",
    d: "M98.279,127.556a7.758,7.758,0,0,0,.029-5.039,5.24,5.24,0,0,1-.029,5.039Z",
    fill: "#f5f5f5"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9961",
    "data-name": "Group 9961"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9960",
    "data-name": "Group 9960"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9959",
    "data-name": "Group 9959"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9958",
    "data-name": "Group 9958"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9957",
    "data-name": "Group 9957"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9956",
    "data-name": "Group 9956"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9955",
    "data-name": "Group 9955"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6228",
    "data-name": "Path 6228",
    d: "M97.128,127.544c-.068-.015.193-1.1.185-2.465s-.259-2.45-.192-2.465a7.554,7.554,0,0,1,.007,4.93Z",
    fill: "#f5f5f5"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10010",
    "data-name": "Group 10010"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9986",
    "data-name": "Group 9986"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9970",
    "data-name": "Group 9970"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9969",
    "data-name": "Group 9969"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9968",
    "data-name": "Group 9968"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9967",
    "data-name": "Group 9967"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9966",
    "data-name": "Group 9966"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9965",
    "data-name": "Group 9965"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9964",
    "data-name": "Group 9964"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_463",
    "data-name": "Rectangle 463",
    width: 22.026,
    height: 23.365,
    transform: "translate(129.914 51.068) rotate(-0.306)",
    fill: "#ebebeb"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9977",
    "data-name": "Group 9977"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9976",
    "data-name": "Group 9976"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9975",
    "data-name": "Group 9975"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9974",
    "data-name": "Group 9974"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9973",
    "data-name": "Group 9973"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9972",
    "data-name": "Group 9972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9971",
    "data-name": "Group 9971"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_464",
    "data-name": "Rectangle 464",
    width: 22.026,
    height: 23.365,
    transform: "translate(151.835 50.951) rotate(-0.307)",
    fill: "#f5f5f5"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9985",
    "data-name": "Group 9985"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9984",
    "data-name": "Group 9984"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9983",
    "data-name": "Group 9983"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9982",
    "data-name": "Group 9982"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9981",
    "data-name": "Group 9981"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9980",
    "data-name": "Group 9980"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9979",
    "data-name": "Group 9979"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9978",
    "data-name": "Group 9978"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6229",
    "data-name": "Path 6229",
    d: "M129.949,57.521c14.637.121,29.311.035,43.946-.2a.234.234,0,0,0,0-.468q-21.957-.122-43.946.268a.2.2,0,0,0,0,.4Z",
    fill: "#e0e0e0"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10009",
    "data-name": "Group 10009"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9993",
    "data-name": "Group 9993"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9992",
    "data-name": "Group 9992"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9991",
    "data-name": "Group 9991"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9990",
    "data-name": "Group 9990"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9989",
    "data-name": "Group 9989"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9988",
    "data-name": "Group 9988"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9987",
    "data-name": "Group 9987"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_465",
    "data-name": "Rectangle 465",
    width: 40.017,
    height: 19.041,
    transform: "translate(116.182 74.139) rotate(-0.307)",
    fill: "#ebebeb"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10000",
    "data-name": "Group 10000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9999",
    "data-name": "Group 9999"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9998",
    "data-name": "Group 9998"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9997",
    "data-name": "Group 9997"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9996",
    "data-name": "Group 9996"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9995",
    "data-name": "Group 9995"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9994",
    "data-name": "Group 9994"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_466",
    "data-name": "Rectangle 466",
    width: 40.017,
    height: 19.04,
    transform: "translate(156.009 73.926) rotate(-0.307)",
    fill: "#f5f5f5"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10008",
    "data-name": "Group 10008"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10007",
    "data-name": "Group 10007"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10006",
    "data-name": "Group 10006"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10005",
    "data-name": "Group 10005"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10004",
    "data-name": "Group 10004"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10003",
    "data-name": "Group 10003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10002",
    "data-name": "Group 10002"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10001",
    "data-name": "Group 10001"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6230",
    "data-name": "Path 6230",
    d: "M116.21,79.435c26.584.3,53.261.031,79.844-.395a.234.234,0,0,0,0-.468c-26.586-.14-53.265-.124-79.844.461a.2.2,0,0,0,0,.4Z",
    fill: "#e0e0e0"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10034",
    "data-name": "Group 10034"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10033",
    "data-name": "Group 10033"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10017",
    "data-name": "Group 10017"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10016",
    "data-name": "Group 10016"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10015",
    "data-name": "Group 10015"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10014",
    "data-name": "Group 10014"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10013",
    "data-name": "Group 10013"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10012",
    "data-name": "Group 10012"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10011",
    "data-name": "Group 10011"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_467",
    "data-name": "Rectangle 467",
    width: 40.017,
    height: 19.041,
    transform: "translate(80.061 181.908) rotate(-0.307)",
    fill: "#ebebeb"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10024",
    "data-name": "Group 10024"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10023",
    "data-name": "Group 10023"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10022",
    "data-name": "Group 10022"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10021",
    "data-name": "Group 10021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10020",
    "data-name": "Group 10020"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10019",
    "data-name": "Group 10019"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10018",
    "data-name": "Group 10018"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_468",
    "data-name": "Rectangle 468",
    width: 40.017,
    height: 19.04,
    transform: "translate(119.888 181.695) rotate(-0.307)",
    fill: "#f5f5f5"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10032",
    "data-name": "Group 10032"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10031",
    "data-name": "Group 10031"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10030",
    "data-name": "Group 10030"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10029",
    "data-name": "Group 10029"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10028",
    "data-name": "Group 10028"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10027",
    "data-name": "Group 10027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10026",
    "data-name": "Group 10026"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10025",
    "data-name": "Group 10025"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6231",
    "data-name": "Path 6231",
    d: "M80.089,187.2c26.584.3,53.261.031,79.844-.394a.234.234,0,0,0,0-.468c-26.586-.141-53.265-.125-79.844.461a.2.2,0,0,0,0,.4Z",
    fill: "#e0e0e0"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10111",
    "data-name": "Group 10111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10041",
    "data-name": "Group 10041"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10040",
    "data-name": "Group 10040"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10039",
    "data-name": "Group 10039"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10038",
    "data-name": "Group 10038"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10037",
    "data-name": "Group 10037"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10036",
    "data-name": "Group 10036"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10035",
    "data-name": "Group 10035"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_469",
    "data-name": "Rectangle 469",
    width: 10.094,
    height: 50.23,
    transform: "translate(56.271 43.055) rotate(-0.307)",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10048",
    "data-name": "Group 10048"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10047",
    "data-name": "Group 10047"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10046",
    "data-name": "Group 10046"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10045",
    "data-name": "Group 10045"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10044",
    "data-name": "Group 10044"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10043",
    "data-name": "Group 10043"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10042",
    "data-name": "Group 10042"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_470",
    "data-name": "Rectangle 470",
    width: 10.095,
    height: 69.083,
    transform: "translate(66.122 24.325) rotate(-0.307)",
    fill: "#ebebeb"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10091",
    "data-name": "Group 10091"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10055",
    "data-name": "Group 10055"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10054",
    "data-name": "Group 10054"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10053",
    "data-name": "Group 10053"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10052",
    "data-name": "Group 10052"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10051",
    "data-name": "Group 10051"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10050",
    "data-name": "Group 10050"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10049",
    "data-name": "Group 10049"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_471",
    "data-name": "Rectangle 471",
    width: 15.685,
    height: 55.984,
    transform: "matrix(1, -0.005, 0.005, 1, 76.303, 37.214)",
    fill: "#f5f5f5"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10062",
    "data-name": "Group 10062"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10061",
    "data-name": "Group 10061"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10060",
    "data-name": "Group 10060"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10059",
    "data-name": "Group 10059"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10058",
    "data-name": "Group 10058"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10057",
    "data-name": "Group 10057"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10056",
    "data-name": "Group 10056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6232",
    "data-name": "Path 6232",
    d: "M91.883,47.916a56.8,56.8,0,0,1-7.842.272,56.812,56.812,0,0,1-7.843-.272,56.812,56.812,0,0,1,7.843-.272A56.8,56.8,0,0,1,91.883,47.916Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10069",
    "data-name": "Group 10069"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10068",
    "data-name": "Group 10068"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10067",
    "data-name": "Group 10067"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10066",
    "data-name": "Group 10066"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10065",
    "data-name": "Group 10065"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10064",
    "data-name": "Group 10064"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10063",
    "data-name": "Group 10063"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6233",
    "data-name": "Path 6233",
    d: "M91.883,45.564a56.8,56.8,0,0,1-7.842.272,56.812,56.812,0,0,1-7.843-.272,56.812,56.812,0,0,1,7.843-.272A56.8,56.8,0,0,1,91.883,45.564Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10076",
    "data-name": "Group 10076"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10075",
    "data-name": "Group 10075"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10074",
    "data-name": "Group 10074"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10073",
    "data-name": "Group 10073"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10072",
    "data-name": "Group 10072"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10071",
    "data-name": "Group 10071"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10070",
    "data-name": "Group 10070"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6234",
    "data-name": "Path 6234",
    d: "M91.883,84.691a56.906,56.906,0,0,1-7.842.271,56.915,56.915,0,0,1-7.843-.271,56.811,56.811,0,0,1,7.843-.272A56.8,56.8,0,0,1,91.883,84.691Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10083",
    "data-name": "Group 10083"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10082",
    "data-name": "Group 10082"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10081",
    "data-name": "Group 10081"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10080",
    "data-name": "Group 10080"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10079",
    "data-name": "Group 10079"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10078",
    "data-name": "Group 10078"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10077",
    "data-name": "Group 10077"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6235",
    "data-name": "Path 6235",
    d: "M91.883,82.339a56.905,56.905,0,0,1-7.842.271,56.914,56.914,0,0,1-7.843-.271,56.813,56.813,0,0,1,7.843-.272A56.8,56.8,0,0,1,91.883,82.339Z",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10090",
    "data-name": "Group 10090"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10089",
    "data-name": "Group 10089"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10088",
    "data-name": "Group 10088"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10087",
    "data-name": "Group 10087"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10086",
    "data-name": "Group 10086"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10085",
    "data-name": "Group 10085"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10084",
    "data-name": "Group 10084"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6236",
    "data-name": "Path 6236",
    d: "M84.293,77.207c-.15,0-.272-5.648-.272-12.614s.122-12.615.272-12.615.272,5.647.272,12.615S84.443,77.207,84.293,77.207Z",
    fill: "#e0e0e0"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10098",
    "data-name": "Group 10098"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10097",
    "data-name": "Group 10097"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10096",
    "data-name": "Group 10096"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10095",
    "data-name": "Group 10095"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10094",
    "data-name": "Group 10094"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10093",
    "data-name": "Group 10093"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10092",
    "data-name": "Group 10092"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_472",
    "data-name": "Rectangle 472",
    width: 17.073,
    height: 42.257,
    transform: "translate(92.053 50.878)",
    fill: "#ebebeb"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10104",
    "data-name": "Group 10104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10103",
    "data-name": "Group 10103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10102",
    "data-name": "Group 10102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10101",
    "data-name": "Group 10101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10100",
    "data-name": "Group 10100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10099",
    "data-name": "Group 10099"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6237",
    "data-name": "Path 6237",
    d: "M73.922,36.065a2.9,2.9,0,1,1-2.9-2.9A2.9,2.9,0,0,1,73.922,36.065Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10110",
    "data-name": "Group 10110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10109",
    "data-name": "Group 10109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10108",
    "data-name": "Group 10108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10107",
    "data-name": "Group 10107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10106",
    "data-name": "Group 10106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10105",
    "data-name": "Group 10105"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_473",
    "data-name": "Rectangle 473",
    width: 1.793,
    height: 41.096,
    transform: "translate(70.124 44.045)",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10122",
    "data-name": "Group 10122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10113",
    "data-name": "Group 10113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10112",
    "data-name": "Group 10112"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_474",
    "data-name": "Rectangle 474",
    width: 177.722,
    height: 6.077,
    transform: "translate(28.147 151.077)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10115",
    "data-name": "Group 10115"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10114",
    "data-name": "Group 10114"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_475",
    "data-name": "Rectangle 475",
    width: 177.722,
    height: 6.077,
    transform: "translate(28.147 93.407)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10117",
    "data-name": "Group 10117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10116",
    "data-name": "Group 10116"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_476",
    "data-name": "Rectangle 476",
    width: 141.451,
    height: 5.736,
    transform: "translate(64.418 200.98)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10119",
    "data-name": "Group 10119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10118",
    "data-name": "Group 10118"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_477",
    "data-name": "Rectangle 477",
    width: 6.778,
    height: 57.367,
    transform: "translate(110.23 98.296)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10121",
    "data-name": "Group 10121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10120",
    "data-name": "Group 10120"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_478",
    "data-name": "Rectangle 478",
    width: 6.778,
    height: 55.618,
    transform: "translate(64.456 151.077)",
    fill: "#e0e0e0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10125",
    "data-name": "Group 10125"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10124",
    "data-name": "Group 10124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10123",
    "data-name": "Group 10123"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6238",
    "data-name": "Path 6238",
    d: "M150.94,125l-4.167,5.988s9.374,2.6,9.374,10.936-5.728,9.9-11.977,9.9-12.238-1.823-11.978-10.155,8.072-11.457,8.072-11.457L136.358,125Z",
    fill: "#f5f5f5"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10141",
    "data-name": "Group 10141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10128",
    "data-name": "Group 10128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10127",
    "data-name": "Group 10127"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_479",
    "data-name": "Rectangle 479",
    width: 7.027,
    height: 151.077,
    transform: "translate(702.153 49.006)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10130",
    "data-name": "Group 10130"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10129",
    "data-name": "Group 10129"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_480",
    "data-name": "Rectangle 480",
    width: 100.861,
    height: 150.119,
    rx: 0.101,
    transform: "translate(600.224 50.175)",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10133",
    "data-name": "Group 10133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10132",
    "data-name": "Group 10132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10131",
    "data-name": "Group 10131"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6239",
    "data-name": "Path 6239",
    d: "M702.153,201.462h-103a.1.1,0,0,1-.1-.1V49.108a.1.1,0,0,1,.1-.1h103a.1.1,0,0,1,.1.1V201.361A.1.1,0,0,1,702.153,201.462Zm-100.659-2.337h98.321a.1.1,0,0,0,.1-.1V51.445a.1.1,0,0,0-.1-.1H601.494a.1.1,0,0,0-.1.1V199.024A.1.1,0,0,0,601.494,199.125Z",
    fill: "#ebebeb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10135",
    "data-name": "Group 10135"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10134",
    "data-name": "Group 10134"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_481",
    "data-name": "Rectangle 481",
    width: 80.728,
    height: 131.497,
    rx: 0.101,
    transform: "translate(610.38 59.436)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10137",
    "data-name": "Group 10137"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10136",
    "data-name": "Group 10136"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_482",
    "data-name": "Rectangle 482",
    width: 45.328,
    height: 53.128,
    rx: 0.064,
    transform: "translate(627.991 96.715)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10140",
    "data-name": "Group 10140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10139",
    "data-name": "Group 10139"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10138",
    "data-name": "Group 10138"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6240",
    "data-name": "Path 6240",
    d: "M669.731,143.34c.058.171-2.179,1.151-6.436.652a15.718,15.718,0,0,1-7.234-2.891,14.683,14.683,0,0,1-5.621-8.841,12.708,12.708,0,0,1,4.3-12.085,11.266,11.266,0,0,1,3.26-1.91,8.681,8.681,0,0,1,4.078-.47,7.174,7.174,0,0,1,4.076,1.78,5.322,5.322,0,0,1,1.608,4.75,7.759,7.759,0,0,1-2.238,4.077,14.742,14.742,0,0,1-3.415,2.515,18.708,18.708,0,0,1-8.146,2.327,16.2,16.2,0,0,1-8.681-1.976,15.78,15.78,0,0,1-6.389-6.623,13.489,13.489,0,0,1-1.146-9.274,13.782,13.782,0,0,1,4.888-7.642,12.072,12.072,0,0,1,4.1-2.069,10.188,10.188,0,0,1,4.614-.143,7.528,7.528,0,0,1,4.188,2.362,6.951,6.951,0,0,1,1.641,4.475,8.538,8.538,0,0,1-1.092,4.263,11.424,11.424,0,0,1-2.585,3.107,17.4,17.4,0,0,1-6.421,3.412,16.465,16.465,0,0,1-6.756.521,13.82,13.82,0,0,1-5.879-2.252,12.728,12.728,0,0,1-5.615-8.894,10.736,10.736,0,0,1,2.08-7.626,9.11,9.11,0,0,1,3.849-3.074c1.058-.4,1.662-.387,1.688-.286.044.144-.479.377-1.338.95a10.032,10.032,0,0,0-2.992,3.217,9.5,9.5,0,0,0-1.226,6.513,10.666,10.666,0,0,0,4.993,6.992,12.3,12.3,0,0,0,10.3.981,14.471,14.471,0,0,0,5.154-2.916,6.332,6.332,0,0,0,2.407-4.829,3.472,3.472,0,0,0-3.1-3.428,6.69,6.69,0,0,0-2.963.14,8.542,8.542,0,0,0-2.8,1.465,10.2,10.2,0,0,0-3.526,5.619,9.813,9.813,0,0,0,.866,6.735,12.178,12.178,0,0,0,4.877,5.07,12.632,12.632,0,0,0,6.71,1.561,15.271,15.271,0,0,0,6.6-1.8,11.391,11.391,0,0,0,2.634-1.856,4.443,4.443,0,0,0,1.336-2.177,1.9,1.9,0,0,0-.54-1.752,3.954,3.954,0,0,0-2.183-.962,5.507,5.507,0,0,0-2.569.219,8.247,8.247,0,0,0-2.395,1.312,9.964,9.964,0,0,0-3.649,9.242,12.733,12.733,0,0,0,4.319,7.651,15.236,15.236,0,0,0,6.209,3.1C667.4,143.458,669.7,143.017,669.731,143.34Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10173",
    "data-name": "Group 10173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10172",
    "data-name": "Group 10172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10147",
    "data-name": "Group 10147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10146",
    "data-name": "Group 10146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10145",
    "data-name": "Group 10145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10144",
    "data-name": "Group 10144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10143",
    "data-name": "Group 10143"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10142",
    "data-name": "Group 10142"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6241",
    "data-name": "Path 6241",
    d: "M192.433,454.35v24.683h75.908V454.35Z",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10153",
    "data-name": "Group 10153"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10152",
    "data-name": "Group 10152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10151",
    "data-name": "Group 10151"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10150",
    "data-name": "Group 10150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10149",
    "data-name": "Group 10149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10148",
    "data-name": "Group 10148"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6242",
    "data-name": "Path 6242",
    d: "M189.249,447.449v6.9H271v-6.9H189.249Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10159",
    "data-name": "Group 10159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10158",
    "data-name": "Group 10158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10157",
    "data-name": "Group 10157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10156",
    "data-name": "Group 10156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10155",
    "data-name": "Group 10155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10154",
    "data-name": "Group 10154"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6243",
    "data-name": "Path 6243",
    d: "M230.122,479.033h38.219V454.35H271v-6.9H228.529v6.262Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10165",
    "data-name": "Group 10165"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10164",
    "data-name": "Group 10164"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10163",
    "data-name": "Group 10163"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10162",
    "data-name": "Group 10162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10161",
    "data-name": "Group 10161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10160",
    "data-name": "Group 10160"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_483",
    "data-name": "Rectangle 483",
    width: 15.394,
    height: 3.716,
    transform: "translate(203.05 458.33)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10171",
    "data-name": "Group 10171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10170",
    "data-name": "Group 10170"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10169",
    "data-name": "Group 10169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10168",
    "data-name": "Group 10168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10167",
    "data-name": "Group 10167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10166",
    "data-name": "Group 10166"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_484",
    "data-name": "Rectangle 484",
    width: 19.767,
    height: 7.846,
    transform: "translate(201.069 466.691)",
    fill: "#fff"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10205",
    "data-name": "Group 10205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10204",
    "data-name": "Group 10204"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10179",
    "data-name": "Group 10179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10178",
    "data-name": "Group 10178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10177",
    "data-name": "Group 10177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10176",
    "data-name": "Group 10176"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10175",
    "data-name": "Group 10175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10174",
    "data-name": "Group 10174"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6244",
    "data-name": "Path 6244",
    d: "M210.1,422.8v24.683h75.908V422.8Z",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10185",
    "data-name": "Group 10185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10184",
    "data-name": "Group 10184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10183",
    "data-name": "Group 10183"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10182",
    "data-name": "Group 10182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10181",
    "data-name": "Group 10181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10180",
    "data-name": "Group 10180"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6245",
    "data-name": "Path 6245",
    d: "M206.913,415.9v6.9H288.66v-6.9H206.913Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10191",
    "data-name": "Group 10191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10190",
    "data-name": "Group 10190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10189",
    "data-name": "Group 10189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10188",
    "data-name": "Group 10188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10187",
    "data-name": "Group 10187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10186",
    "data-name": "Group 10186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6246",
    "data-name": "Path 6246",
    d: "M247.786,447.482h38.219V422.8h2.654v-6.9H246.194v6.262Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10197",
    "data-name": "Group 10197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10196",
    "data-name": "Group 10196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10195",
    "data-name": "Group 10195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10194",
    "data-name": "Group 10194"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10193",
    "data-name": "Group 10193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10192",
    "data-name": "Group 10192"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_485",
    "data-name": "Rectangle 485",
    width: 15.394,
    height: 3.716,
    transform: "translate(220.714 426.779)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10203",
    "data-name": "Group 10203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10202",
    "data-name": "Group 10202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10201",
    "data-name": "Group 10201"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10200",
    "data-name": "Group 10200"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10199",
    "data-name": "Group 10199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10198",
    "data-name": "Group 10198"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_486",
    "data-name": "Rectangle 486",
    width: 19.767,
    height: 7.846,
    transform: "translate(218.733 435.139)",
    fill: "#fff"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10237",
    "data-name": "Group 10237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10236",
    "data-name": "Group 10236"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10211",
    "data-name": "Group 10211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10210",
    "data-name": "Group 10210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10209",
    "data-name": "Group 10209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10208",
    "data-name": "Group 10208"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10207",
    "data-name": "Group 10207"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10206",
    "data-name": "Group 10206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6247",
    "data-name": "Path 6247",
    d: "M55.364,453.456v24.683h75.908V453.456Z",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10217",
    "data-name": "Group 10217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10216",
    "data-name": "Group 10216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10215",
    "data-name": "Group 10215"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10214",
    "data-name": "Group 10214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10213",
    "data-name": "Group 10213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10212",
    "data-name": "Group 10212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6248",
    "data-name": "Path 6248",
    d: "M52.179,446.555v6.9h81.747v-6.9H52.179Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10223",
    "data-name": "Group 10223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10222",
    "data-name": "Group 10222"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10221",
    "data-name": "Group 10221"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10220",
    "data-name": "Group 10220"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10219",
    "data-name": "Group 10219"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10218",
    "data-name": "Group 10218"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6249",
    "data-name": "Path 6249",
    d: "M93.052,478.139h38.219V453.456h2.654v-6.9H91.46v6.262Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10229",
    "data-name": "Group 10229"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10228",
    "data-name": "Group 10228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10227",
    "data-name": "Group 10227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10226",
    "data-name": "Group 10226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10225",
    "data-name": "Group 10225"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10224",
    "data-name": "Group 10224"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_487",
    "data-name": "Rectangle 487",
    width: 15.394,
    height: 3.716,
    transform: "translate(65.98 457.437)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10235",
    "data-name": "Group 10235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10234",
    "data-name": "Group 10234"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10233",
    "data-name": "Group 10233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10232",
    "data-name": "Group 10232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10231",
    "data-name": "Group 10231"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10230",
    "data-name": "Group 10230"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_488",
    "data-name": "Rectangle 488",
    width: 19.767,
    height: 7.846,
    transform: "translate(63.999 465.797)",
    fill: "#fff"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10239",
    "data-name": "Group 10239"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10238",
    "data-name": "Group 10238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6250",
    "data-name": "Path 6250",
    d: "M677.661,478.226c0,.144-133.278.261-297.647.261-164.426,0-297.675-.117-297.675-.261s133.249-.26,297.675-.26C544.383,477.966,677.661,478.083,677.661,478.226Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10318",
    "data-name": "Group 10318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10273",
    "data-name": "Group 10273"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10272",
    "data-name": "Group 10272"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10271",
    "data-name": "Group 10271"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10270",
    "data-name": "Group 10270"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10269",
    "data-name": "Group 10269"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10268",
    "data-name": "Group 10268"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10267",
    "data-name": "Group 10267"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10248",
    "data-name": "Group 10248"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10247",
    "data-name": "Group 10247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10246",
    "data-name": "Group 10246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10245",
    "data-name": "Group 10245"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10244",
    "data-name": "Group 10244"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10243",
    "data-name": "Group 10243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10240",
    "data-name": "Group 10240"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6251",
    "data-name": "Path 6251",
    d: "M619.546,78.275l-.161,305.815A17.122,17.122,0,0,1,602.254,401.2l-453.772-.239a17.122,17.122,0,0,1-17.113-17.131l.161-305.816A17.124,17.124,0,0,1,148.662,60.9l453.77.239A17.123,17.123,0,0,1,619.546,78.275Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10242",
    "data-name": "Group 10242"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10241",
    "data-name": "Group 10241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6252",
    "data-name": "Path 6252",
    d: "M619.546,78.275s-.026-.355-.066-1.056a8.644,8.644,0,0,0-.134-1.3,12.976,12.976,0,0,0-.352-1.788A16.254,16.254,0,0,0,617,69.39a17.411,17.411,0,0,0-4.859-5.15,16.883,16.883,0,0,0-3.8-1.962,16.385,16.385,0,0,0-4.635-1.005l-1.262-.063h-1.3l-2.683,0-5.712,0-27.352.01-174.314-.009-120.372-.032-67.059-.022-35.069-.013-17.9-.007a28.8,28.8,0,0,0-4.466.194,16.811,16.811,0,0,0-4.282,1.2,16.988,16.988,0,0,0-6.91,5.545,19.433,19.433,0,0,0-1.219,1.889,18.876,18.876,0,0,0-.923,2.053,17.006,17.006,0,0,0-1.036,4.382c-.109,1.5-.079,3.038-.083,4.571l0,4.61q0,9.234-.008,18.577-.008,18.686-.015,37.789-.018,38.2-.035,77.941c-.026,52.942-.054,107.757-.081,163.9a18.794,18.794,0,0,0,.773,5.105,17.828,17.828,0,0,0,2.29,4.616,16.549,16.549,0,0,0,3.565,3.707,15.784,15.784,0,0,0,4.5,2.462c3.231,1.3,6.77.971,10.239,1.023l10.417.005,41.313.023,80.771.047,152.693.1,138.169.1,16.088.012,7.937.007a32.7,32.7,0,0,0,3.911-.133,16.416,16.416,0,0,0,3.757-.9,16.968,16.968,0,0,0,10.289-10.64c.2-.6.327-1.221.491-1.829.086-.625.212-1.245.266-1.871.09-1.251.084-2.524.08-3.793q0-3.8.006-7.57.025-30.129.047-57.761c.074-73.592.134-133.145.175-174.3.032-20.575.057-36.552.074-47.389.014-5.415.025-9.544.032-12.324s.029-4.2.029-4.2.017,1.423.025,4.2.011,6.909.019,12.324c0,10.837.013,26.814.024,47.389,0,41.158-.005,100.711-.009,174.3q-.008,27.6-.014,57.76,0,3.766,0,7.57c0,1.267.012,2.536-.08,3.829-.055.642-.183,1.277-.271,1.916-.167.624-.3,1.259-.5,1.875a17.378,17.378,0,0,1-10.535,10.9,16.786,16.786,0,0,1-3.85.929,33.076,33.076,0,0,1-3.961.138l-7.938,0-16.087-.005L438.2,401.356,285.5,401.291l-80.771-.039-41.314-.021-10.416,0c-1.743-.017-3.469.034-5.23-.038a17.292,17.292,0,0,1-9.83-3.554,17.088,17.088,0,0,1-3.675-3.821,18.35,18.35,0,0,1-2.359-4.759,19.287,19.287,0,0,1-.8-5.262c.031-56.142.062-110.957.092-163.9q.024-39.708.047-77.941.012-19.1.024-37.789.006-9.342.012-18.577l0-4.61c.005-1.535-.026-3.059.087-4.617a17.533,17.533,0,0,1,1.066-4.507,15.413,15.413,0,0,1,2.205-4.054,17.144,17.144,0,0,1,11.511-6.933,29.3,29.3,0,0,1,4.535-.2l17.9.012,35.069.025,67.059.048,120.373.1,174.313.175,27.352.038,5.712.01,2.683,0,1.3,0,1.272.066a16.516,16.516,0,0,1,4.666,1.025,16.977,16.977,0,0,1,3.818,1.986,17.459,17.459,0,0,1,4.866,5.195,16.184,16.184,0,0,1,1.978,4.765,12.781,12.781,0,0,1,.341,1.8,8.465,8.465,0,0,1,.121,1.307C619.538,77.92,619.546,78.275,619.546,78.275Z",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10254",
    "data-name": "Group 10254"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10253",
    "data-name": "Group 10253"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10252",
    "data-name": "Group 10252"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10251",
    "data-name": "Group 10251"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10250",
    "data-name": "Group 10250"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10249",
    "data-name": "Group 10249"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_489",
    "data-name": "Rectangle 489",
    width: 318.614,
    height: 407.552,
    transform: "translate(165.094 390.885) rotate(-89.97)",
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10260",
    "data-name": "Group 10260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10259",
    "data-name": "Group 10259"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10258",
    "data-name": "Group 10258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10257",
    "data-name": "Group 10257"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10256",
    "data-name": "Group 10256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10255",
    "data-name": "Group 10255"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6253",
    "data-name": "Path 6253",
    d: "M594.949,218.121a13.048,13.048,0,1,1-13.055,13.041A13.048,13.048,0,0,1,594.949,218.121Z",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10266",
    "data-name": "Group 10266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10265",
    "data-name": "Group 10265"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10264",
    "data-name": "Group 10264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10263",
    "data-name": "Group 10263"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10262",
    "data-name": "Group 10262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10261",
    "data-name": "Group 10261"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_490",
    "data-name": "Rectangle 490",
    width: 102.422,
    height: 5.391,
    rx: 1.215,
    transform: "matrix(0.001, -1, 1, 0.001, 145.478, 282.143)",
    fill: "#263238"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10274",
    "data-name": "Group 10274"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_491",
    "data-name": "Rectangle 491",
    width: 159.366,
    height: 26.403,
    rx: 5.43,
    transform: "translate(196.3 342.766)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10275",
    "data-name": "Group 10275"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_492",
    "data-name": "Rectangle 492",
    width: 159.366,
    height: 26.403,
    rx: 5.43,
    transform: "translate(194.941 286.219)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10276",
    "data-name": "Group 10276"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_493",
    "data-name": "Rectangle 493",
    width: 159.366,
    height: 26.403,
    rx: 5.43,
    transform: "translate(366.206 286.219)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10277",
    "data-name": "Group 10277"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_494",
    "data-name": "Rectangle 494",
    width: 153.438,
    height: 26.403,
    rx: 5.43,
    transform: "translate(370.467 125.539)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10278",
    "data-name": "Group 10278"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_495",
    "data-name": "Rectangle 495",
    width: 331.227,
    height: 26.403,
    rx: 5.43,
    transform: "translate(196.3 177.969)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10279",
    "data-name": "Group 10279"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_496",
    "data-name": "Rectangle 496",
    width: 159.366,
    height: 26.403,
    rx: 5.43,
    transform: "translate(196.057 125.539)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10280",
    "data-name": "Group 10280"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6254",
    "data-name": "Path 6254",
    d: "M207.108,139.372v1.8h-.736v-1.813l-2.066-3.388h.8l1.664,2.742,1.672-2.742h.735Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6255",
    "data-name": "Path 6255",
    d: "M209.012,139.2a2.048,2.048,0,1,1,2.051,2.014A1.959,1.959,0,0,1,209.012,139.2Zm3.373,0a1.327,1.327,0,1,0-1.322,1.39A1.291,1.291,0,0,0,212.385,139.2Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6256",
    "data-name": "Path 6256",
    d: "M217.768,137.232v3.938h-.677v-.594a1.6,1.6,0,0,1-1.337.639,1.547,1.547,0,0,1-1.694-1.717v-2.266h.713v2.184c0,.773.386,1.16,1.063,1.16a1.159,1.159,0,0,0,1.218-1.308v-2.036Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6257",
    "data-name": "Path 6257",
    d: "M221.248,137.2v.691a1.263,1.263,0,0,0-1.4,1.322v1.962h-.713v-3.938h.684v.661A1.5,1.5,0,0,1,221.248,137.2Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6258",
    "data-name": "Path 6258",
    d: "M228.755,135.969v5.2h-.609l-3.121-3.879v3.879h-.743v-5.2h.609l3.121,3.878v-3.878Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6259",
    "data-name": "Path 6259",
    d: "M233.336,138.792v2.378h-.677v-.52a1.461,1.461,0,0,1-1.293.565c-.891,0-1.456-.476-1.456-1.159,0-.632.408-1.152,1.583-1.152h1.129v-.141c0-.6-.349-.952-1.055-.952a2,2,0,0,0-1.249.424l-.3-.535a2.624,2.624,0,0,1,1.628-.5C232.726,137.2,233.336,137.715,233.336,138.792Zm-.714,1.175v-.551h-1.1c-.706,0-.906.275-.906.61,0,.394.326.639.869.639A1.142,1.142,0,0,0,232.622,139.967Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6260",
    "data-name": "Path 6260",
    d: "M241.2,138.9v2.266h-.714v-2.184c0-.773-.371-1.152-1.018-1.152a1.143,1.143,0,0,0-1.181,1.307v2.029h-.713v-2.184c0-.773-.372-1.152-1.018-1.152a1.143,1.143,0,0,0-1.182,1.307v2.029h-.713v-3.938h.683v.587a1.6,1.6,0,0,1,1.36-.624,1.455,1.455,0,0,1,1.367.728,1.777,1.777,0,0,1,1.517-.728A1.51,1.51,0,0,1,241.2,138.9Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6261",
    "data-name": "Path 6261",
    d: "M246.085,139.439h-3.2a1.335,1.335,0,0,0,1.427,1.152,1.473,1.473,0,0,0,1.137-.476l.394.461a2.147,2.147,0,0,1-3.671-1.375,1.929,1.929,0,0,1,1.976-2.006,1.9,1.9,0,0,1,1.948,2.029C246.1,139.283,246.092,139.372,246.085,139.439Zm-3.2-.513h2.527a1.272,1.272,0,0,0-2.527,0Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10282",
    "data-name": "Group 10282"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6262",
    "data-name": "Path 6262",
    d: "M224.416,113.6v5.2h-.795l-2.868-3.522V118.8h-.959v-5.2h.795l2.868,3.522V113.6Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6263",
    "data-name": "Path 6263",
    d: "M229.048,116.471V118.8h-.877v-.483a1.4,1.4,0,0,1-1.248.536c-.907,0-1.479-.5-1.479-1.189,0-.662.446-1.182,1.65-1.182h1.025v-.06c0-.542-.326-.861-.988-.861a1.967,1.967,0,0,0-1.2.393l-.364-.676a2.792,2.792,0,0,1,1.68-.49C228.387,114.784,229.048,115.326,229.048,116.471Zm-.929,1.084v-.46h-.958c-.632,0-.8.237-.8.527,0,.334.283.55.758.55A1.011,1.011,0,0,0,228.119,117.555Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6264",
    "data-name": "Path 6264",
    d: "M236.875,116.522V118.8h-.929v-2.155c0-.706-.327-1.047-.892-1.047-.609,0-1.033.4-1.033,1.189V118.8h-.929v-2.155c0-.706-.327-1.047-.891-1.047-.617,0-1.033.4-1.033,1.189V118.8h-.929v-3.968h.884v.5a1.645,1.645,0,0,1,1.3-.549,1.486,1.486,0,0,1,1.338.661,1.852,1.852,0,0,1,1.486-.661A1.527,1.527,0,0,1,236.875,116.522Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6265",
    "data-name": "Path 6265",
    d: "M241.82,117.109h-3.113a1.2,1.2,0,0,0,1.285.951,1.422,1.422,0,0,0,1.077-.43l.5.572a2.228,2.228,0,0,1-3.79-1.39,1.974,1.974,0,0,1,2.052-2.028,1.935,1.935,0,0,1,2.006,2.05C241.835,116.909,241.828,117.02,241.82,117.109Zm-3.121-.616h2.252a1.08,1.08,0,0,0-1.122-.966A1.1,1.1,0,0,0,238.7,116.493Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10281",
    "data-name": "Group 10281"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6266",
    "data-name": "Path 6266",
    d: "M202.442,114.624v1.287H204.7v.9h-2.255v1.774h-1.126v-4.87H205v.9Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6267",
    "data-name": "Path 6267",
    d: "M205.479,113.72a.621.621,0,0,1,.675-.606.609.609,0,0,1,.675.585.678.678,0,0,1-1.35.021Zm.132,1.127H206.7v3.743h-1.086Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6268",
    "data-name": "Path 6268",
    d: "M210.028,114.791v1c-.091-.007-.16-.014-.244-.014a.92.92,0,0,0-.995,1.044v1.767H207.7v-3.743h1.036v.494A1.512,1.512,0,0,1,210.028,114.791Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6269",
    "data-name": "Path 6269",
    d: "M210.324,118.243l.362-.78a2.568,2.568,0,0,0,1.3.362c.5,0,.689-.132.689-.341,0-.613-2.261.014-2.261-1.482,0-.71.64-1.211,1.732-1.211a3.083,3.083,0,0,1,1.44.327l-.361.772a2.159,2.159,0,0,0-1.079-.278c-.487,0-.7.153-.7.348,0,.64,2.261.021,2.261,1.5,0,.7-.647,1.19-1.768,1.19A3.22,3.22,0,0,1,210.324,118.243Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6270",
    "data-name": "Path 6270",
    d: "M216.792,118.41a1.561,1.561,0,0,1-.884.236,1.234,1.234,0,0,1-1.4-1.343v-1.538h-.577v-.835h.577v-.911H215.6v.911h.932v.835H215.6v1.524a.437.437,0,0,0,.466.494.733.733,0,0,0,.438-.139Z",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10283",
    "data-name": "Group 10283"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6271",
    "data-name": "Path 6271",
    d: "M246.6,112.985l-.848,1.116v.018l1.347-.179v.607l-1.347-.16v.018l.856,1.07-.562.322-.536-1.25h-.017l-.581,1.259-.509-.321.849-1.09v-.017l-1.322.169v-.607l1.313.17v-.018L244.4,113l.545-.312.554,1.241h.017l.545-1.25Z",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10284",
    "data-name": "Group 10284"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6272",
    "data-name": "Path 6272",
    d: "M208.133,300.99v1.8H207.4v-1.813l-2.066-3.389h.8l1.664,2.742,1.672-2.742h.735Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6273",
    "data-name": "Path 6273",
    d: "M210.037,300.819a2.047,2.047,0,1,1,2.051,2.013A1.96,1.96,0,0,1,210.037,300.819Zm3.374,0a1.328,1.328,0,1,0-1.323,1.388A1.293,1.293,0,0,0,213.411,300.819Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6274",
    "data-name": "Path 6274",
    d: "M218.793,298.849v3.938h-.677v-.594a1.6,1.6,0,0,1-1.337.639,1.547,1.547,0,0,1-1.694-1.717v-2.266h.713v2.184c0,.774.386,1.16,1.062,1.16a1.159,1.159,0,0,0,1.219-1.308v-2.036Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6275",
    "data-name": "Path 6275",
    d: "M222.273,298.812v.691a1.263,1.263,0,0,0-1.4,1.323v1.961h-.713v-3.938h.683v.661A1.5,1.5,0,0,1,222.273,298.812Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6276",
    "data-name": "Path 6276",
    d: "M229.78,297.585v5.2h-.609l-3.121-3.879v3.879h-.743v-5.2h.609l3.121,3.88v-3.88Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6277",
    "data-name": "Path 6277",
    d: "M234.36,300.409v2.378h-.676v-.52a1.461,1.461,0,0,1-1.293.565c-.891,0-1.456-.475-1.456-1.159,0-.632.408-1.152,1.583-1.152h1.129v-.141c0-.6-.35-.951-1.055-.951a2,2,0,0,0-1.249.423l-.3-.535a2.623,2.623,0,0,1,1.627-.5C233.751,298.812,234.36,299.332,234.36,300.409Zm-.713,1.174v-.55h-1.1c-.706,0-.906.276-.906.61,0,.393.326.64.869.64A1.143,1.143,0,0,0,233.647,301.583Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6278",
    "data-name": "Path 6278",
    d: "M242.224,300.521v2.266h-.714V300.6c0-.774-.371-1.152-1.018-1.152a1.144,1.144,0,0,0-1.181,1.308v2.028H238.6V300.6c0-.774-.372-1.152-1.018-1.152a1.144,1.144,0,0,0-1.182,1.308v2.028h-.713v-3.938h.683v.587a1.6,1.6,0,0,1,1.36-.624,1.455,1.455,0,0,1,1.367.728,1.775,1.775,0,0,1,1.516-.728A1.51,1.51,0,0,1,242.224,300.521Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6279",
    "data-name": "Path 6279",
    d: "M247.109,301.056h-3.195a1.334,1.334,0,0,0,1.427,1.151,1.468,1.468,0,0,0,1.137-.475l.394.461a2.147,2.147,0,0,1-3.671-1.374,1.929,1.929,0,0,1,1.976-2.007,1.9,1.9,0,0,1,1.948,2.028A2.073,2.073,0,0,1,247.109,301.056Zm-3.195-.513h2.527a1.271,1.271,0,0,0-2.527,0Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10285",
    "data-name": "Group 10285"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6280",
    "data-name": "Path 6280",
    d: "M237.869,272.5l-.848,1.116v.018l1.348-.179v.608l-1.348-.16v.017l.857,1.071-.562.322-.536-1.25h-.018l-.58,1.259-.509-.322.848-1.089V273.9l-1.321.17v-.608l1.312.17v-.017l-.839-1.089.544-.313.554,1.241h.018l.545-1.249Z",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10286",
    "data-name": "Group 10286"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6281",
    "data-name": "Path 6281",
    d: "M394.882,274.739l-.848,1.116v.017l1.347-.178v.607l-1.347-.16v.017l.857,1.072-.562.321-.536-1.25h-.018l-.58,1.259-.509-.321.848-1.089v-.019l-1.322.17v-.607l1.313.17v-.018l-.839-1.089.545-.312.553,1.24h.018l.544-1.249Z",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10287",
    "data-name": "Group 10287"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6282",
    "data-name": "Path 6282",
    d: "M378.038,300.99v1.8H377.3v-1.813l-2.066-3.389h.8l1.664,2.742,1.672-2.742h.736Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6283",
    "data-name": "Path 6283",
    d: "M379.942,300.819a2.048,2.048,0,1,1,2.051,2.013A1.96,1.96,0,0,1,379.942,300.819Zm3.374,0a1.328,1.328,0,1,0-1.323,1.388A1.293,1.293,0,0,0,383.316,300.819Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6284",
    "data-name": "Path 6284",
    d: "M388.7,298.849v3.938h-.677v-.594a1.6,1.6,0,0,1-1.337.639,1.547,1.547,0,0,1-1.694-1.717v-2.266h.713v2.184c0,.774.386,1.16,1.062,1.16a1.159,1.159,0,0,0,1.219-1.308v-2.036Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6285",
    "data-name": "Path 6285",
    d: "M392.177,298.812v.691a1.155,1.155,0,0,0-.163-.008,1.176,1.176,0,0,0-1.241,1.331v1.961h-.713v-3.938h.684v.661A1.5,1.5,0,0,1,392.177,298.812Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6286",
    "data-name": "Path 6286",
    d: "M399.685,297.585v5.2h-.609l-3.121-3.879v3.879h-.743v-5.2h.609l3.121,3.88v-3.88Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6287",
    "data-name": "Path 6287",
    d: "M404.265,300.409v2.378h-.676v-.52a1.461,1.461,0,0,1-1.293.565c-.891,0-1.457-.475-1.457-1.159,0-.632.41-1.152,1.583-1.152h1.13v-.141c0-.6-.349-.951-1.055-.951a1.99,1.99,0,0,0-1.248.423l-.3-.535a2.619,2.619,0,0,1,1.627-.5C403.656,298.812,404.265,299.332,404.265,300.409Zm-.713,1.174v-.55h-1.1c-.706,0-.908.276-.908.61,0,.393.328.64.871.64A1.142,1.142,0,0,0,403.552,301.583Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6288",
    "data-name": "Path 6288",
    d: "M412.129,300.521v2.266h-.713V300.6c0-.774-.371-1.152-1.018-1.152a1.144,1.144,0,0,0-1.182,1.308v2.028H408.5V300.6c0-.774-.372-1.152-1.018-1.152a1.144,1.144,0,0,0-1.182,1.308v2.028h-.714v-3.938h.685v.587a1.593,1.593,0,0,1,1.359-.624,1.457,1.457,0,0,1,1.368.728,1.773,1.773,0,0,1,1.515-.728A1.51,1.51,0,0,1,412.129,300.521Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6289",
    "data-name": "Path 6289",
    d: "M417.014,301.056h-3.2a1.333,1.333,0,0,0,1.427,1.151,1.465,1.465,0,0,0,1.136-.475l.4.461a2.147,2.147,0,0,1-3.671-1.374,1.929,1.929,0,0,1,1.977-2.007,1.9,1.9,0,0,1,1.946,2.028A2.067,2.067,0,0,1,417.014,301.056Zm-3.2-.513h2.526a1.271,1.271,0,0,0-2.526,0Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10288",
    "data-name": "Group 10288"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6290",
    "data-name": "Path 6290",
    d: "M206.351,170.486v.81h-3.9v-5.2h3.8v.81h-2.831v1.353h2.511v.795h-2.511v1.434Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6291",
    "data-name": "Path 6291",
    d: "M213.977,169.022V171.3h-.929v-2.155c0-.706-.327-1.048-.891-1.048-.61,0-1.033.4-1.033,1.189V171.3H210.2v-2.155c0-.706-.327-1.048-.892-1.048-.616,0-1.033.4-1.033,1.189V171.3h-.929v-3.968h.885v.5a1.641,1.641,0,0,1,1.3-.55,1.486,1.486,0,0,1,1.338.661,1.849,1.849,0,0,1,1.486-.661A1.526,1.526,0,0,1,213.977,169.022Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6292",
    "data-name": "Path 6292",
    d: "M218.491,168.97V171.3h-.877v-.483a1.4,1.4,0,0,1-1.248.535c-.907,0-1.479-.5-1.479-1.189,0-.662.446-1.182,1.65-1.182h1.025v-.059c0-.543-.327-.862-.988-.862a1.962,1.962,0,0,0-1.2.394l-.364-.677a2.8,2.8,0,0,1,1.68-.49C217.83,167.283,218.491,167.825,218.491,168.97Zm-.929,1.085v-.461H216.6c-.632,0-.8.238-.8.527,0,.335.283.551.758.551A1.011,1.011,0,0,0,217.562,170.055Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6293",
    "data-name": "Path 6293",
    d: "M219.556,166.117a.566.566,0,0,1,.594-.558.553.553,0,0,1,.6.535.6.6,0,0,1-1.189.023Zm.126,1.211h.929V171.3h-.929Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6294",
    "data-name": "Path 6294",
    d: "M221.831,165.782h.928V171.3h-.928Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10289",
    "data-name": "Group 10289"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6295",
    "data-name": "Path 6295",
    d: "M208.133,192.74v1.8H207.4v-1.813l-2.066-3.389h.8l1.664,2.742,1.672-2.742h.735Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6296",
    "data-name": "Path 6296",
    d: "M210.037,192.569a2.047,2.047,0,1,1,2.051,2.013A1.96,1.96,0,0,1,210.037,192.569Zm3.374,0a1.328,1.328,0,1,0-1.323,1.389A1.293,1.293,0,0,0,213.411,192.569Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6297",
    "data-name": "Path 6297",
    d: "M218.793,190.6v3.939h-.677v-.6a1.6,1.6,0,0,1-1.337.639,1.547,1.547,0,0,1-1.694-1.716V190.6h.713v2.185c0,.773.386,1.159,1.062,1.159a1.158,1.158,0,0,0,1.219-1.307V190.6Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6298",
    "data-name": "Path 6298",
    d: "M222.273,190.562v.691a1.349,1.349,0,0,0-.164-.007,1.175,1.175,0,0,0-1.241,1.33v1.962h-.713V190.6h.683v.662A1.5,1.5,0,0,1,222.273,190.562Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6299",
    "data-name": "Path 6299",
    d: "M229.082,193.891v.647h-3.775v-5.2h3.671v.647H226.05v1.6h2.608v.632H226.05v1.679Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6300",
    "data-name": "Path 6300",
    d: "M236.723,192.271v2.267h-.714v-2.185c0-.773-.371-1.151-1.018-1.151a1.143,1.143,0,0,0-1.181,1.307v2.029H233.1v-2.185c0-.773-.372-1.151-1.018-1.151a1.143,1.143,0,0,0-1.182,1.307v2.029h-.713V190.6h.683v.587a1.6,1.6,0,0,1,1.36-.624,1.457,1.457,0,0,1,1.367.728,1.778,1.778,0,0,1,1.516-.728A1.51,1.51,0,0,1,236.723,192.271Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6301",
    "data-name": "Path 6301",
    d: "M241.163,192.16v2.378h-.677v-.52a1.462,1.462,0,0,1-1.293.564c-.891,0-1.456-.475-1.456-1.159,0-.631.409-1.152,1.583-1.152h1.129v-.141c0-.6-.349-.951-1.055-.951a1.99,1.99,0,0,0-1.248.424l-.3-.535a2.618,2.618,0,0,1,1.628-.506C240.553,190.562,241.163,191.082,241.163,192.16Zm-.714,1.174v-.55h-1.1c-.705,0-.906.275-.906.609,0,.394.327.64.869.64A1.143,1.143,0,0,0,240.449,193.334Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6302",
    "data-name": "Path 6302",
    d: "M242.36,189.381a.47.47,0,0,1,.483-.469.465.465,0,1,1-.483.469Zm.127,1.218h.713v3.939h-.713Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6303",
    "data-name": "Path 6303",
    d: "M244.561,189.024h.714v5.514h-.714Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10290",
    "data-name": "Group 10290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6304",
    "data-name": "Path 6304",
    d: "M228.682,165.485l-.848,1.116v.018l1.348-.179v.607l-1.348-.16v.018l.857,1.07-.562.322-.536-1.25h-.018l-.58,1.259-.509-.321.848-1.09v-.017l-1.321.169v-.607l1.312.17v-.018l-.839-1.089.545-.312.553,1.241h.018l.545-1.25Z",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10291",
    "data-name": "Group 10291"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6305",
    "data-name": "Path 6305",
    d: "M269.289,219.455l-.848,1.116v.018l1.348-.179v.607l-1.348-.161v.018l.857,1.071-.563.321-.535-1.249h-.018l-.58,1.259-.509-.322.848-1.089v-.018l-1.321.17v-.607l1.312.169v-.017l-.839-1.09.544-.312.554,1.241h.018l.544-1.25Z",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10292",
    "data-name": "Group 10292"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_497",
    "data-name": "Rectangle 497",
    width: 331.713,
    height: 26.403,
    rx: 5.43,
    transform: "translate(195.814 233.986)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10293",
    "data-name": "Group 10293"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6306",
    "data-name": "Path 6306",
    d: "M374.545,111.605h.966v4.385h2.72v.817h-3.686Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6307",
    "data-name": "Path 6307",
    d: "M382.267,114.481v2.326h-.877v-.483a1.4,1.4,0,0,1-1.248.535c-.907,0-1.478-.5-1.478-1.189,0-.661.445-1.181,1.649-1.181h1.025v-.06c0-.542-.326-.862-.988-.862a1.963,1.963,0,0,0-1.2.394l-.365-.676a2.793,2.793,0,0,1,1.68-.491C381.606,112.794,382.267,113.337,382.267,114.481Zm-.929,1.085v-.461h-.958c-.631,0-.8.238-.8.528,0,.334.282.55.758.55A1.01,1.01,0,0,0,381.338,115.566Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6308",
    "data-name": "Path 6308",
    d: "M383.005,116.413l.357-.706a2.672,2.672,0,0,0,1.382.394c.587,0,.832-.164.832-.439,0-.757-2.452-.044-2.452-1.627,0-.75.676-1.241,1.747-1.241a3.159,3.159,0,0,1,1.485.342l-.356.706a2.171,2.171,0,0,0-1.137-.3c-.565,0-.832.185-.832.445,0,.8,2.452.09,2.452,1.643,0,.743-.684,1.226-1.8,1.226A3.15,3.15,0,0,1,383.005,116.413Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6309",
    "data-name": "Path 6309",
    d: "M389.672,116.592a1.458,1.458,0,0,1-.891.267,1.219,1.219,0,0,1-1.367-1.338v-1.909h-.655v-.743h.655v-.907h.928v.907H389.4v.743h-1.063V115.5c0,.387.194.6.55.6a.841.841,0,0,0,.521-.164Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6310",
    "data-name": "Path 6310",
    d: "M397.2,111.605v5.2h-.795l-2.868-3.522v3.522h-.959v-5.2h.8l2.868,3.523v-3.523Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6311",
    "data-name": "Path 6311",
    d: "M401.834,114.481v2.326h-.877v-.483a1.406,1.406,0,0,1-1.248.535c-.907,0-1.479-.5-1.479-1.189,0-.661.445-1.181,1.649-1.181H400.9v-.06c0-.542-.327-.862-.988-.862a1.971,1.971,0,0,0-1.2.394l-.363-.676a2.788,2.788,0,0,1,1.679-.491C401.172,112.794,401.834,113.337,401.834,114.481Zm-.929,1.085v-.461h-.958c-.632,0-.8.238-.8.528,0,.334.282.55.758.55A1.013,1.013,0,0,0,400.9,115.566Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6312",
    "data-name": "Path 6312",
    d: "M409.661,114.533v2.274h-.929v-2.155c0-.706-.327-1.048-.892-1.048-.609,0-1.033.4-1.033,1.189v2.014h-.928v-2.155c0-.706-.328-1.048-.892-1.048-.617,0-1.033.4-1.033,1.189v2.014h-.929v-3.968h.884v.505a1.649,1.649,0,0,1,1.3-.55,1.487,1.487,0,0,1,1.337.661,1.856,1.856,0,0,1,1.487-.661A1.527,1.527,0,0,1,409.661,114.533Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6313",
    "data-name": "Path 6313",
    d: "M414.606,115.12h-3.114a1.2,1.2,0,0,0,1.286.951,1.421,1.421,0,0,0,1.077-.431l.5.573a2.229,2.229,0,0,1-3.79-1.39,1.973,1.973,0,0,1,2.051-2.029,1.936,1.936,0,0,1,2.007,2.051C414.621,114.919,414.613,115.031,414.606,115.12Zm-3.121-.617h2.251a1.08,1.08,0,0,0-1.122-.966A1.1,1.1,0,0,0,411.485,114.5Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10294",
    "data-name": "Group 10294"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6314",
    "data-name": "Path 6314",
    d: "M383.744,139.372v1.8h-.736v-1.813l-2.066-3.388h.8l1.664,2.742,1.672-2.742h.735Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6315",
    "data-name": "Path 6315",
    d: "M385.648,139.2a2.048,2.048,0,1,1,2.051,2.014A1.959,1.959,0,0,1,385.648,139.2Zm3.374,0a1.328,1.328,0,1,0-1.323,1.39A1.292,1.292,0,0,0,389.022,139.2Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6316",
    "data-name": "Path 6316",
    d: "M394.4,137.232v3.938h-.677v-.594a1.6,1.6,0,0,1-1.337.639A1.547,1.547,0,0,1,390.7,139.5v-2.266h.713v2.184c0,.773.386,1.16,1.062,1.16a1.159,1.159,0,0,0,1.219-1.308v-2.036Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6317",
    "data-name": "Path 6317",
    d: "M397.884,137.2v.691a1.263,1.263,0,0,0-1.4,1.322v1.962h-.713v-3.938h.684v.661A1.5,1.5,0,0,1,397.884,137.2Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6318",
    "data-name": "Path 6318",
    d: "M405.391,135.969v5.2h-.609l-3.121-3.879v3.879h-.743v-5.2h.609l3.121,3.878v-3.878Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6319",
    "data-name": "Path 6319",
    d: "M409.971,138.792v2.378H409.3v-.52a1.461,1.461,0,0,1-1.292.565c-.892,0-1.458-.476-1.458-1.159,0-.632.41-1.152,1.584-1.152h1.129v-.141c0-.6-.349-.952-1.055-.952a1.99,1.99,0,0,0-1.248.424l-.3-.535a2.619,2.619,0,0,1,1.627-.5C409.362,137.2,409.971,137.715,409.971,138.792Zm-.713,1.175v-.551h-1.1c-.706,0-.907.275-.907.61,0,.394.327.639.87.639A1.141,1.141,0,0,0,409.258,139.967Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6320",
    "data-name": "Path 6320",
    d: "M417.836,138.9v2.266h-.714v-2.184c0-.773-.371-1.152-1.018-1.152a1.143,1.143,0,0,0-1.182,1.307v2.029h-.713v-2.184c0-.773-.372-1.152-1.018-1.152a1.143,1.143,0,0,0-1.182,1.307v2.029H411.3v-3.938h.685v.587a1.6,1.6,0,0,1,1.359-.624,1.457,1.457,0,0,1,1.368.728,1.773,1.773,0,0,1,1.515-.728A1.511,1.511,0,0,1,417.836,138.9Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6321",
    "data-name": "Path 6321",
    d: "M422.72,139.439h-3.2a1.334,1.334,0,0,0,1.427,1.152,1.469,1.469,0,0,0,1.136-.476l.395.461a2.147,2.147,0,0,1-3.671-1.375,1.929,1.929,0,0,1,1.977-2.006,1.9,1.9,0,0,1,1.946,2.029A2.086,2.086,0,0,1,422.72,139.439Zm-3.2-.513h2.526a1.271,1.271,0,0,0-2.526,0Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10295",
    "data-name": "Group 10295"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6322",
    "data-name": "Path 6322",
    d: "M419.709,111l-.848,1.116v.018l1.348-.179v.607l-1.348-.161v.018l.856,1.071-.561.321-.536-1.249H418.6l-.58,1.259-.509-.322.848-1.089v-.017l-1.321.169v-.607l1.312.169V112.1l-.839-1.089.544-.312.554,1.24h.018l.544-1.25Z",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10296",
    "data-name": "Group 10296"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6323",
    "data-name": "Path 6323",
    d: "M199.817,222.055a2.815,2.815,0,0,1,4.845-1.806l-.624.588a1.826,1.826,0,0,0-1.39-.61,1.828,1.828,0,1,0,0,3.656,1.809,1.809,0,0,0,1.39-.617l.624.595a2.814,2.814,0,0,1-4.845-1.806Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6324",
    "data-name": "Path 6324",
    d: "M205.028,222.672a2.115,2.115,0,1,1,2.11,2.036A2,2,0,0,1,205.028,222.672Zm3.292,0a1.18,1.18,0,1,0-1.182,1.241A1.156,1.156,0,0,0,208.32,222.672Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6325",
    "data-name": "Path 6325",
    d: "M214.059,222.382v2.274h-.929V222.5c0-.706-.349-1.048-.943-1.048a1.055,1.055,0,0,0-1.108,1.2v2.006h-.929v-3.968h.885v.512a1.727,1.727,0,0,1,1.367-.557A1.551,1.551,0,0,1,214.059,222.382Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6326",
    "data-name": "Path 6326",
    d: "M217.628,224.441a1.461,1.461,0,0,1-.892.267,1.219,1.219,0,0,1-1.367-1.338v-1.909h-.654v-.743h.654v-.907h.929v.907h1.062v.743H216.3v1.888c0,.386.193.594.55.594a.838.838,0,0,0,.52-.164Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6327",
    "data-name": "Path 6327",
    d: "M221.717,222.33v2.326h-.877v-.483a1.406,1.406,0,0,1-1.249.535c-.906,0-1.478-.5-1.478-1.189,0-.661.446-1.181,1.649-1.181h1.026v-.06c0-.542-.327-.862-.989-.862a1.965,1.965,0,0,0-1.2.394l-.364-.676a2.788,2.788,0,0,1,1.679-.491C221.055,220.643,221.717,221.186,221.717,222.33Zm-.929,1.085v-.461h-.959c-.631,0-.8.238-.8.528,0,.334.282.55.758.55A1.011,1.011,0,0,0,220.788,223.415Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6328",
    "data-name": "Path 6328",
    d: "M222.617,222.672a2.008,2.008,0,0,1,2.148-2.029,1.786,1.786,0,0,1,1.694.922l-.713.416a1.124,1.124,0,0,0-.989-.55,1.242,1.242,0,0,0,0,2.482,1.124,1.124,0,0,0,.989-.55l.713.416a1.8,1.8,0,0,1-1.694.929A2.014,2.014,0,0,1,222.617,222.672Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6329",
    "data-name": "Path 6329",
    d: "M229.7,224.441a1.458,1.458,0,0,1-.891.267,1.22,1.22,0,0,1-1.368-1.338v-1.909h-.654v-.743h.654v-.907h.929v.907h1.063v.743h-1.063v1.888c0,.386.194.594.55.594a.838.838,0,0,0,.52-.164Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6330",
    "data-name": "Path 6330",
    d: "M238.4,219.454v5.2h-.795l-2.869-3.522v3.522h-.958v-5.2h.795l2.868,3.523v-3.523Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6331",
    "data-name": "Path 6331",
    d: "M243.553,220.688v3.968h-.884v-.505a1.622,1.622,0,0,1-1.278.557,1.57,1.57,0,0,1-1.709-1.754v-2.266h.928v2.14c0,.721.342,1.062.93,1.062a1.045,1.045,0,0,0,1.085-1.2v-2.006Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6332",
    "data-name": "Path 6332",
    d: "M251.41,222.382v2.274h-.929V222.5c0-.706-.327-1.048-.892-1.048-.609,0-1.033.4-1.033,1.189v2.014h-.928V222.5c0-.706-.328-1.048-.892-1.048-.617,0-1.033.4-1.033,1.189v2.014h-.929v-3.968h.884v.5a1.647,1.647,0,0,1,1.3-.55,1.485,1.485,0,0,1,1.337.662,1.853,1.853,0,0,1,1.486-.662A1.527,1.527,0,0,1,251.41,222.382Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6333",
    "data-name": "Path 6333",
    d: "M256.816,222.672a1.932,1.932,0,0,1-2.014,2.036,1.636,1.636,0,0,1-1.315-.565v.513H252.6v-5.514h.928v2.029a1.651,1.651,0,0,1,1.271-.528A1.927,1.927,0,0,1,256.816,222.672Zm-.944,0a1.179,1.179,0,1,0-1.174,1.241A1.154,1.154,0,0,0,255.872,222.672Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6334",
    "data-name": "Path 6334",
    d: "M261.418,222.969H258.3a1.2,1.2,0,0,0,1.286.951,1.422,1.422,0,0,0,1.077-.43l.5.571a2.228,2.228,0,0,1-3.79-1.389,1.974,1.974,0,0,1,2.051-2.029,1.935,1.935,0,0,1,2.007,2.051C261.433,222.768,261.425,222.88,261.418,222.969Zm-3.122-.617h2.252a1.079,1.079,0,0,0-1.122-.965A1.1,1.1,0,0,0,258.3,222.352Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6335",
    "data-name": "Path 6335",
    d: "M264.623,220.643v.885a1.179,1.179,0,0,0-.216-.023,1.082,1.082,0,0,0-1.152,1.226v1.925h-.929v-3.968h.885v.579A1.561,1.561,0,0,1,264.623,220.643Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10297",
    "data-name": "Group 10297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6336",
    "data-name": "Path 6336",
    d: "M205.823,277.112h-2.6l-.512,1.2h-1l2.341-5.2h.951l2.348,5.2h-1.011Zm-.319-.758-.981-2.274-.974,2.274Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6337",
    "data-name": "Path 6337",
    d: "M211.778,272.8v5.514h-.892V277.8a1.636,1.636,0,0,1-1.315.565,2.033,2.033,0,0,1,0-4.065,1.624,1.624,0,0,1,1.278.535V272.8Zm-.914,3.529a1.183,1.183,0,1,0-1.181,1.242A1.159,1.159,0,0,0,210.864,276.331Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6338",
    "data-name": "Path 6338",
    d: "M216.885,272.8v5.514h-.891V277.8a1.637,1.637,0,0,1-1.316.565,2.033,2.033,0,0,1,0-4.065,1.627,1.627,0,0,1,1.279.535V272.8Zm-.914,3.529a1.183,1.183,0,1,0-1.181,1.242A1.159,1.159,0,0,0,215.971,276.331Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6339",
    "data-name": "Path 6339",
    d: "M220.4,274.3v.884a1.16,1.16,0,0,0-.215-.022,1.082,1.082,0,0,0-1.152,1.226v1.925h-.929v-3.968h.884v.579A1.563,1.563,0,0,1,220.4,274.3Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6340",
    "data-name": "Path 6340",
    d: "M224.87,276.629h-3.114a1.2,1.2,0,0,0,1.286.951,1.419,1.419,0,0,0,1.077-.431l.5.572a2.228,2.228,0,0,1-3.79-1.39,1.974,1.974,0,0,1,2.052-2.028,1.935,1.935,0,0,1,2.006,2.051C224.885,276.428,224.878,276.539,224.87,276.629Zm-3.121-.617H224a1.081,1.081,0,0,0-1.122-.966A1.1,1.1,0,0,0,221.749,276.012Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6341",
    "data-name": "Path 6341",
    d: "M225.325,277.922l.357-.706a2.662,2.662,0,0,0,1.382.394c.587,0,.832-.163.832-.439,0-.758-2.452-.044-2.452-1.627,0-.751.676-1.241,1.746-1.241a3.148,3.148,0,0,1,1.486.342l-.356.706a2.173,2.173,0,0,0-1.137-.3c-.565,0-.832.187-.832.446,0,.8,2.452.089,2.452,1.643,0,.743-.684,1.226-1.8,1.226A3.159,3.159,0,0,1,225.325,277.922Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6342",
    "data-name": "Path 6342",
    d: "M229.154,277.922l.356-.706a2.666,2.666,0,0,0,1.383.394c.587,0,.832-.163.832-.439,0-.758-2.452-.044-2.452-1.627,0-.751.676-1.241,1.746-1.241a3.151,3.151,0,0,1,1.486.342l-.356.706a2.176,2.176,0,0,0-1.138-.3c-.564,0-.832.187-.832.446,0,.8,2.452.089,2.452,1.643,0,.743-.683,1.226-1.8,1.226A3.156,3.156,0,0,1,229.154,277.922Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10298",
    "data-name": "Group 10298"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6343",
    "data-name": "Path 6343",
    d: "M209.106,355.816l2.166,1.219-.564,1-2.2-1.292.019,2.476h-1.093l.018-2.476-2.2,1.292-.565-1,2.185-1.219-2.185-1.2.565-1.02,2.2,1.292-.018-2.457h1.093l-.019,2.457,2.2-1.292.564,1.02Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6344",
    "data-name": "Path 6344",
    d: "M216.749,355.816l2.166,1.219-.564,1-2.2-1.292.019,2.476h-1.093l.018-2.476-2.2,1.292-.565-1,2.185-1.219-2.185-1.2.565-1.02,2.2,1.292-.018-2.457h1.093l-.019,2.457,2.2-1.292.564,1.02Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6345",
    "data-name": "Path 6345",
    d: "M224.392,355.816l2.166,1.219-.565,1-2.2-1.292.018,2.476h-1.092l.018-2.476-2.2,1.292-.564-1,2.184-1.219-2.184-1.2.564-1.02,2.2,1.292-.018-2.457h1.092l-.018,2.457,2.2-1.292.565,1.02Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6346",
    "data-name": "Path 6346",
    d: "M232.035,355.816l2.166,1.219-.565,1-2.2-1.292.018,2.476H230.36l.018-2.476-2.2,1.292-.564-1,2.184-1.219-2.184-1.2.564-1.02,2.2,1.292-.018-2.457h1.092l-.018,2.457,2.2-1.292.565,1.02Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6347",
    "data-name": "Path 6347",
    d: "M239.677,355.816l2.166,1.219-.564,1-2.2-1.292.019,2.476H238l.018-2.476-2.2,1.292-.564-1,2.184-1.219-2.184-1.2.564-1.02,2.2,1.292L238,352.43H239.1l-.019,2.457,2.2-1.292.564,1.02Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6348",
    "data-name": "Path 6348",
    d: "M247.32,355.816l2.166,1.219-.564,1-2.2-1.292.019,2.476h-1.092l.018-2.476-2.2,1.292-.564-1,2.184-1.219-2.184-1.2.564-1.02,2.2,1.292-.018-2.457h1.092l-.019,2.457,2.2-1.292.564,1.02Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6349",
    "data-name": "Path 6349",
    d: "M254.963,355.816l2.166,1.219-.564,1-2.2-1.292.019,2.476h-1.092l.018-2.476-2.2,1.292-.564-1,2.184-1.219-2.184-1.2.564-1.02,2.2,1.292-.018-2.457h1.092l-.019,2.457,2.2-1.292.564,1.02Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10299",
    "data-name": "Group 10299"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6350",
    "data-name": "Path 6350",
    d: "M370.727,280.04l.334-.751a2.882,2.882,0,0,0,1.717.573c.81,0,1.152-.289,1.152-.676,0-1.122-3.092-.387-3.092-2.318,0-.84.669-1.554,2.1-1.554a3.3,3.3,0,0,1,1.732.461l-.3.751a2.881,2.881,0,0,0-1.435-.409c-.8,0-1.129.312-1.129.706,0,1.107,3.084.386,3.084,2.3,0,.833-.676,1.545-2.1,1.545A3.355,3.355,0,0,1,370.727,280.04Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6351",
    "data-name": "Path 6351",
    d: "M378.138,280.374a1.455,1.455,0,0,1-.892.268,1.219,1.219,0,0,1-1.367-1.337v-1.91h-.654v-.743h.654v-.907h.929v.907h1.062v.743h-1.062v1.888c0,.385.193.594.55.594a.834.834,0,0,0,.52-.164Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6352",
    "data-name": "Path 6352",
    d: "M382.226,278.264v2.326h-.877v-.483a1.406,1.406,0,0,1-1.248.535c-.907,0-1.479-.5-1.479-1.189,0-.661.446-1.181,1.65-1.181H381.3v-.06c0-.542-.327-.862-.988-.862a1.954,1.954,0,0,0-1.2.395l-.364-.677a2.783,2.783,0,0,1,1.679-.491C381.564,276.577,382.226,277.12,382.226,278.264Zm-.929,1.085v-.461h-.959c-.631,0-.8.238-.8.528,0,.334.282.55.758.55A1.011,1.011,0,0,0,381.3,279.349Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6353",
    "data-name": "Path 6353",
    d: "M385.8,280.374a1.452,1.452,0,0,1-.891.268,1.219,1.219,0,0,1-1.367-1.337v-1.91h-.655v-.743h.655v-.907h.928v.907h1.063v.743h-1.063v1.888c0,.385.194.594.55.594a.837.837,0,0,0,.521-.164Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6354",
    "data-name": "Path 6354",
    d: "M390.151,278.9h-3.113a1.2,1.2,0,0,0,1.285.951,1.42,1.42,0,0,0,1.077-.432l.5.572a2.228,2.228,0,0,1-3.79-1.389,1.974,1.974,0,0,1,2.052-2.029,1.935,1.935,0,0,1,2.006,2.051C390.166,278.7,390.159,278.814,390.151,278.9Zm-3.121-.618h2.252a1.079,1.079,0,0,0-1.122-.965A1.1,1.1,0,0,0,387.03,278.286Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10300",
    "data-name": "Group 10300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6355",
    "data-name": "Path 6355",
    d: "M204.544,331.8c0,1.145-.848,1.851-2.215,1.851h-1.174v1.5h-.966v-5.2h2.14C203.7,329.95,204.544,330.649,204.544,331.8Zm-.974,0c0-.653-.439-1.033-1.286-1.033h-1.129v2.066h1.129C203.131,332.833,203.57,332.454,203.57,331.8Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6356",
    "data-name": "Path 6356",
    d: "M208.707,332.826v2.326h-.877v-.484a1.406,1.406,0,0,1-1.248.535c-.907,0-1.479-.5-1.479-1.188,0-.661.446-1.182,1.65-1.182h1.025v-.059c0-.542-.327-.863-.988-.863a1.966,1.966,0,0,0-1.2.395l-.364-.677a2.789,2.789,0,0,1,1.679-.49C208.045,331.139,208.707,331.681,208.707,332.826Zm-.929,1.084v-.46h-.959c-.631,0-.8.238-.8.528,0,.334.282.55.758.55A1.011,1.011,0,0,0,207.778,333.91Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6357",
    "data-name": "Path 6357",
    d: "M209.445,334.758l.356-.706a2.666,2.666,0,0,0,1.383.394c.587,0,.832-.163.832-.439,0-.758-2.452-.044-2.452-1.627,0-.751.676-1.241,1.746-1.241a3.151,3.151,0,0,1,1.486.342l-.356.706a2.176,2.176,0,0,0-1.138-.3c-.564,0-.832.187-.832.446,0,.8,2.452.089,2.452,1.643,0,.743-.683,1.225-1.8,1.225A3.156,3.156,0,0,1,209.445,334.758Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6358",
    "data-name": "Path 6358",
    d: "M213.274,334.758l.356-.706a2.662,2.662,0,0,0,1.382.394c.587,0,.832-.163.832-.439,0-.758-2.452-.044-2.452-1.627,0-.751.676-1.241,1.746-1.241a3.155,3.155,0,0,1,1.487.342l-.357.706a2.172,2.172,0,0,0-1.137-.3c-.565,0-.832.187-.832.446,0,.8,2.452.089,2.452,1.643,0,.743-.684,1.225-1.8,1.225A3.156,3.156,0,0,1,213.274,334.758Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6359",
    "data-name": "Path 6359",
    d: "M223.671,331.184l-1.464,3.968h-.891l-1.026-2.735-1.04,2.735h-.892l-1.457-3.968h.877l1.048,2.928,1.093-2.928h.78l1.07,2.942,1.077-2.942Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6360",
    "data-name": "Path 6360",
    d: "M223.875,333.167a2.115,2.115,0,1,1,2.11,2.036A2,2,0,0,1,223.875,333.167Zm3.292,0a1.18,1.18,0,1,0-1.182,1.241A1.155,1.155,0,0,0,227.167,333.167Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6361",
    "data-name": "Path 6361",
    d: "M231.293,331.139v.884a1.17,1.17,0,0,0-.216-.022,1.082,1.082,0,0,0-1.152,1.226v1.925H229v-3.968h.884v.579A1.562,1.562,0,0,1,231.293,331.139Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6362",
    "data-name": "Path 6362",
    d: "M235.931,329.638v5.514h-.891v-.513a1.636,1.636,0,0,1-1.316.564,2.032,2.032,0,0,1,0-4.064,1.627,1.627,0,0,1,1.279.535v-2.036Zm-.914,3.529a1.183,1.183,0,1,0-1.181,1.241A1.159,1.159,0,0,0,235.017,333.167Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10304",
    "data-name": "Group 10304"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10302",
    "data-name": "Group 10302"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10301",
    "data-name": "Group 10301"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6363",
    "data-name": "Path 6363",
    d: "M503.678,369.169a8.837,8.837,0,0,0,1.563-.285,5.423,5.423,0,0,0,3.277-2.925,6.684,6.684,0,0,0,.466-3.2c-.007-1.214-.014-2.532-.021-3.946-.012-2.836-.025-6.06-.039-9.621a7.616,7.616,0,0,0-.279-2.645,5.22,5.22,0,0,0-1.51-2.264,5.154,5.154,0,0,0-2.549-1.221,24.921,24.921,0,0,0-3.047-.077l-13.382.024-30.664.02a5.183,5.183,0,0,0-5.152,4.719c-.047,2.6-.015,5.247-.027,7.8s0,5.084-.006,7.551a5.606,5.606,0,0,0,.782,3.377,5.141,5.141,0,0,0,2.6,2.126,9.094,9.094,0,0,0,3.365.334l3.4.006,6.5.013,11.661.032,16.884.083,4.59.049,1.194.025a2.34,2.34,0,0,1,.406.027,2.34,2.34,0,0,1-.406.027l-1.194.026-4.59.049-16.884.082-11.661.032-6.5.013-3.4.006c-.578,0-1.145.01-1.741-.006a5.415,5.415,0,0,1-1.791-.348,5.63,5.63,0,0,1-2.844-2.317,6.127,6.127,0,0,1-.864-3.636q0-3.7-.006-7.551c.009-2.574-.028-5.153.021-7.845a5.7,5.7,0,0,1,5.668-5.195l30.664.02,13.382.024a24.674,24.674,0,0,1,3.12.1,5.637,5.637,0,0,1,4.352,3.775,7.947,7.947,0,0,1,.281,2.766c-.014,3.561-.027,6.785-.038,9.621-.008,1.414-.015,2.732-.022,3.946a6.865,6.865,0,0,1-.53,3.288,5.481,5.481,0,0,1-3.43,2.941A4.434,4.434,0,0,1,503.678,369.169Z",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10303",
    "data-name": "Group 10303"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6364",
    "data-name": "Path 6364",
    d: "M462.649,356.347a3.006,3.006,0,0,1,5.209-1.855l-.811.748a1.761,1.761,0,0,0-1.373-.639,1.746,1.746,0,0,0,0,3.493,1.744,1.744,0,0,0,1.373-.647l.811.749a3,3,0,0,1-5.209-1.849Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6365",
    "data-name": "Path 6365",
    d: "M468.16,356.979a2.309,2.309,0,1,1,2.308,2.16A2.159,2.159,0,0,1,468.16,356.979Zm3.377,0a1.076,1.076,0,1,0-1.069,1.162A1.058,1.058,0,0,0,471.537,356.979Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6366",
    "data-name": "Path 6366",
    d: "M477.867,356.675v2.4h-1.216v-2.215c0-.678-.313-.991-.851-.991-.584,0-1,.36-1,1.131v2.075h-1.216v-4.2h1.162v.491a1.836,1.836,0,0,1,1.388-.552A1.643,1.643,0,0,1,477.867,356.675Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6367",
    "data-name": "Path 6367",
    d: "M481.67,358.873a1.735,1.735,0,0,1-.991.266,1.382,1.382,0,0,1-1.566-1.505V355.91h-.648v-.935h.648v-1.022h1.216v1.022h1.045v.935h-1.045v1.709a.489.489,0,0,0,.522.553.812.812,0,0,0,.491-.156Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6368",
    "data-name": "Path 6368",
    d: "M482.207,353.619a.7.7,0,0,1,.756-.679.682.682,0,0,1,.756.655.759.759,0,0,1-1.512.024Zm.148,1.262h1.216v4.2h-1.216Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6369",
    "data-name": "Path 6369",
    d: "M488.99,356.675v2.4h-1.216v-2.215c0-.678-.312-.991-.851-.991-.584,0-1.005.36-1.005,1.131v2.075H484.7v-4.2h1.162v.491a1.836,1.836,0,0,1,1.388-.552A1.643,1.643,0,0,1,488.99,356.675Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6370",
    "data-name": "Path 6370",
    d: "M494.314,354.881v4.2h-1.153v-.5a1.7,1.7,0,0,1-1.3.562,1.672,1.672,0,0,1-1.793-1.887v-2.371h1.216v2.192c0,.7.312,1.013.85,1.013.562,0,.967-.358.967-1.131v-2.074Z",
    fill: "#ff725e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6371",
    "data-name": "Path 6371",
    d: "M499.529,357.323h-3.174a1.12,1.12,0,0,0,1.2.841,1.422,1.422,0,0,0,1.053-.4l.646.7a2.449,2.449,0,0,1-4.125-1.481,2.136,2.136,0,0,1,2.239-2.159,2.076,2.076,0,0,1,2.183,2.175C499.552,357.088,499.537,357.221,499.529,357.323Zm-3.19-.71h2.067a1.048,1.048,0,0,0-2.067,0Z",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10307",
    "data-name": "Group 10307"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10305",
    "data-name": "Group 10305"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_498",
    "data-name": "Rectangle 498",
    width: 57.049,
    height: 26.403,
    rx: 5.43,
    transform: "translate(384.886 342.766)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10306",
    "data-name": "Group 10306"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6372",
    "data-name": "Path 6372",
    d: "M404.129,358.538l.428-.951a3.212,3.212,0,0,0,1.8.57c.749,0,1.053-.25,1.053-.585,0-1.022-3.174-.32-3.174-2.347,0-.928.749-1.7,2.3-1.7a3.669,3.669,0,0,1,1.894.483l-.389.959a3.091,3.091,0,0,0-1.513-.429c-.749,0-1.037.282-1.037.624,0,1.006,3.173.312,3.173,2.316,0,.912-.756,1.692-2.316,1.692A3.888,3.888,0,0,1,404.129,358.538Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6373",
    "data-name": "Path 6373",
    d: "M413.156,356.683v2.394h-1.138v-.523a1.377,1.377,0,0,1-1.279.585c-.983,0-1.568-.546-1.568-1.271,0-.741.523-1.255,1.8-1.255h.967c0-.523-.311-.827-.967-.827a2.019,2.019,0,0,0-1.209.39l-.436-.849a3.211,3.211,0,0,1,1.808-.507C412.416,354.82,413.156,355.411,413.156,356.683Zm-1.216,1.068v-.428h-.834c-.569,0-.749.21-.749.491,0,.3.258.507.687.507A.9.9,0,0,0,411.94,357.751Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6374",
    "data-name": "Path 6374",
    d: "M418.34,354.881l-1.77,4.2h-1.255l-1.763-4.2h1.256l1.161,2.855,1.2-2.855Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6375",
    "data-name": "Path 6375",
    d: "M422.806,357.323h-3.174a1.121,1.121,0,0,0,1.2.841,1.421,1.421,0,0,0,1.052-.4l.647.7a2.449,2.449,0,0,1-4.125-1.481,2.136,2.136,0,0,1,2.238-2.159,2.076,2.076,0,0,1,2.184,2.175C422.83,357.088,422.814,357.221,422.806,357.323Zm-3.189-.71h2.066a1.048,1.048,0,0,0-2.066,0Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10308",
    "data-name": "Group 10308"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6376",
    "data-name": "Path 6376",
    d: "M209.845,248.16v1.8h-.736v-1.813l-2.066-3.388h.795L209.5,247.5l1.672-2.742h.735Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6377",
    "data-name": "Path 6377",
    d: "M211.749,247.99A2.047,2.047,0,1,1,213.8,250,1.96,1.96,0,0,1,211.749,247.99Zm3.374,0a1.328,1.328,0,1,0-1.323,1.388A1.293,1.293,0,0,0,215.123,247.99Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6378",
    "data-name": "Path 6378",
    d: "M220.5,246.02v3.938h-.676v-.594a1.6,1.6,0,0,1-1.337.639,1.548,1.548,0,0,1-1.695-1.717V246.02h.714V248.2c0,.774.386,1.16,1.062,1.16a1.159,1.159,0,0,0,1.219-1.308V246.02Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6379",
    "data-name": "Path 6379",
    d: "M223.984,245.983v.692a1.161,1.161,0,0,0-.163-.008A1.175,1.175,0,0,0,222.58,248v1.961h-.713V246.02h.683v.662A1.5,1.5,0,0,1,223.984,245.983Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6380",
    "data-name": "Path 6380",
    d: "M231.492,244.757v5.2h-.609l-3.121-3.878v3.878h-.743v-5.2h.609l3.121,3.879v-3.879Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6381",
    "data-name": "Path 6381",
    d: "M236.622,246.02v3.938h-.676v-.594a1.6,1.6,0,0,1-1.338.639,1.547,1.547,0,0,1-1.694-1.717V246.02h.714V248.2c0,.774.386,1.16,1.062,1.16a1.159,1.159,0,0,0,1.219-1.308V246.02Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6382",
    "data-name": "Path 6382",
    d: "M244.523,247.692v2.266h-.713v-2.184c0-.773-.372-1.152-1.018-1.152a1.144,1.144,0,0,0-1.182,1.309v2.027H240.9v-2.184c0-.773-.372-1.152-1.018-1.152a1.145,1.145,0,0,0-1.182,1.309v2.027h-.713V246.02h.684v.587a1.6,1.6,0,0,1,1.359-.624,1.458,1.458,0,0,1,1.368.729,1.772,1.772,0,0,1,1.516-.729A1.51,1.51,0,0,1,244.523,247.692Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6383",
    "data-name": "Path 6383",
    d: "M249.921,247.99A1.917,1.917,0,0,1,247.93,250a1.665,1.665,0,0,1-1.4-.669v.624h-.683v-5.513h.713v2.17a1.676,1.676,0,0,1,1.375-.632A1.911,1.911,0,0,1,249.921,247.99Zm-.72,0a1.328,1.328,0,1,0-1.33,1.388A1.3,1.3,0,0,0,249.2,247.99Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6384",
    "data-name": "Path 6384",
    d: "M254.457,248.227h-3.2a1.334,1.334,0,0,0,1.427,1.151,1.468,1.468,0,0,0,1.137-.475l.394.461a2.147,2.147,0,0,1-3.671-1.374,1.929,1.929,0,0,1,1.977-2.007,1.9,1.9,0,0,1,1.947,2.029C254.472,248.071,254.464,248.16,254.457,248.227Zm-3.2-.512h2.527a1.271,1.271,0,0,0-2.527,0Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6385",
    "data-name": "Path 6385",
    d: "M257.58,245.983v.692a1.263,1.263,0,0,0-1.4,1.322v1.961h-.713V246.02h.684v.662A1.5,1.5,0,0,1,257.58,245.983Z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10309",
    "data-name": "Group 10309"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_499",
    "data-name": "Rectangle 499",
    width: 407.963,
    height: 24.971,
    transform: "translate(164.973 71.854)",
    fill: "#ff725e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10310",
    "data-name": "Group 10310"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6386",
    "data-name": "Path 6386",
    d: "M189.312,83.118v1.651H192.2V85.93h-2.892v2.276h-1.446V81.957h4.722v1.161Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6387",
    "data-name": "Path 6387",
    d: "M193.111,85.082a3.424,3.424,0,1,1,3.419,3.231A3.234,3.234,0,0,1,193.111,85.082Zm5.374,0a1.955,1.955,0,1,0-1.955,2A1.906,1.906,0,0,0,198.485,85.082Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6388",
    "data-name": "Path 6388",
    d: "M205.015,88.206l-1.205-1.741h-1.33v1.741h-1.447V81.957h2.705c1.669,0,2.714.866,2.714,2.268a2.033,2.033,0,0,1-1.285,1.973l1.4,2.008Zm-1.357-5.07H202.48v2.178h1.178c.884,0,1.33-.411,1.33-1.089S204.542,83.136,203.658,83.136Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6389",
    "data-name": "Path 6389",
    d: "M213.276,88.206l-.008-3.749-1.839,3.088h-.652l-1.83-3.008v3.669H207.59V81.957h1.2l2.339,3.883,2.3-3.883h1.188l.017,6.249Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10317",
    "data-name": "Group 10317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10316",
    "data-name": "Group 10316"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10315",
    "data-name": "Group 10315"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10314",
    "data-name": "Group 10314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10313",
    "data-name": "Group 10313"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10312",
    "data-name": "Group 10312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10311",
    "data-name": "Group 10311"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6390",
    "data-name": "Path 6390",
    d: "M572.814,72.486,165.262,72.5l.234-.233c-.042,95.086-.09,203.721-.141,318.578v.035l-.261-.26,407.552.26-.215.215c.231-192.318.381-316.821.383-318.614,0,1.792.019,126.3.048,318.614v.216h-.216l-407.552-.17h-.26v-.295c.07-114.858.136-223.492.194-318.578v-.235h.233Z",
    fill: "#263238"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10484",
    "data-name": "Group 10484"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10323",
    "data-name": "Group 10323"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10320",
    "data-name": "Group 10320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10319",
    "data-name": "Group 10319"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_500",
    "data-name": "Rectangle 500",
    width: 73.504,
    height: 10.1,
    transform: "translate(94.037 416.495)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10322",
    "data-name": "Group 10322"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10321",
    "data-name": "Group 10321"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6391",
    "data-name": "Path 6391",
    d: "M167.666,426.721H93.911V416.369h73.755Zm-73.5-.252h73.253v-9.848H94.162Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10326",
    "data-name": "Group 10326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10325",
    "data-name": "Group 10325"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10324",
    "data-name": "Group 10324"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6392",
    "data-name": "Path 6392",
    d: "M100.852,423.234l10.58,52.2h39.147L160.807,426.6Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10329",
    "data-name": "Group 10329"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10328",
    "data-name": "Group 10328"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10327",
    "data-name": "Group 10327"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6393",
    "data-name": "Path 6393",
    d: "M100.852,470.492l5.643,7.759h47.583l6.729-7.759Z",
    fill: "#455a64"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10333",
    "data-name": "Group 10333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10332",
    "data-name": "Group 10332"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10331",
    "data-name": "Group 10331"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10330",
    "data-name": "Group 10330"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6394",
    "data-name": "Path 6394",
    d: "M128.028,424.758c-.144,0-.329-24.181-.413-54s-.035-54.01.11-54.01.329,24.175.413,54.008S128.173,424.758,128.028,424.758Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10337",
    "data-name": "Group 10337"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10336",
    "data-name": "Group 10336"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10335",
    "data-name": "Group 10335"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10334",
    "data-name": "Group 10334"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6395",
    "data-name": "Path 6395",
    d: "M144.4,364.245a2.575,2.575,0,0,1-.2.562c-.172.411-.39.929-.656,1.565l-.48,1.127-.489,1.373-.567,1.574c-.2.559-.351,1.167-.544,1.8a73.118,73.118,0,0,0-2.055,9,109.277,109.277,0,0,0-1.138,11.254,151.647,151.647,0,0,0,.581,20.558c.236,2.625.474,4.746.649,6.21.075.686.136,1.245.185,1.688a2.494,2.494,0,0,1,.029.594,2.583,2.583,0,0,1-.133-.579c-.075-.439-.168-.994-.283-1.676-.237-1.457-.532-3.574-.816-6.2a135.357,135.357,0,0,1-.736-20.619,102.5,102.5,0,0,1,1.186-11.309,68.055,68.055,0,0,1,2.178-9.029c.205-.629.372-1.237.582-1.795l.608-1.57.532-1.364c.182-.411.367-.779.524-1.114l.748-1.529A2.512,2.512,0,0,1,144.4,364.245Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10341",
    "data-name": "Group 10341"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10340",
    "data-name": "Group 10340"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10339",
    "data-name": "Group 10339"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10338",
    "data-name": "Group 10338"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6396",
    "data-name": "Path 6396",
    d: "M142.523,344.687a4.893,4.893,0,0,1-.234.8l-.765,2.248q-.257.736-.562,1.62-.274.906-.592,1.953c-.429,1.4-.928,2.989-1.371,4.778l-.737,2.8-.689,3.057c-.514,2.1-.884,4.392-1.358,6.78-.81,4.8-1.523,10.112-2.016,15.712-.464,5.605-.666,10.961-.737,15.833-.015,4.872.047,9.263.247,12.944.065,1.842.183,3.505.278,4.966s.176,2.721.269,3.748q.114,1.485.18,2.368a4.9,4.9,0,0,1,.028.83,4.887,4.887,0,0,1-.132-.819q-.105-.881-.278-2.36c-.125-1.025-.247-2.282-.359-3.744s-.267-3.126-.356-4.97c-.248-3.685-.348-8.083-.36-12.967.045-4.883.233-10.253.7-15.873.493-5.616,1.224-10.94,2.062-15.753.488-2.393.876-4.683,1.409-6.79q.373-1.586.721-3.06l.772-2.8c.467-1.788.992-3.376,1.449-4.77q.34-1.041.634-1.944.33-.876.607-1.608.538-1.392.858-2.218A4.9,4.9,0,0,1,142.523,344.687Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10345",
    "data-name": "Group 10345"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10344",
    "data-name": "Group 10344"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10343",
    "data-name": "Group 10343"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10342",
    "data-name": "Group 10342"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6397",
    "data-name": "Path 6397",
    d: "M123.379,429.036a1.152,1.152,0,0,1-.041-.283c-.018-.217-.041-.491-.07-.832-.052-.771-.124-1.842-.216-3.2-.176-2.821-.427-6.835-.737-11.779-.638-9.943-1.561-23.68-3.234-38.787-.855-7.553-1.846-14.727-2.877-21.231-.548-3.246-1.045-6.335-1.609-9.209-.517-2.882-1.074-5.552-1.587-7.989-.483-2.443-1.022-4.631-1.455-6.561s-.837-3.586-1.182-4.936c-.324-1.323-.579-2.366-.763-3.116-.076-.333-.137-.6-.186-.814a1.147,1.147,0,0,1-.046-.282,1.151,1.151,0,0,1,.1.268c.061.209.139.473.236.8.206.744.494,1.779.859,3.092.374,1.343.816,2.991,1.269,4.919s1.025,4.11,1.532,6.551c.537,2.434,1.116,5.1,1.652,7.986.583,2.874,1.1,5.964,1.658,9.213,1.058,6.508,2.066,13.688,2.922,21.25,1.674,15.122,2.539,28.872,3.083,38.823.27,4.977.458,9.005.571,11.79.05,1.363.089,2.436.118,3.208.007.342.013.617.017.834A1.165,1.165,0,0,1,123.379,429.036Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10348",
    "data-name": "Group 10348"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10347",
    "data-name": "Group 10347"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10346",
    "data-name": "Group 10346"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6398",
    "data-name": "Path 6398",
    d: "M127.429,328.369c-.319-3.425-3.781-6.01-7.222-6.045s-6.647,2.028-8.751,4.75a27.359,27.359,0,0,0-4.214,9.352c-2.317,8.071-3.583,16.551-2.593,24.889s4.374,16.547,10.357,22.438c.973.958,2.233,1.916,3.568,1.631a4.3,4.3,0,0,0,1.882-1.163,55.7,55.7,0,0,0,18.076-42.353c-.093-3.171-.509-6.471-2.265-9.113s-5.849-5.446-8.838-4.386",
    fill: "#ff725e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10375",
    "data-name": "Group 10375"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10351",
    "data-name": "Group 10351"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10350",
    "data-name": "Group 10350"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10349",
    "data-name": "Group 10349"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6399",
    "data-name": "Path 6399",
    d: "M101.739,300.93q-2.424,4.388-4.846,8.776c-.113.2-.263.434-.495.453-.255.021-.445-.22-.585-.434L83,290.064l2.951-1.672Z",
    fill: "#ff725e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10355",
    "data-name": "Group 10355",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10354",
    "data-name": "Group 10354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10353",
    "data-name": "Group 10353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10352",
    "data-name": "Group 10352"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6400",
    "data-name": "Path 6400",
    d: "M101.739,300.93q-2.424,4.388-4.846,8.776c-.113.2-.263.434-.495.453-.255.021-.445-.22-.585-.434L83,290.064l2.951-1.672Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10358",
    "data-name": "Group 10358"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10357",
    "data-name": "Group 10357"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10356",
    "data-name": "Group 10356"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6401",
    "data-name": "Path 6401",
    d: "M127.725,316.744l-43.7-25.787a2.036,2.036,0,0,1-1.064-1.074c-.175-.646.311-1.27.777-1.751a30.12,30.12,0,0,1,23.354-9.175,26.683,26.683,0,0,1,21.114,13.131c4.217,7.536,4.356,17.5-.48,24.656",
    fill: "#ff725e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10362",
    "data-name": "Group 10362"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10361",
    "data-name": "Group 10361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10360",
    "data-name": "Group 10360"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10359",
    "data-name": "Group 10359"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6402",
    "data-name": "Path 6402",
    d: "M90.322,282.725a2.389,2.389,0,0,1,.573-.071c.376-.019.933-.087,1.651-.079a32.729,32.729,0,0,1,6.064.481,35.444,35.444,0,0,1,28.285,25.594,32.814,32.814,0,0,1,1.083,5.986,12.06,12.06,0,0,1,.067,1.274,2.142,2.142,0,0,1-.337.953,7.363,7.363,0,0,0,.068-2.206,37.325,37.325,0,0,0-1.237-5.9,35.7,35.7,0,0,0-28-25.331,37.155,37.155,0,0,0-6-.642C91.117,282.747,90.324,282.772,90.322,282.725Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10366",
    "data-name": "Group 10366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10365",
    "data-name": "Group 10365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10364",
    "data-name": "Group 10364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10363",
    "data-name": "Group 10363"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6403",
    "data-name": "Path 6403",
    d: "M121.809,298.945a10.5,10.5,0,0,1-2.209,1c-1.392.549-3.338,1.25-5.514,1.942s-4.171,1.241-5.625,1.6a10.544,10.544,0,0,1-2.383.455,11.766,11.766,0,0,1,2.284-.811l5.566-1.739,5.548-1.791A11.87,11.87,0,0,1,121.809,298.945Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10370",
    "data-name": "Group 10370"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10369",
    "data-name": "Group 10369"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10368",
    "data-name": "Group 10368"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10367",
    "data-name": "Group 10367"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6404",
    "data-name": "Path 6404",
    d: "M114.928,280.46a30.528,30.528,0,0,1,.247,9.77,30.633,30.633,0,0,1-.254-4.882A30.591,30.591,0,0,1,114.928,280.46Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10374",
    "data-name": "Group 10374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10373",
    "data-name": "Group 10373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10372",
    "data-name": "Group 10372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10371",
    "data-name": "Group 10371"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6405",
    "data-name": "Path 6405",
    d: "M83.642,290.468a19.517,19.517,0,0,1,3.175-1.117c1.985-.613,4.75-1.387,7.832-2.131s5.9-1.311,7.945-1.67a19.5,19.5,0,0,1,3.335-.451,23.674,23.674,0,0,1-3.262.814c-2.025.451-4.819,1.076-7.895,1.816s-5.847,1.458-7.854,1.978A23.716,23.716,0,0,1,83.642,290.468Z",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10399",
    "data-name": "Group 10399"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10378",
    "data-name": "Group 10378"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10377",
    "data-name": "Group 10377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10376",
    "data-name": "Group 10376"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6406",
    "data-name": "Path 6406",
    d: "M109.291,320.936c-3.759-2.85-7.733-3.412-12.446-3.225a38.05,38.05,0,0,0-13.622,3.515c-7.369,3.228-14.295,7.985-18.7,14.718s-5.935,15.646-2.639,22.985a3.274,3.274,0,0,0,1.493,1.81,3.563,3.563,0,0,0,2.466-.188c8.381-2.735,16.822-5.494,24.528-9.776s14.72-10.233,18.856-18.019a15.483,15.483,0,0,0,1.984-5.98,7.431,7.431,0,0,0-1.922-5.84",
    fill: "#ff725e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10382",
    "data-name": "Group 10382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10381",
    "data-name": "Group 10381"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10380",
    "data-name": "Group 10380"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10379",
    "data-name": "Group 10379"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6407",
    "data-name": "Path 6407",
    d: "M109.365,320.052a3.1,3.1,0,0,1-.6.245l-1.756.6-1.272.424c-.46.166-.952.372-1.485.579-1.061.429-2.292.857-3.588,1.486l-2.055.936c-.713.329-1.424.734-2.177,1.118-1.52.746-3.056,1.7-4.693,2.666a74.114,74.114,0,0,0-18.489,16.266c-1.167,1.5-2.309,2.9-3.243,4.316-.476.7-.968,1.352-1.385,2.017s-.811,1.307-1.191,1.919C66.639,353.834,66.058,355,65.5,356c-.273.5-.54.964-.763,1.4l-.583,1.207-.822,1.665a3.161,3.161,0,0,1-.32.567,2.92,2.92,0,0,1,.223-.609c.19-.442.434-1.008.735-1.71.166-.375.347-.786.543-1.23s.466-.914.728-1.426c.538-1.014,1.1-2.2,1.872-3.423l1.168-1.947c.411-.675.9-1.338,1.369-2.046.925-1.431,2.06-2.853,3.224-4.372A71.809,71.809,0,0,1,91.483,327.7c1.654-.962,3.209-1.907,4.746-2.641.762-.378,1.482-.775,2.2-1.1l2.08-.91c1.313-.61,2.559-1.017,3.634-1.422.541-.194,1.039-.388,1.506-.54l1.29-.382,1.79-.511A3.066,3.066,0,0,1,109.365,320.052Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10386",
    "data-name": "Group 10386"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10385",
    "data-name": "Group 10385"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10384",
    "data-name": "Group 10384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10383",
    "data-name": "Group 10383"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6408",
    "data-name": "Path 6408",
    d: "M80,335.951A88.136,88.136,0,0,1,70.86,338.9a88.31,88.31,0,0,1-9.29,2.443,88.294,88.294,0,0,1,9.143-2.946A88.133,88.133,0,0,1,80,335.951Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10390",
    "data-name": "Group 10390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10389",
    "data-name": "Group 10389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10388",
    "data-name": "Group 10388"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10387",
    "data-name": "Group 10387"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6409",
    "data-name": "Path 6409",
    d: "M79.626,356.126a14.594,14.594,0,0,1-.2-2.848c-.048-1.761-.056-4.2.019-6.883s.219-5.119.366-6.875a14.523,14.523,0,0,1,.36-2.832,16.412,16.412,0,0,1,.009,2.853c-.059,1.93-.132,4.275-.212,6.868s-.123,4.939-.172,6.869A16.216,16.216,0,0,1,79.626,356.126Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10394",
    "data-name": "Group 10394"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10393",
    "data-name": "Group 10393"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10392",
    "data-name": "Group 10392"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10391",
    "data-name": "Group 10391"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6410",
    "data-name": "Path 6410",
    d: "M96.909,347.322c-.145.01-.6-4.937-1.027-11.048s-.648-11.076-.5-11.086.6,4.936,1.027,11.05S97.053,347.312,96.909,347.322Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10398",
    "data-name": "Group 10398"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10397",
    "data-name": "Group 10397"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10396",
    "data-name": "Group 10396"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10395",
    "data-name": "Group 10395"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6411",
    "data-name": "Path 6411",
    d: "M75.4,324.708a16.373,16.373,0,0,1,2.93-.088c1.807.012,4.3.065,7.055.156s5.247.2,7.051.311a16.37,16.37,0,0,1,2.918.281,16.109,16.109,0,0,1-2.926.089c-1.807-.013-4.3-.066-7.06-.157s-5.25-.2-7.054-.31A16.059,16.059,0,0,1,75.4,324.708Z",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10403",
    "data-name": "Group 10403"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10402",
    "data-name": "Group 10402"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10401",
    "data-name": "Group 10401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10400",
    "data-name": "Group 10400"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6412",
    "data-name": "Path 6412",
    d: "M116.88,384.9a2.489,2.489,0,0,1-.062-.585c-.02-.44-.046-1-.077-1.681-.066-1.46-.081-3.576-.025-6.189s.225-5.723.539-9.167c.341-3.44.833-7.213,1.539-11.144.724-3.928,1.592-7.636,2.487-10.981.919-3.338,1.849-6.317,2.726-8.786s1.63-4.452,2.206-5.8c.271-.631.491-1.145.665-1.551a2.512,2.512,0,0,1,.265-.527,2.481,2.481,0,0,1-.167.565c-.149.415-.339.94-.572,1.585-.518,1.368-1.223,3.363-2.045,5.842s-1.721,5.458-2.612,8.791c-.865,3.341-1.716,7.038-2.438,10.952-.7,3.916-1.208,7.673-1.573,11.1-.34,3.429-.555,6.527-.65,9.133s-.145,4.716-.141,6.174c-.009.685-.016,1.241-.022,1.681A2.468,2.468,0,0,1,116.88,384.9Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10407",
    "data-name": "Group 10407"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10406",
    "data-name": "Group 10406"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10405",
    "data-name": "Group 10405"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10404",
    "data-name": "Group 10404"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6413",
    "data-name": "Path 6413",
    d: "M119.185,356.29a11.9,11.9,0,0,1-1.743,1.913c-1.13,1.128-2.736,2.641-4.567,4.248s-3.544,3-4.809,3.972a12.008,12.008,0,0,1-2.125,1.478,13.476,13.476,0,0,1,1.89-1.764l4.7-4.08,4.659-4.124A13.578,13.578,0,0,1,119.185,356.29Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10411",
    "data-name": "Group 10411"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10410",
    "data-name": "Group 10410"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10409",
    "data-name": "Group 10409"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10408",
    "data-name": "Group 10408"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6414",
    "data-name": "Path 6414",
    d: "M133.018,367.433a20.706,20.706,0,0,1-1.857-2.572l-4.318-6.3-4.409-6.241a20.527,20.527,0,0,1-1.765-2.635,17.956,17.956,0,0,1,2.062,2.413c1.212,1.54,2.833,3.709,4.542,6.164s3.177,4.728,4.2,6.4A17.638,17.638,0,0,1,133.018,367.433Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10415",
    "data-name": "Group 10415"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10414",
    "data-name": "Group 10414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10413",
    "data-name": "Group 10413"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10412",
    "data-name": "Group 10412"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6415",
    "data-name": "Path 6415",
    d: "M125.772,332.39c.078.122-4.517,3.215-10.262,6.909s-10.467,6.59-10.546,6.468,4.516-3.214,10.263-6.909S125.694,332.269,125.772,332.39Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10419",
    "data-name": "Group 10419"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10418",
    "data-name": "Group 10418"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10417",
    "data-name": "Group 10417"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10416",
    "data-name": "Group 10416"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6416",
    "data-name": "Path 6416",
    d: "M138.728,346.374a85.531,85.531,0,0,1-6.95-6.422,85.723,85.723,0,0,1-6.584-6.8,85.414,85.414,0,0,1,6.95,6.423A85.838,85.838,0,0,1,138.728,346.374Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10443",
    "data-name": "Group 10443"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10422",
    "data-name": "Group 10422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10421",
    "data-name": "Group 10421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10420",
    "data-name": "Group 10420"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6417",
    "data-name": "Path 6417",
    d: "M141.986,346.094l3.945-.327a19.517,19.517,0,0,0,7.965-2.438,31.81,31.81,0,0,1,3.713-1.865c4.877-1.958,10.318-1.607,15.566-1.871a64.458,64.458,0,0,0,24.763-6.332,2.41,2.41,0,0,0,1.079-.979c.81-1.476-.695-2.79-1.99-3.588-6.645-4.1-13.41-8.242-20.946-10.274s-16.09-1.689-22.521,2.736c-7.548,5.194-10.3,15.864-11.574,24.938",
    fill: "#ff725e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10426",
    "data-name": "Group 10426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10425",
    "data-name": "Group 10425"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10424",
    "data-name": "Group 10424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10423",
    "data-name": "Group 10423"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6418",
    "data-name": "Path 6418",
    d: "M199.106,331.8a3.79,3.79,0,0,1-.669-.311l-1.87-.979c-1.621-.853-3.956-2.111-6.9-3.526a64.585,64.585,0,0,0-10.689-4.12,35.291,35.291,0,0,0-13.854-1.122,23.677,23.677,0,0,0-12.63,5.424,28.082,28.082,0,0,0-6.576,9.236c-1.386,2.957-2.24,5.472-2.862,7.193-.291.825-.524,1.486-.7,1.989a3.923,3.923,0,0,1-.275.684,3.757,3.757,0,0,1,.175-.716c.154-.512.357-1.184.609-2.022a65.658,65.658,0,0,1,2.719-7.283,27.962,27.962,0,0,1,6.593-9.443,23.944,23.944,0,0,1,12.881-5.581A35.242,35.242,0,0,1,179.1,322.4a62.108,62.108,0,0,1,10.722,4.251c2.94,1.463,5.249,2.772,6.842,3.68l1.822,1.066A3.946,3.946,0,0,1,199.106,331.8Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10430",
    "data-name": "Group 10430"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10429",
    "data-name": "Group 10429"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10428",
    "data-name": "Group 10428"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10427",
    "data-name": "Group 10427"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6419",
    "data-name": "Path 6419",
    d: "M189.633,336.887c-.081.12-5.24-3.218-11.521-7.453s-11.311-7.768-11.23-7.888,5.239,3.216,11.522,7.454S189.714,336.767,189.633,336.887Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10434",
    "data-name": "Group 10434"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10433",
    "data-name": "Group 10433"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10432",
    "data-name": "Group 10432"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10431",
    "data-name": "Group 10431"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6420",
    "data-name": "Path 6420",
    d: "M184.13,321.274a12.533,12.533,0,0,1-3.755.676,12.741,12.741,0,0,1-3.831-.05,24.8,24.8,0,0,1,3.786-.387A25.027,25.027,0,0,1,184.13,321.274Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10438",
    "data-name": "Group 10438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10437",
    "data-name": "Group 10437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10436",
    "data-name": "Group 10436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10435",
    "data-name": "Group 10435"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6421",
    "data-name": "Path 6421",
    d: "M161.547,318.331a10.007,10.007,0,0,1-1.692,2.644,11.334,11.334,0,0,1-2.144,2.436,10,10,0,0,1,1.693-2.644A11.314,11.314,0,0,1,161.547,318.331Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10442",
    "data-name": "Group 10442"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10441",
    "data-name": "Group 10441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10440",
    "data-name": "Group 10440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10439",
    "data-name": "Group 10439"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6422",
    "data-name": "Path 6422",
    d: "M166.169,339.926a13.781,13.781,0,0,1-2.483-1.346c-1.49-.9-3.5-2.23-5.656-3.792s-4.049-3.041-5.413-4.123a15.39,15.39,0,0,1-2.142-1.836,14.857,14.857,0,0,1,2.365,1.54c1.547,1.125,3.423,2.487,5.5,3.994,2.145,1.558,4.115,2.924,5.549,3.906A16.583,16.583,0,0,1,166.169,339.926Z",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10467",
    "data-name": "Group 10467"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10446",
    "data-name": "Group 10446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10445",
    "data-name": "Group 10445"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10444",
    "data-name": "Group 10444"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6423",
    "data-name": "Path 6423",
    d: "M147.794,362.852c-3.762-.994-8.247,2.666-9.022,6.479s.654,7.713,2.329,11.226a57.271,57.271,0,0,0,15.558,20.357c6.737,5.368,15.175,8.8,23.789,8.757-1.591-7.387.421-15.1-.466-22.61a29.411,29.411,0,0,0-26.049-25.791c-2.4-.259-5.181-.636-6.139,1.582",
    fill: "#ff725e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10450",
    "data-name": "Group 10450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10449",
    "data-name": "Group 10449"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10448",
    "data-name": "Group 10448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10447",
    "data-name": "Group 10447"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6424",
    "data-name": "Path 6424",
    d: "M180.448,409.671a2.409,2.409,0,0,1-.535-.249,9.769,9.769,0,0,1-1.408-.944,14.673,14.673,0,0,1-3.714-4.969c-.6-1.164-1.271-2.429-1.926-3.829-.635-1.4-1.313-2.9-2.024-4.475a43.414,43.414,0,0,0-2.487-4.782,37.573,37.573,0,0,0-3.423-4.655c-2.576-3.026-5.34-5.644-7.736-8.144a53.235,53.235,0,0,1-5.9-7.076,25.971,25.971,0,0,1-2.881-5.505,16.655,16.655,0,0,1-.5-1.614,2.513,2.513,0,0,1-.119-.577c.049-.014.262.768.811,2.117a28.479,28.479,0,0,0,3,5.369,55.985,55.985,0,0,0,5.939,6.95c2.406,2.474,5.185,5.084,7.788,8.141a37.083,37.083,0,0,1,3.461,4.726,42.627,42.627,0,0,1,2.49,4.851c.695,1.579,1.357,3.081,1.978,4.491.632,1.394,1.284,2.672,1.861,3.843a15.2,15.2,0,0,0,3.516,4.981C179.735,409.269,180.479,409.621,180.448,409.671Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10454",
    "data-name": "Group 10454"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10453",
    "data-name": "Group 10453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10452",
    "data-name": "Group 10452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10451",
    "data-name": "Group 10451"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6425",
    "data-name": "Path 6425",
    d: "M160.993,403.532a11.31,11.31,0,0,1,.345-2.533c.295-1.549.778-3.676,1.43-5.993s1.351-4.384,1.909-5.86a11.33,11.33,0,0,1,1.027-2.34,13.574,13.574,0,0,1-.677,2.46c-.466,1.5-1.1,3.575-1.755,5.882s-1.187,4.408-1.573,5.932A13.718,13.718,0,0,1,160.993,403.532Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10458",
    "data-name": "Group 10458"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10457",
    "data-name": "Group 10457"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10456",
    "data-name": "Group 10456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10455",
    "data-name": "Group 10455"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6426",
    "data-name": "Path 6426",
    d: "M179.735,385.4a15.493,15.493,0,0,1-2.65-.609c-1.621-.424-3.86-1-6.351-1.565s-4.762-1-6.408-1.309a15.583,15.583,0,0,1-2.656-.585,12.753,12.753,0,0,1,2.715.22c1.666.219,3.96.6,6.465,1.163s4.739,1.2,6.338,1.72A12.8,12.8,0,0,1,179.735,385.4Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10462",
    "data-name": "Group 10462"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10461",
    "data-name": "Group 10461"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10460",
    "data-name": "Group 10460"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10459",
    "data-name": "Group 10459"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6427",
    "data-name": "Path 6427",
    d: "M147.032,390.667a15.288,15.288,0,0,1,.406-2.931c.331-1.8.858-4.265,1.561-6.963s1.453-5.11,2.042-6.838a15.336,15.336,0,0,1,1.077-2.756,17.965,17.965,0,0,1-.724,2.866c-.5,1.753-1.186,4.172-1.888,6.86s-1.283,5.135-1.705,6.908A18.141,18.141,0,0,1,147.032,390.667Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10466",
    "data-name": "Group 10466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10465",
    "data-name": "Group 10465"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10464",
    "data-name": "Group 10464"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10463",
    "data-name": "Group 10463"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6428",
    "data-name": "Path 6428",
    d: "M171.1,369.6c-.016.143-4.712-.237-10.49-.849s-10.45-1.226-10.435-1.37,4.711.236,10.491.849S171.119,369.451,171.1,369.6Z",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10471",
    "data-name": "Group 10471"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10470",
    "data-name": "Group 10470"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10469",
    "data-name": "Group 10469"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10468",
    "data-name": "Group 10468"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6429",
    "data-name": "Path 6429",
    d: "M167.663,426.553c0,.144-16.511.262-36.872.262s-36.876-.118-36.876-.262,16.507-.262,36.876-.262S167.663,426.408,167.663,426.553Z",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10475",
    "data-name": "Group 10475"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10474",
    "data-name": "Group 10474"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10473",
    "data-name": "Group 10473"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10472",
    "data-name": "Group 10472"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6430",
    "data-name": "Path 6430",
    d: "M156.176,447.8c0,.145-11.124.262-24.843.262s-24.846-.117-24.846-.262,11.122-.261,24.846-.261S156.176,447.655,156.176,447.8Z",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10479",
    "data-name": "Group 10479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10478",
    "data-name": "Group 10478"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10477",
    "data-name": "Group 10477"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10476",
    "data-name": "Group 10476"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6431",
    "data-name": "Path 6431",
    d: "M155.744,450.837c0,.145-10.93.262-24.41.262s-24.413-.117-24.413-.262,10.928-.262,24.413-.262S155.744,450.693,155.744,450.837Z",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10483",
    "data-name": "Group 10483"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10482",
    "data-name": "Group 10482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10481",
    "data-name": "Group 10481"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10480",
    "data-name": "Group 10480"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6432",
    "data-name": "Path 6432",
    d: "M156.61,445.3c0,.145-11.507.262-25.7.262s-25.7-.117-25.7-.262,11.5-.262,25.7-.262S156.61,445.151,156.61,445.3Z",
    fill: "#455a64"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10999",
    "data-name": "Group 10999"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10504",
    "data-name": "Group 10504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10498",
    "data-name": "Group 10498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10497",
    "data-name": "Group 10497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10496",
    "data-name": "Group 10496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10495",
    "data-name": "Group 10495"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10487",
    "data-name": "Group 10487"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10486",
    "data-name": "Group 10486"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10485",
    "data-name": "Group 10485"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6433",
    "data-name": "Path 6433",
    d: "M594.74,165.718s-8.013-1.292-12.67,2.433a19.312,19.312,0,0,0-7.335,13.505c-.582,5.123-4.283,24.919-4.283,24.919l-7.243-9.783-7.981,7.006s6.738,32.3,13.064,34.476,13.2-4.925,14.826-6.206S594.74,165.718,594.74,165.718Z",
    fill: "#ff725e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10490",
    "data-name": "Group 10490"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10489",
    "data-name": "Group 10489"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10488",
    "data-name": "Group 10488"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6434",
    "data-name": "Path 6434",
    d: "M592.028,165.507s-10.515,15-11.733,18.833-10.087,10.763-9.92,19.845a87.411,87.411,0,0,0,1.108,12.355,19.2,19.2,0,0,1-.136,7.005l-4.1,19.794a12.092,12.092,0,0,0,9.05,5.221c6.439.7,22.853,4.57,33.763,0l7.831-3.829V214.1l5.4-12.531,15.355-24.887s-7.841-5.43-15.157-7.777C615.792,166.439,603.353,166.221,592.028,165.507Z",
    fill: "#ff725e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10494",
    "data-name": "Group 10494"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10493",
    "data-name": "Group 10493"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10492",
    "data-name": "Group 10492"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10491",
    "data-name": "Group 10491"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6435",
    "data-name": "Path 6435",
    d: "M568.061,239.388a3.882,3.882,0,0,1,.094-.693l.361-1.966,1.418-7.217c.261-1.531.758-3.161,1.007-4.96q.105-.674.212-1.368.06-.7.122-1.421a26.922,26.922,0,0,0,.075-2.97,26.608,26.608,0,0,0-1.064-6.28,21.539,21.539,0,0,1-1.175-6.849,19.511,19.511,0,0,1,1.724-6.743,43.374,43.374,0,0,1,3.026-5.715c2.175-3.5,4.373-6.475,6.182-9l4.3-5.96,1.169-1.621a3.759,3.759,0,0,1,.434-.547,3.783,3.783,0,0,1-.353.6l-1.094,1.674c-.965,1.443-2.392,3.512-4.176,6.051s-3.939,5.543-6.079,9.031a43.983,43.983,0,0,0-2.97,5.667,19.21,19.21,0,0,0-1.677,6.574,21.322,21.322,0,0,0,1.149,6.708,24.34,24.34,0,0,1,.956,9.407q-.069.73-.136,1.44-.114.7-.227,1.381c-.268,1.815-.788,3.448-1.069,4.973-.654,2.992-1.186,5.431-1.568,7.178l-.45,1.947A3.637,3.637,0,0,1,568.061,239.388Z",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10501",
    "data-name": "Group 10501"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10500",
    "data-name": "Group 10500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10499",
    "data-name": "Group 10499"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6436",
    "data-name": "Path 6436",
    d: "M633.5,173.5s19.151,6.852,11.881,30.731c-5.788,19.015-17.684,41.705-25.209,42.155-3.909.234-8.167.087-10.823-2.006-10.766-8.483-17.319-31.226-17.319-31.226l10.3-11.506,12.481,18.5c1.4-.6,9.71-26.209,9.71-26.209S630.489,174.3,633.5,173.5Z",
    fill: "#ff725e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10503",
    "data-name": "Group 10503"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10502",
    "data-name": "Group 10502"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6437",
    "data-name": "Path 6437",
    d: "M624.4,196.074a2.448,2.448,0,0,1-.135.459l-.457,1.313-1.8,4.952c-1.593,4.291-3.84,10.347-6.525,17.582l-.154.414-.248-.367L602.573,201.95l.4.036-1.266,1.3-9.5,9.707.059-.252a120.427,120.427,0,0,0,4.978,13.669,63.83,63.83,0,0,0,5.542,10.061,54.612,54.612,0,0,0,4.684,5.935l1.409,1.455a4.351,4.351,0,0,1,.468.526,4.185,4.185,0,0,1-.529-.463l-1.471-1.4a49.49,49.49,0,0,1-4.822-5.872,62.154,62.154,0,0,1-5.674-10.064,117.049,117.049,0,0,1-5.062-13.693l-.045-.144.1-.108,9.487-9.72,1.266-1.3.224-.228.178.265,12.454,18.513-.4.047,6.7-17.516c.813-2.082,1.458-3.734,1.917-4.907.217-.537.39-.963.522-1.288A2.389,2.389,0,0,1,624.4,196.074Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10618",
    "data-name": "Group 10618"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10617",
    "data-name": "Group 10617"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10616",
    "data-name": "Group 10616"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10615",
    "data-name": "Group 10615"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10519",
    "data-name": "Group 10519"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10518",
    "data-name": "Group 10518"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10517",
    "data-name": "Group 10517"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10516",
    "data-name": "Group 10516"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10515",
    "data-name": "Group 10515"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10514",
    "data-name": "Group 10514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10513",
    "data-name": "Group 10513"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10512",
    "data-name": "Group 10512"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10511",
    "data-name": "Group 10511"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10510",
    "data-name": "Group 10510"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10509",
    "data-name": "Group 10509"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10508",
    "data-name": "Group 10508"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10507",
    "data-name": "Group 10507"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10506",
    "data-name": "Group 10506"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10505",
    "data-name": "Group 10505"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6438",
    "data-name": "Path 6438",
    d: "M577.814,446.854l1.276,19.456s-19.348,7.831-19.463,11.45l37.815-1.118-.744-30.4Z",
    fill: "#ff725e"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10535",
    "data-name": "Group 10535"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10534",
    "data-name": "Group 10534"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10533",
    "data-name": "Group 10533"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10532",
    "data-name": "Group 10532"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10531",
    "data-name": "Group 10531"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10530",
    "data-name": "Group 10530"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10529",
    "data-name": "Group 10529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10528",
    "data-name": "Group 10528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10527",
    "data-name": "Group 10527"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10526",
    "data-name": "Group 10526"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10525",
    "data-name": "Group 10525"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10524",
    "data-name": "Group 10524"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10523",
    "data-name": "Group 10523"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10522",
    "data-name": "Group 10522"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10521",
    "data-name": "Group 10521"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10520",
    "data-name": "Group 10520"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6439",
    "data-name": "Path 6439",
    d: "M590.734,464.326a1.545,1.545,0,0,1,1.12,1.731,1.485,1.485,0,0,1-1.706,1.125,1.63,1.63,0,0,1-1.176-1.839,1.542,1.542,0,0,1,1.9-.974",
    fill: "#e0e0e0"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10550",
    "data-name": "Group 10550"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10549",
    "data-name": "Group 10549"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10548",
    "data-name": "Group 10548"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10547",
    "data-name": "Group 10547"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10546",
    "data-name": "Group 10546"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10545",
    "data-name": "Group 10545"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10544",
    "data-name": "Group 10544"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10543",
    "data-name": "Group 10543"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10542",
    "data-name": "Group 10542"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10541",
    "data-name": "Group 10541"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10540",
    "data-name": "Group 10540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10539",
    "data-name": "Group 10539"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10538",
    "data-name": "Group 10538"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10537",
    "data-name": "Group 10537"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10536",
    "data-name": "Group 10536"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6440",
    "data-name": "Path 6440",
    d: "M597.505,477.98l-.082-3.488L561.064,475.8s-1.662.782-1.437,1.962Z",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10566",
    "data-name": "Group 10566"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10565",
    "data-name": "Group 10565"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10564",
    "data-name": "Group 10564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10563",
    "data-name": "Group 10563"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10562",
    "data-name": "Group 10562"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10561",
    "data-name": "Group 10561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10560",
    "data-name": "Group 10560"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10559",
    "data-name": "Group 10559"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10558",
    "data-name": "Group 10558"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10557",
    "data-name": "Group 10557"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10556",
    "data-name": "Group 10556"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10555",
    "data-name": "Group 10555"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10554",
    "data-name": "Group 10554"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10553",
    "data-name": "Group 10553"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10552",
    "data-name": "Group 10552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10551",
    "data-name": "Group 10551"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6441",
    "data-name": "Path 6441",
    d: "M578.471,466.136c.012.185.938.241,1.864.808.941.543,1.433,1.329,1.6,1.25.17-.041-.138-1.136-1.272-1.8S578.426,465.968,578.471,466.136Z",
    fill: "#263238"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10582",
    "data-name": "Group 10582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10581",
    "data-name": "Group 10581"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10580",
    "data-name": "Group 10580"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10579",
    "data-name": "Group 10579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10578",
    "data-name": "Group 10578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10577",
    "data-name": "Group 10577"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10576",
    "data-name": "Group 10576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10575",
    "data-name": "Group 10575"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10574",
    "data-name": "Group 10574"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10573",
    "data-name": "Group 10573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10572",
    "data-name": "Group 10572"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10571",
    "data-name": "Group 10571"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10570",
    "data-name": "Group 10570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10569",
    "data-name": "Group 10569"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10568",
    "data-name": "Group 10568"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10567",
    "data-name": "Group 10567"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6442",
    "data-name": "Path 6442",
    d: "M574.554,467.894c-.037.18.772.47,1.422,1.233.673.743.856,1.583,1.039,1.57.175.023.271-1.062-.556-1.994S574.552,467.718,574.554,467.894Z",
    fill: "#263238"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10598",
    "data-name": "Group 10598"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10597",
    "data-name": "Group 10597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10596",
    "data-name": "Group 10596"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10595",
    "data-name": "Group 10595"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10594",
    "data-name": "Group 10594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10593",
    "data-name": "Group 10593"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10592",
    "data-name": "Group 10592"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10591",
    "data-name": "Group 10591"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10590",
    "data-name": "Group 10590"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10589",
    "data-name": "Group 10589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10588",
    "data-name": "Group 10588"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10587",
    "data-name": "Group 10587"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10586",
    "data-name": "Group 10586"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10585",
    "data-name": "Group 10585"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10584",
    "data-name": "Group 10584"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10583",
    "data-name": "Group 10583"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6443",
    "data-name": "Path 6443",
    d: "M572.441,472.707c.169.035.4-.895-.1-1.892s-1.38-1.375-1.453-1.219c-.1.155.477.681.878,1.507C572.182,471.918,572.257,472.7,572.441,472.707Z",
    fill: "#263238"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10614",
    "data-name": "Group 10614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10613",
    "data-name": "Group 10613"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10612",
    "data-name": "Group 10612"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10611",
    "data-name": "Group 10611"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10610",
    "data-name": "Group 10610"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10609",
    "data-name": "Group 10609"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10608",
    "data-name": "Group 10608"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10607",
    "data-name": "Group 10607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10606",
    "data-name": "Group 10606"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10605",
    "data-name": "Group 10605"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10604",
    "data-name": "Group 10604"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10603",
    "data-name": "Group 10603"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10602",
    "data-name": "Group 10602"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10601",
    "data-name": "Group 10601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10600",
    "data-name": "Group 10600"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10599",
    "data-name": "Group 10599"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6444",
    "data-name": "Path 6444",
    d: "M578.673,461.67c.082.166.922-.114,1.967-.074,1.047.019,1.869.345,1.961.184.1-.137-.71-.8-1.943-.827S578.578,461.527,578.673,461.67Z",
    fill: "#263238"
  }))))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10732",
    "data-name": "Group 10732"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10731",
    "data-name": "Group 10731"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10730",
    "data-name": "Group 10730"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10729",
    "data-name": "Group 10729"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10633",
    "data-name": "Group 10633"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10632",
    "data-name": "Group 10632"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10631",
    "data-name": "Group 10631"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10630",
    "data-name": "Group 10630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10629",
    "data-name": "Group 10629"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10628",
    "data-name": "Group 10628"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10627",
    "data-name": "Group 10627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10626",
    "data-name": "Group 10626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10625",
    "data-name": "Group 10625"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10624",
    "data-name": "Group 10624"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10623",
    "data-name": "Group 10623"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10622",
    "data-name": "Group 10622"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10621",
    "data-name": "Group 10621"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10620",
    "data-name": "Group 10620"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10619",
    "data-name": "Group 10619"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6445",
    "data-name": "Path 6445",
    d: "M612.654,447.23l1.109,19.467s-19.415,7.666-19.56,11.283l37.823-.8-.484-30.4Z",
    fill: "#ff725e"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10649",
    "data-name": "Group 10649"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10648",
    "data-name": "Group 10648"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10647",
    "data-name": "Group 10647"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10646",
    "data-name": "Group 10646"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10645",
    "data-name": "Group 10645"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10644",
    "data-name": "Group 10644"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10643",
    "data-name": "Group 10643"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10642",
    "data-name": "Group 10642"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10641",
    "data-name": "Group 10641"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10640",
    "data-name": "Group 10640"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10639",
    "data-name": "Group 10639"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10638",
    "data-name": "Group 10638"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10637",
    "data-name": "Group 10637"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10636",
    "data-name": "Group 10636"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10635",
    "data-name": "Group 10635"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10634",
    "data-name": "Group 10634"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6446",
    "data-name": "Path 6446",
    d: "M625.424,464.812a1.545,1.545,0,0,1,1.1,1.74,1.484,1.484,0,0,1-1.715,1.111,1.631,1.631,0,0,1-1.161-1.849,1.541,1.541,0,0,1,1.912-.957",
    fill: "#e0e0e0"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10664",
    "data-name": "Group 10664"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10663",
    "data-name": "Group 10663"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10662",
    "data-name": "Group 10662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10661",
    "data-name": "Group 10661"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10660",
    "data-name": "Group 10660"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10659",
    "data-name": "Group 10659"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10658",
    "data-name": "Group 10658"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10657",
    "data-name": "Group 10657"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10656",
    "data-name": "Group 10656"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10655",
    "data-name": "Group 10655"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10654",
    "data-name": "Group 10654"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10653",
    "data-name": "Group 10653"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10652",
    "data-name": "Group 10652"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10651",
    "data-name": "Group 10651"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10650",
    "data-name": "Group 10650"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6447",
    "data-name": "Path 6447",
    d: "M632.07,477.98l-.044-2.946-36.37,1s-1.668.768-1.453,1.95Z",
    fill: "#263238"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10680",
    "data-name": "Group 10680"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10679",
    "data-name": "Group 10679"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10678",
    "data-name": "Group 10678"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10677",
    "data-name": "Group 10677"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10676",
    "data-name": "Group 10676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10675",
    "data-name": "Group 10675"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10674",
    "data-name": "Group 10674"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10673",
    "data-name": "Group 10673"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10672",
    "data-name": "Group 10672"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10671",
    "data-name": "Group 10671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10670",
    "data-name": "Group 10670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10669",
    "data-name": "Group 10669"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10668",
    "data-name": "Group 10668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10667",
    "data-name": "Group 10667"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10666",
    "data-name": "Group 10666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10665",
    "data-name": "Group 10665"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6448",
    "data-name": "Path 6448",
    d: "M613.146,466.517c.01.185.935.249,1.856.824.937.551,1.422,1.341,1.59,1.264.17-.039-.129-1.137-1.256-1.814S613.1,466.349,613.146,466.517Z",
    fill: "#263238"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10696",
    "data-name": "Group 10696"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10695",
    "data-name": "Group 10695"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10694",
    "data-name": "Group 10694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10693",
    "data-name": "Group 10693"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10692",
    "data-name": "Group 10692"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10691",
    "data-name": "Group 10691"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10690",
    "data-name": "Group 10690"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10689",
    "data-name": "Group 10689"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10688",
    "data-name": "Group 10688"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10687",
    "data-name": "Group 10687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10686",
    "data-name": "Group 10686"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10685",
    "data-name": "Group 10685"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10684",
    "data-name": "Group 10684"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10683",
    "data-name": "Group 10683"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10682",
    "data-name": "Group 10682"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10681",
    "data-name": "Group 10681"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6449",
    "data-name": "Path 6449",
    d: "M609.213,468.242c-.038.18.768.477,1.412,1.245.666.749.842,1.59,1.026,1.578.174.026.279-1.059-.539-2S609.214,468.066,609.213,468.242Z",
    fill: "#263238"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10712",
    "data-name": "Group 10712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10711",
    "data-name": "Group 10711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10710",
    "data-name": "Group 10710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10709",
    "data-name": "Group 10709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10708",
    "data-name": "Group 10708"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10707",
    "data-name": "Group 10707"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10706",
    "data-name": "Group 10706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10705",
    "data-name": "Group 10705"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10704",
    "data-name": "Group 10704"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10703",
    "data-name": "Group 10703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10702",
    "data-name": "Group 10702"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10701",
    "data-name": "Group 10701"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10700",
    "data-name": "Group 10700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10699",
    "data-name": "Group 10699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10698",
    "data-name": "Group 10698"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10697",
    "data-name": "Group 10697"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6450",
    "data-name": "Path 6450",
    d: "M607.06,473.037c.169.036.406-.892-.089-1.894s-1.368-1.386-1.443-1.23c-.1.154.471.685.866,1.513C606.807,472.245,606.876,473.023,607.06,473.037Z",
    fill: "#263238"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10728",
    "data-name": "Group 10728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10727",
    "data-name": "Group 10727"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10726",
    "data-name": "Group 10726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10725",
    "data-name": "Group 10725"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10724",
    "data-name": "Group 10724"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10723",
    "data-name": "Group 10723"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10722",
    "data-name": "Group 10722"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10721",
    "data-name": "Group 10721"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10720",
    "data-name": "Group 10720"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10719",
    "data-name": "Group 10719"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10718",
    "data-name": "Group 10718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10717",
    "data-name": "Group 10717"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10716",
    "data-name": "Group 10716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10715",
    "data-name": "Group 10715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10714",
    "data-name": "Group 10714"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10713",
    "data-name": "Group 10713"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6451",
    "data-name": "Path 6451",
    d: "M613.385,462.053c.081.167.923-.106,1.969-.057,1.046.028,1.866.361,1.959.2.1-.136-.7-.8-1.936-.843S613.292,461.91,613.385,462.053Z",
    fill: "#263238"
  }))))))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10801",
    "data-name": "Group 10801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10734",
    "data-name": "Group 10734"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10733",
    "data-name": "Group 10733"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6452",
    "data-name": "Path 6452",
    d: "M618.426,244.066s9.634,10.111,14.69,22.556,2.835,72.361,2.835,72.361l-1.059,31.412s1.525,27,.358,46.247-2.475,40.576-2.475,40.576l-21,1.008L589.487,294.987l5.575,75.282c3.548,19.2,3.13,53.07,2.443,87.933l-22.247.024s-7.662-52.106-9.409-64.483c-1.974-13.988-7.794-52.463-7.794-52.463s-4.483-36.816-2.927-56.65S568.5,237.065,568.892,235.9l47.5,8.556",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10800",
    "data-name": "Group 10800"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10736",
    "data-name": "Group 10736"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10735",
    "data-name": "Group 10735"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6453",
    "data-name": "Path 6453",
    d: "M620.85,238.792l5.573,14.824s41.412,57.776,40.209,62.591-23.773,23.472-30.393,20.462-23.773-15.347-29.491-27.685-21.967-46.943-21.967-46.943l-5.116-9.63,5.718-3.912Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10737",
    "data-name": "Group 10737"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6454",
    "data-name": "Path 6454",
    d: "M568.516,236.729h0c5.018,2.692,4.485,11.109,9.5,13.8-8.373,11.725-11.237,26.489-12.378,40.851s-.786,28.909-3.666,43.026l-10.4-.731a244.472,244.472,0,0,1,8.864-82.409A36.234,36.234,0,0,1,568.516,236.729Z",
    fill: "#455a64"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10740",
    "data-name": "Group 10740"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10739",
    "data-name": "Group 10739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10738",
    "data-name": "Group 10738"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6455",
    "data-name": "Path 6455",
    d: "M609.027,261.04a11.845,11.845,0,0,0,2.62-.6,55.316,55.316,0,0,0,11.9-5.115,11.791,11.791,0,0,0,2.239-1.486A16.793,16.793,0,0,0,623.367,255c-1.469.752-3.515,1.758-5.826,2.753s-4.449,1.785-6.006,2.334A16.918,16.918,0,0,0,609.027,261.04Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10743",
    "data-name": "Group 10743",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10742",
    "data-name": "Group 10742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10741",
    "data-name": "Group 10741"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6456",
    "data-name": "Path 6456",
    d: "M635.885,305.027l1,.073a24.46,24.46,0,0,1-27.217,5c-3.036-1.424-6.052-4.056-5.916-7.406A61.119,61.119,0,0,0,635.885,305.027Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10759",
    "data-name": "Group 10759"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10749",
    "data-name": "Group 10749"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10745",
    "data-name": "Group 10745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10744",
    "data-name": "Group 10744"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6457",
    "data-name": "Path 6457",
    d: "M584.166,252.451c3.871-.711,11.3,1.315,14.024,4.16s4.353,6.542,5.693,10.242c2.905,8.02,4.972,16.9,11.276,22.648,5.93,5.4,14.359,6.854,22.29,8.074.215,2.929.181,6.419-2.229,8.1a7.69,7.69,0,0,1-2.394.993,39.153,39.153,0,0,1-7.208,1.279c-11.291.927-23.252-3.618-29.879-12.807-8.383-11.622-9.045-25.587-13.786-39.109",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10748",
    "data-name": "Group 10748"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10747",
    "data-name": "Group 10747"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10746",
    "data-name": "Group 10746"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6458",
    "data-name": "Path 6458",
    d: "M581.953,256.029a2.667,2.667,0,0,0,.114.427c.093.3.22.71.384,1.236.349,1.081.822,2.691,1.382,4.777s1.192,4.652,1.916,7.636,1.543,6.387,2.684,10.088a54.788,54.788,0,0,0,4.939,11.653,33.861,33.861,0,0,0,4.1,5.765,29.892,29.892,0,0,0,5.673,4.912,35.311,35.311,0,0,0,15.03,5.491,37.506,37.506,0,0,0,8.518.085,39.218,39.218,0,0,0,4.3-.712c.716-.158,1.427-.34,2.139-.54a7.746,7.746,0,0,0,2.1-.872,4.957,4.957,0,0,0,1.62-1.76,7.327,7.327,0,0,0,.744-2.214,18.127,18.127,0,0,0,.109-4.445l-.014-.2-.2-.031c-5.3-.816-10.491-1.695-15.113-3.632a24.505,24.505,0,0,1-6.284-3.711,23.308,23.308,0,0,1-4.609-5.225,53.179,53.179,0,0,1-5.282-11.787,102.556,102.556,0,0,0-3.958-10.563,25.026,25.026,0,0,0-2.523-4.222,18.824,18.824,0,0,0-1.475-1.719,9.2,9.2,0,0,0-1.693-1.3,21.308,21.308,0,0,0-6.513-2.453,18.237,18.237,0,0,0-4.36-.443,7.022,7.022,0,0,0-1.512.186c.005.034.519-.082,1.514-.089a19.216,19.216,0,0,1,4.318.53,21.459,21.459,0,0,1,6.409,2.5,8.951,8.951,0,0,1,1.629,1.275,18.6,18.6,0,0,1,1.435,1.7,24.924,24.924,0,0,1,2.459,4.184,104.338,104.338,0,0,1,3.884,10.547A53.178,53.178,0,0,0,611.1,285a23.683,23.683,0,0,0,4.688,5.344,24.95,24.95,0,0,0,6.4,3.8c4.691,1.974,9.918,2.862,15.226,3.683l-.217-.234a17.652,17.652,0,0,1-.1,4.316,5.208,5.208,0,0,1-2.137,3.633,14.483,14.483,0,0,1-4.069,1.342,38.945,38.945,0,0,1-4.248.7,37.109,37.109,0,0,1-8.4-.076,34.931,34.931,0,0,1-14.831-5.386,29.507,29.507,0,0,1-5.6-4.82,33.512,33.512,0,0,1-4.065-5.677,54.9,54.9,0,0,1-4.961-11.547c-1.159-3.679-2-7.074-2.752-10.049s-1.4-5.541-2-7.619-1.095-3.684-1.477-4.757c-.184-.519-.327-.924-.432-1.221A2.847,2.847,0,0,0,581.953,256.029Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10752",
    "data-name": "Group 10752"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10751",
    "data-name": "Group 10751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10750",
    "data-name": "Group 10750"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6459",
    "data-name": "Path 6459",
    d: "M628.609,307.4a12.739,12.739,0,0,1,1.159-11.171,3.943,3.943,0,0,0-1.091,1.369,10.236,10.236,0,0,0-.855,8.238A3.951,3.951,0,0,0,628.609,307.4Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10755",
    "data-name": "Group 10755"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10754",
    "data-name": "Group 10754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10753",
    "data-name": "Group 10753"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6460",
    "data-name": "Path 6460",
    d: "M628.325,300.194a38.607,38.607,0,0,0,8.884.6,38.752,38.752,0,0,0-8.884-.6Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10758",
    "data-name": "Group 10758"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10757",
    "data-name": "Group 10757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10756",
    "data-name": "Group 10756"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6461",
    "data-name": "Path 6461",
    d: "M627.491,303.423a41.339,41.339,0,0,0,9.213.193,41.339,41.339,0,0,0-9.213-.193Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10775",
    "data-name": "Group 10775"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10765",
    "data-name": "Group 10765"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10761",
    "data-name": "Group 10761"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10760",
    "data-name": "Group 10760"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6462",
    "data-name": "Path 6462",
    d: "M574.651,254.963c-6.933,6.259-9.525,16.183-9.271,25.52s2.967,18.4,5.053,27.509,3.549,18.662,1.307,27.73L580.63,337a37.343,37.343,0,0,0,9.852-29.116c-.912-8.707-4.866-16.749-7.7-25.031s-4.515-17.624-.943-25.616",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10764",
    "data-name": "Group 10764"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10763",
    "data-name": "Group 10763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10762",
    "data-name": "Group 10762"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6463",
    "data-name": "Path 6463",
    d: "M581.838,257.233a2.737,2.737,0,0,0-.184.389l-.491,1.166a24.753,24.753,0,0,0-1.189,4.722,31.47,31.47,0,0,0-.082,7.718,52.1,52.1,0,0,0,2.173,10.013c1.141,3.631,2.689,7.5,4.24,11.694a65.752,65.752,0,0,1,3.786,13.716,36.576,36.576,0,0,1-1.27,15.581,37.036,37.036,0,0,1-8.378,14.587l.224-.078-4.369-.626-4.521-.648.213.316a47.284,47.284,0,0,0,.656-17.053,133.916,133.916,0,0,0-3.116-15.546c-1.2-4.892-2.338-9.532-3.059-13.931a59.287,59.287,0,0,1-.871-12.314,34.742,34.742,0,0,1,4.939-16.931,26.724,26.724,0,0,1,2.938-3.833l.884-.894a2.7,2.7,0,0,0,.29-.318,2.855,2.855,0,0,0-.325.28c-.223.21-.529.5-.921.863a24.9,24.9,0,0,0-3.03,3.8,34.523,34.523,0,0,0-5.129,17.018,59.178,59.178,0,0,0,.812,12.4c.706,4.423,1.832,9.08,3.018,13.974a134.977,134.977,0,0,1,3.075,15.5,46.938,46.938,0,0,1-.661,16.869l-.067.276.281.04,4.521.649,4.369.625.132.019.091-.1a37.463,37.463,0,0,0,8.482-14.8,36.943,36.943,0,0,0,1.255-15.789,65.767,65.767,0,0,0-3.857-13.8c-1.572-4.193-3.136-8.049-4.293-11.655a52.526,52.526,0,0,1-2.233-9.936,31.861,31.861,0,0,1,0-7.661,26.425,26.425,0,0,1,1.091-4.715c.188-.5.336-.893.443-1.18C581.8,257.375,581.838,257.233,581.838,257.233Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10768",
    "data-name": "Group 10768"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10767",
    "data-name": "Group 10767"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10766",
    "data-name": "Group 10766"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6464",
    "data-name": "Path 6464",
    d: "M573.192,328.566a26.909,26.909,0,0,1,12.226,1.638,5.146,5.146,0,0,0-1.627-.885,17.538,17.538,0,0,0-8.8-1.179A5.134,5.134,0,0,0,573.192,328.566Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10771",
    "data-name": "Group 10771"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10770",
    "data-name": "Group 10770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10769",
    "data-name": "Group 10769"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6465",
    "data-name": "Path 6465",
    d: "M578.366,336.762a32.552,32.552,0,0,0,3.714-7.274,32.552,32.552,0,0,0-3.714,7.274Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10774",
    "data-name": "Group 10774"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10773",
    "data-name": "Group 10773"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10772",
    "data-name": "Group 10772"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6466",
    "data-name": "Path 6466",
    d: "M573.721,336.1a34.9,34.9,0,0,0,3.363-7.774,34.951,34.951,0,0,0-3.363,7.774Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10787",
    "data-name": "Group 10787"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10778",
    "data-name": "Group 10778"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10777",
    "data-name": "Group 10777"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10776",
    "data-name": "Group 10776"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6467",
    "data-name": "Path 6467",
    d: "M586.479,252.058c.061.019.207-.194.28-.6a2.887,2.887,0,0,0-1.2-2.78c-.342-.223-.6-.263-.625-.205-.069.13.73.621,1.148,1.629C586.527,251.1,586.337,252.019,586.479,252.058Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10780",
    "data-name": "Group 10780"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10779",
    "data-name": "Group 10779"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6468",
    "data-name": "Path 6468",
    d: "M574.921,249.891c1.2-1.887,4.042-2.523,6.263-2.789a5.455,5.455,0,0,1,5.614,4.8,6.028,6.028,0,0,1-4.373,6.139,6.747,6.747,0,0,1-7.141-2.806A5.042,5.042,0,0,1,574.921,249.891Z",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10783",
    "data-name": "Group 10783"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10782",
    "data-name": "Group 10782"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10781",
    "data-name": "Group 10781"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6469",
    "data-name": "Path 6469",
    d: "M579.908,248.154c-.032-.042-.628.384-1.183,1.4a5.941,5.941,0,0,0,2.123,7.92,3.166,3.166,0,0,0,1.724.619c.028-.084-.644-.28-1.521-.921a6.019,6.019,0,0,1-2-7.458C579.49,248.718,579.974,248.212,579.908,248.154Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10786",
    "data-name": "Group 10786"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10785",
    "data-name": "Group 10785"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10784",
    "data-name": "Group 10784"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6470",
    "data-name": "Path 6470",
    d: "M575.48,249.18c-.045-.036-.388.273-.715.933a5.349,5.349,0,0,0,.576,5.45c.458.577.858.807.9.762.056-.061-.245-.381-.6-.968a6.164,6.164,0,0,1-.54-5.106C575.321,249.6,575.548,249.228,575.48,249.18Z",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10790",
    "data-name": "Group 10790",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10789",
    "data-name": "Group 10789"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10788",
    "data-name": "Group 10788"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6471",
    "data-name": "Path 6471",
    d: "M574.8,254.951a9.205,9.205,0,0,0,6.756,3.078,4.642,4.642,0,0,1-3.495,2.417,3.587,3.587,0,0,1-3.261-5.5Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10793",
    "data-name": "Group 10793",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10792",
    "data-name": "Group 10792"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10791",
    "data-name": "Group 10791"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6472",
    "data-name": "Path 6472",
    d: "M606.437,263.66a8.07,8.07,0,0,1,3.713-2.161c5.151-1.86,10.707-5.042,15.857-6.9-4.7,4.167-9.787,9.083-15.177,12.306-1.3.778-3,1.519-4.237.637C605.412,266.7,605.524,264.788,606.437,263.66Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10796",
    "data-name": "Group 10796",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10795",
    "data-name": "Group 10795"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10794",
    "data-name": "Group 10794"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6473",
    "data-name": "Path 6473",
    d: "M563.774,272.923c.8-6.186,3.662-12.29,8.653-16.032-2.683,4.888-5.4,9.86-6.6,15.305-1.316,5.982-.349,9.806.246,15.9L565.5,291.1A45.1,45.1,0,0,1,563.774,272.923Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10799",
    "data-name": "Group 10799"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10798",
    "data-name": "Group 10798"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10797",
    "data-name": "Group 10797"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6474",
    "data-name": "Path 6474",
    d: "M609.218,267.941a3,3,0,0,0,.8-.392c.5-.279,1.2-.712,2.057-1.272a62.492,62.492,0,0,0,12.054-10.411c.679-.763,1.21-1.4,1.558-1.849a2.96,2.96,0,0,0,.5-.734,27.941,27.941,0,0,0-2.328,2.335c-1.416,1.458-3.421,3.423-5.765,5.45s-4.582,3.72-6.23,4.909A28.063,28.063,0,0,0,609.218,267.941Z",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10966",
    "data-name": "Group 10966"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10965",
    "data-name": "Group 10965"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10960",
    "data-name": "Group 10960"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10804",
    "data-name": "Group 10804"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10803",
    "data-name": "Group 10803"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10802",
    "data-name": "Group 10802"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6475",
    "data-name": "Path 6475",
    d: "M583.78,118.31c-1.5-2.671-.568-6.256,1.644-8.371a11.758,11.758,0,0,1,8.481-2.841,34.906,34.906,0,0,1,8.965,1.851,9.769,9.769,0,0,1,17.14,3.236,6.209,6.209,0,0,1,8.344,7.139l-12.96,6.532-11.446,28.01a11.963,11.963,0,0,1-19.505-13.509,10.26,10.26,0,0,1-2.417-2.306,10.48,10.48,0,0,1-5.633-5.8C574.358,126.679,578.03,119.751,583.78,118.31Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10944",
    "data-name": "Group 10944"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10912",
    "data-name": "Group 10912"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10911",
    "data-name": "Group 10911"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10906",
    "data-name": "Group 10906"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10905",
    "data-name": "Group 10905"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10904",
    "data-name": "Group 10904"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10903",
    "data-name": "Group 10903"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10882",
    "data-name": "Group 10882"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10881",
    "data-name": "Group 10881"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10880",
    "data-name": "Group 10880"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10814",
    "data-name": "Group 10814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10813",
    "data-name": "Group 10813"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10812",
    "data-name": "Group 10812"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10811",
    "data-name": "Group 10811"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10810",
    "data-name": "Group 10810"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10809",
    "data-name": "Group 10809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10808",
    "data-name": "Group 10808"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10807",
    "data-name": "Group 10807"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10806",
    "data-name": "Group 10806"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10805",
    "data-name": "Group 10805"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6476",
    "data-name": "Path 6476",
    d: "M599.913,168.863a39.147,39.147,0,0,1,.411-4.639s-8.411-2.079-9.311-13.334c-.447-5.6.537-14.641,1.582-22.015.94-6.637,6-14.475,12.587-13.255l20.343,6.862c2,.371,2.573,2.132,2.375,4.159l.093.963-3.447,31.764-1.066,9.538c-.631,6.037-6.054,12.179-12.124,12.089h0A11.342,11.342,0,0,1,599.913,168.863Z",
    fill: "#9f7362"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10836",
    "data-name": "Group 10836"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10824",
    "data-name": "Group 10824"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10823",
    "data-name": "Group 10823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10822",
    "data-name": "Group 10822"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10821",
    "data-name": "Group 10821"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10820",
    "data-name": "Group 10820"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10819",
    "data-name": "Group 10819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10818",
    "data-name": "Group 10818"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10817",
    "data-name": "Group 10817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10816",
    "data-name": "Group 10816"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10815",
    "data-name": "Group 10815"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6477",
    "data-name": "Path 6477",
    d: "M594.718,139.037a1.431,1.431,0,0,0,1.263,1.546,1.368,1.368,0,0,0,1.57-1.171,1.431,1.431,0,0,0-1.261-1.547A1.369,1.369,0,0,0,594.718,139.037Z",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10835",
    "data-name": "Group 10835"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10834",
    "data-name": "Group 10834"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10833",
    "data-name": "Group 10833"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10832",
    "data-name": "Group 10832"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10831",
    "data-name": "Group 10831"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10830",
    "data-name": "Group 10830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10829",
    "data-name": "Group 10829"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10828",
    "data-name": "Group 10828"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10827",
    "data-name": "Group 10827"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10826",
    "data-name": "Group 10826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10825",
    "data-name": "Group 10825"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6478",
    "data-name": "Path 6478",
    d: "M594.463,134.872c.162.2,1.3-.516,2.838-.392,1.534.1,2.6.978,2.78.8.088-.077-.066-.427-.528-.822a3.928,3.928,0,0,0-2.208-.874,3.77,3.77,0,0,0-2.277.545C594.568,134.458,594.382,134.782,594.463,134.872Z",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10858",
    "data-name": "Group 10858"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10846",
    "data-name": "Group 10846"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10845",
    "data-name": "Group 10845"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10844",
    "data-name": "Group 10844"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10843",
    "data-name": "Group 10843"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10842",
    "data-name": "Group 10842"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10841",
    "data-name": "Group 10841"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10840",
    "data-name": "Group 10840"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10839",
    "data-name": "Group 10839"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10838",
    "data-name": "Group 10838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10837",
    "data-name": "Group 10837"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6479",
    "data-name": "Path 6479",
    d: "M607.94,139.806a1.431,1.431,0,0,0,1.263,1.546,1.368,1.368,0,0,0,1.57-1.171,1.432,1.432,0,0,0-1.262-1.547A1.369,1.369,0,0,0,607.94,139.806Z",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10857",
    "data-name": "Group 10857"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10856",
    "data-name": "Group 10856"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10855",
    "data-name": "Group 10855"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10854",
    "data-name": "Group 10854"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10853",
    "data-name": "Group 10853"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10852",
    "data-name": "Group 10852"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10851",
    "data-name": "Group 10851"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10850",
    "data-name": "Group 10850"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10849",
    "data-name": "Group 10849"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10848",
    "data-name": "Group 10848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10847",
    "data-name": "Group 10847"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6480",
    "data-name": "Path 6480",
    d: "M609.136,135.72c.163.2,1.307-.515,2.84-.391,1.534.1,2.6.978,2.779.8.088-.077-.063-.426-.528-.822a3.928,3.928,0,0,0-2.207-.873,3.774,3.774,0,0,0-2.278.544C609.244,135.306,609.057,135.63,609.136,135.72Z",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10869",
    "data-name": "Group 10869"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10868",
    "data-name": "Group 10868"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10867",
    "data-name": "Group 10867"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10866",
    "data-name": "Group 10866"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10865",
    "data-name": "Group 10865"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10864",
    "data-name": "Group 10864"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10863",
    "data-name": "Group 10863"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10862",
    "data-name": "Group 10862"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10861",
    "data-name": "Group 10861"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10860",
    "data-name": "Group 10860"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10859",
    "data-name": "Group 10859"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6481",
    "data-name": "Path 6481",
    d: "M602.8,146.15a10.249,10.249,0,0,0-2.457-.643c-.389-.071-.753-.178-.8-.45a2,2,0,0,1,.351-1.142q.664-1.378,1.392-2.892c1.939-4.123,3.376-7.525,3.21-7.6s-1.875,3.2-3.815,7.324c-.468,1.018-.917,1.987-1.343,2.915a2.271,2.271,0,0,0-.323,1.522.985.985,0,0,0,.6.623,2.683,2.683,0,0,0,.658.144A9.982,9.982,0,0,0,602.8,146.15Z",
    fill: "#263238"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10879",
    "data-name": "Group 10879"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10878",
    "data-name": "Group 10878"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10877",
    "data-name": "Group 10877"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10876",
    "data-name": "Group 10876"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10875",
    "data-name": "Group 10875"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10874",
    "data-name": "Group 10874"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10873",
    "data-name": "Group 10873"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10872",
    "data-name": "Group 10872"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10871",
    "data-name": "Group 10871"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10870",
    "data-name": "Group 10870"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6482",
    "data-name": "Path 6482",
    d: "M600.324,164.224a28.365,28.365,0,0,0,15.2-2.812s-4.367,7.554-15.413,5.647Z",
    fill: "#65463c"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10892",
    "data-name": "Group 10892"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10891",
    "data-name": "Group 10891"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10890",
    "data-name": "Group 10890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10889",
    "data-name": "Group 10889"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10888",
    "data-name": "Group 10888"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10887",
    "data-name": "Group 10887"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10886",
    "data-name": "Group 10886"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10885",
    "data-name": "Group 10885"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10884",
    "data-name": "Group 10884"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10883",
    "data-name": "Group 10883"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6483",
    "data-name": "Path 6483",
    d: "M609.449,131.556c.155.418,1.69.208,3.5.411,1.812.167,3.272.685,3.508.307.106-.18-.151-.571-.743-.972a6.115,6.115,0,0,0-5.337-.547C609.714,131.027,609.382,131.359,609.449,131.556Z",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10902",
    "data-name": "Group 10902"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10901",
    "data-name": "Group 10901"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10900",
    "data-name": "Group 10900"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10899",
    "data-name": "Group 10899"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10898",
    "data-name": "Group 10898"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10897",
    "data-name": "Group 10897"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10896",
    "data-name": "Group 10896"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10895",
    "data-name": "Group 10895"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10894",
    "data-name": "Group 10894"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10893",
    "data-name": "Group 10893"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6484",
    "data-name": "Path 6484",
    d: "M594.765,130.391c.292.373,1.571.109,3.076.209,1.507.055,2.758.45,3.08.109.142-.167-.031-.532-.562-.9a4.854,4.854,0,0,0-2.454-.766,4.781,4.781,0,0,0-2.506.51C594.84,129.865,594.637,130.21,594.765,130.391Z",
    fill: "#263238"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10910",
    "data-name": "Group 10910"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10909",
    "data-name": "Group 10909"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10908",
    "data-name": "Group 10908"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10907",
    "data-name": "Group 10907"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6485",
    "data-name": "Path 6485",
    d: "M619.886,115.9a7.631,7.631,0,0,1-9.545,6.833c-1.675-.44-3.472-1.439-5.011-.645-1.619.834-1.859,3.161-3.321,4.248-2.089,1.553-5.085-.279-7.629.27-1.965.425-3.3,2.171-4.7,3.62s-3.417,2.773-5.3,2.057a22.587,22.587,0,0,1,1.151-5.07,7.607,7.607,0,0,1,3.228-3.957,28.23,28.23,0,0,0,2.565-1.244c1.693-1.167,2.232-3.38,3.353-5.1a8.366,8.366,0,0,1,6.671-3.733c2.2-.058,4.409.769,6.582.393,1.606-.278,3.06-1.2,4.68-1.379,3.154-.356,5.876,2.094,7.962,4.487",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10915",
    "data-name": "Group 10915"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10914",
    "data-name": "Group 10914"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10913",
    "data-name": "Group 10913"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6486",
    "data-name": "Path 6486",
    d: "M609.6,119.569c1.424-.293,4.345-.98,5.184-2.132a8.547,8.547,0,0,1,7.735-3.7,7.054,7.054,0,0,1,5.911,6.038,10.143,10.143,0,0,1,8.268,6.253,11.759,11.759,0,0,1-1.14,10.879,20.985,20.985,0,0,0-1.339,2.6,17.238,17.238,0,0,1,2.139,2.478c2.955,4.784-3.024,7.539-3.024,7.539.426,3.419-2.725,3.812-4.747,4.064-1.944.242-2.44,5.784-4.039,5.778l-.562-16.845a2.076,2.076,0,0,1-.719.229c-3.8.563-3.741-6.771-2.749-8.795a21.764,21.764,0,0,1-3.451-4.225,15.712,15.712,0,0,1-1.147-7.683C614.565,122.026,608.973,119.7,609.6,119.569Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10943",
    "data-name": "Group 10943"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10928",
    "data-name": "Group 10928"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10927",
    "data-name": "Group 10927"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10926",
    "data-name": "Group 10926"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10925",
    "data-name": "Group 10925"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10924",
    "data-name": "Group 10924"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10923",
    "data-name": "Group 10923"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10922",
    "data-name": "Group 10922"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10921",
    "data-name": "Group 10921"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10920",
    "data-name": "Group 10920"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10919",
    "data-name": "Group 10919"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10918",
    "data-name": "Group 10918"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10917",
    "data-name": "Group 10917"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10916",
    "data-name": "Group 10916"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6487",
    "data-name": "Path 6487",
    d: "M623.53,143.479a3.252,3.252,0,0,1,4.954-2.4c1.077.736,1.839,2.11,1.545,4.614-.782,6.677-7.324,4.514-7.314,4.321C622.722,149.893,623.181,146.238,623.53,143.479Z",
    fill: "#9f7362"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10942",
    "data-name": "Group 10942"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10941",
    "data-name": "Group 10941"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10940",
    "data-name": "Group 10940"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10939",
    "data-name": "Group 10939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10938",
    "data-name": "Group 10938"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10937",
    "data-name": "Group 10937"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10936",
    "data-name": "Group 10936"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10935",
    "data-name": "Group 10935"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10934",
    "data-name": "Group 10934"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10933",
    "data-name": "Group 10933"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10932",
    "data-name": "Group 10932"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10931",
    "data-name": "Group 10931"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10930",
    "data-name": "Group 10930"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10929",
    "data-name": "Group 10929"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6488",
    "data-name": "Path 6488",
    d: "M625.052,147.722c.032-.018.107.1.293.209a1.172,1.172,0,0,0,.867.12,2.9,2.9,0,0,0,1.634-2.427,3.856,3.856,0,0,0-.13-1.7,1.351,1.351,0,0,0-.77-1,.6.6,0,0,0-.724.238c-.112.177-.085.315-.121.322-.021.015-.131-.129-.045-.4a.752.752,0,0,1,.312-.387.881.881,0,0,1,.663-.1,1.646,1.646,0,0,1,1.094,1.178,3.976,3.976,0,0,1,.185,1.908,3.04,3.04,0,0,1-2.035,2.685,1.254,1.254,0,0,1-1.043-.3C625.045,147.885,625.027,147.732,625.052,147.722Z",
    fill: "#65463c"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10948",
    "data-name": "Group 10948"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10947",
    "data-name": "Group 10947"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10946",
    "data-name": "Group 10946"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10945",
    "data-name": "Group 10945"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6489",
    "data-name": "Path 6489",
    d: "M587.67,138.946c.033-.054-.644-.376-1.6-1.278a9.583,9.583,0,0,1-2.671-4.762,9.309,9.309,0,0,1-.123-3.772,8.063,8.063,0,0,1,1.833-3.866,9.52,9.52,0,0,1,9-3c.316.057.615.173.917.254.293.108.573.235.848.346l.427.173-.051-.444a3.287,3.287,0,0,1,.538-2.216,5.238,5.238,0,0,1,1.683-1.567,6.911,6.911,0,0,1,4.272-.875c2.854.269,5.371,1.232,7.625,1.2a7.162,7.162,0,0,0,4.88-1.657,4.133,4.133,0,0,0,.852-1.132,1.8,1.8,0,0,0,.167-.464,5.825,5.825,0,0,1-1.15,1.45,7.141,7.141,0,0,1-4.747,1.443,17.6,17.6,0,0,1-3.5-.536,30.915,30.915,0,0,0-4.089-.776,8.794,8.794,0,0,0-2.3.067,7.059,7.059,0,0,0-2.27.843,5.723,5.723,0,0,0-1.859,1.72,3.812,3.812,0,0,0-.625,2.57l.375-.271c-.292-.12-.591-.256-.9-.371-.321-.088-.641-.209-.977-.272a9.954,9.954,0,0,0-9.483,3.2,8.449,8.449,0,0,0-1.9,4.108,9.591,9.591,0,0,0,.191,3.935,9.482,9.482,0,0,0,2.9,4.824,6.709,6.709,0,0,0,1.255.894A2.032,2.032,0,0,0,587.67,138.946Z",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10952",
    "data-name": "Group 10952"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10951",
    "data-name": "Group 10951"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10950",
    "data-name": "Group 10950"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10949",
    "data-name": "Group 10949"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6490",
    "data-name": "Path 6490",
    d: "M586.038,116.066a7.213,7.213,0,0,1,1.989-.985,5.551,5.551,0,0,1,2.5-.1,4.926,4.926,0,0,1,2.786,1.521l.292.323.1-.422a7.62,7.62,0,0,1,5.537-5.345,9.85,9.85,0,0,1,6.112.938,26.147,26.147,0,0,0,4.983,1.81,7.39,7.39,0,0,0,3.588-.043,4.5,4.5,0,0,0,.9-.379c.193-.115.288-.183.279-.2-.022-.045-.431.191-1.235.378a7.74,7.74,0,0,1-3.456-.122,28.445,28.445,0,0,1-4.874-1.894,16.178,16.178,0,0,0-2.993-1.009,7.726,7.726,0,0,0-3.43.006,7.989,7.989,0,0,0-5.858,5.752l.391-.1a5.244,5.244,0,0,0-3.062-1.584,5.606,5.606,0,0,0-2.642.21,4.746,4.746,0,0,0-1.5.805C586.157,115.891,586.023,116.052,586.038,116.066Z",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10955",
    "data-name": "Group 10955"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10954",
    "data-name": "Group 10954"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10953",
    "data-name": "Group 10953"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6491",
    "data-name": "Path 6491",
    d: "M603.763,149.391a2.2,2.2,0,0,1,1.7-.741,2.6,2.6,0,0,1,1.853,1.016c.011.011.021.023.031.034.02.027.048.048.066.075l-.026-.013a1.251,1.251,0,0,1,.287.734,1.841,1.841,0,0,1-.873,1.494,2.328,2.328,0,0,1-2.681-.039A1.9,1.9,0,0,1,603.763,149.391Z",
    fill: "#65463c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10959",
    "data-name": "Group 10959"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10958",
    "data-name": "Group 10958"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10957",
    "data-name": "Group 10957"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10956",
    "data-name": "Group 10956"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6492",
    "data-name": "Path 6492",
    d: "M607.731,148.135c-.088-.022-.22.33-.554.793a3.6,3.6,0,0,1-3.824,1.484c-.558-.118-.893-.288-.943-.212-.045.058.22.37.818.617a3.4,3.4,0,0,0,4.315-1.674C607.818,148.557,607.8,148.148,607.731,148.135Z",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10964",
    "data-name": "Group 10964"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10963",
    "data-name": "Group 10963"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10962",
    "data-name": "Group 10962"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10961",
    "data-name": "Group 10961"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6493",
    "data-name": "Path 6493",
    d: "M633.451,129.694a1.492,1.492,0,0,0,.3-.22,8.129,8.129,0,0,0,.75-.744,7.805,7.805,0,0,0,1.8-3.428,6.132,6.132,0,0,0-.006-2.707,5.548,5.548,0,0,0-1.5-2.727,4.438,4.438,0,0,0-3.176-1.282,4.121,4.121,0,0,0-3.313,1.569l.308.162.024-.072a9.2,9.2,0,0,0-.189-7,6.053,6.053,0,0,0-4.507-3.439,4.95,4.95,0,0,0-3.711,1.052,3.9,3.9,0,0,0-.721.785,1.478,1.478,0,0,0-.177.327,6.124,6.124,0,0,1,.983-1.005,4.9,4.9,0,0,1,3.594-.911,5.826,5.826,0,0,1,4.247,3.335,8.953,8.953,0,0,1,.147,6.745l-.023.07-.339,1.036.648-.874a3.792,3.792,0,0,1,3.031-1.433,4.119,4.119,0,0,1,2.948,1.171,5.284,5.284,0,0,1,1.438,2.561,5.94,5.94,0,0,1,.047,2.587,8.01,8.01,0,0,1-1.666,3.392C633.819,129.344,633.428,129.669,633.451,129.694Z",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10982",
    "data-name": "Group 10982"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10969",
    "data-name": "Group 10969"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10968",
    "data-name": "Group 10968"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10967",
    "data-name": "Group 10967"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6494",
    "data-name": "Path 6494",
    d: "M537.611,191.087l6.482,24.487a3.047,3.047,0,0,0,3,2.266l33.566-.66a3.045,3.045,0,0,0,2.92-3.673l-4.943-23.452a3.045,3.045,0,0,0-2.98-2.417H540.266A2.746,2.746,0,0,0,537.611,191.087Z",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10972",
    "data-name": "Group 10972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10971",
    "data-name": "Group 10971"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10970",
    "data-name": "Group 10970"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6495",
    "data-name": "Path 6495",
    d: "M534.788,196.618a2.468,2.468,0,0,1-.015-3.039,3.758,3.758,0,0,1,2.881-1.362,8.207,8.207,0,0,1,3.2.666,20.871,20.871,0,0,1,3.633,1.812,3.464,3.464,0,0,1,1.81,2.117c.159.944-.868,2.022-1.7,1.548a4.01,4.01,0,0,1,2.346,2.794c.173,1.195-.465,1.838-1.623,2.182a1.8,1.8,0,0,1,1.04,2.3,2.068,2.068,0,0,1-2.59.79,6.035,6.035,0,0,1-2.258-1.894,5.521,5.521,0,0,1,.644,3.794,7.421,7.421,0,0,1-4.853-5.959,3.431,3.431,0,0,1-.932-4.218,3.556,3.556,0,0,1-2.118-2.97",
    fill: "#9f7362"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10976",
    "data-name": "Group 10976"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10975",
    "data-name": "Group 10975"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10974",
    "data-name": "Group 10974"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10973",
    "data-name": "Group 10973"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6496",
    "data-name": "Path 6496",
    d: "M545.3,203.347a9.645,9.645,0,0,1-1.105-.845,7.459,7.459,0,0,0-2.913-1.49,3.992,3.992,0,0,0-1.772,0,3.311,3.311,0,0,0-1.293.646,4.117,4.117,0,0,0-.842,1.062.757.757,0,0,1,.1-.368,2.579,2.579,0,0,1,.612-.843,3.305,3.305,0,0,1,1.359-.746,4.03,4.03,0,0,1,1.9-.027,6.85,6.85,0,0,1,2.979,1.611A5.309,5.309,0,0,1,545.3,203.347Z",
    fill: "#65463c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10980",
    "data-name": "Group 10980"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10979",
    "data-name": "Group 10979"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10978",
    "data-name": "Group 10978"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10977",
    "data-name": "Group 10977"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6497",
    "data-name": "Path 6497",
    d: "M545.019,198.476a5.916,5.916,0,0,1-1.342-.56,15.487,15.487,0,0,0-1.429-.624,12.11,12.11,0,0,0-1.838-.476,5.261,5.261,0,0,0-1.866-.018,3.415,3.415,0,0,0-1.383.6,3.539,3.539,0,0,0-.9,1.078.8.8,0,0,1,.108-.382,2.464,2.464,0,0,1,.673-.851,3.4,3.4,0,0,1,1.452-.7,5.191,5.191,0,0,1,1.966-.005,10.773,10.773,0,0,1,1.882.51,12.011,12.011,0,0,1,1.428.69A10.22,10.22,0,0,1,545.019,198.476Z",
    fill: "#65463c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10981",
    "data-name": "Group 10981"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6498",
    "data-name": "Path 6498",
    d: "M559.686,199.479l.187-.029a1.648,1.648,0,1,1-.187.029Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10998",
    "data-name": "Group 10998"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10985",
    "data-name": "Group 10985"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10984",
    "data-name": "Group 10984"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10983",
    "data-name": "Group 10983"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6499",
    "data-name": "Path 6499",
    d: "M592.3,191.06s-3.56-6.947-4.613-6.54-2.432.432-1.758,3.059,2.421,4.434,2.32,6.5-1.719,6.687.075,8.842,4.825,8.638,4.825,8.638l7.888-8.036-1.764-2.588s2.957-4.1,3.534-6.483a14.566,14.566,0,0,0-.291-5.752,5.736,5.736,0,0,0-.86-3.509,25.239,25.239,0,0,0,.157-3.183c-.035-1.609-4.185-8.241-4.185-8.241a2.409,2.409,0,0,0-1.412,3.03,31.281,31.281,0,0,0,1.635,4.1l-4.845-1.845a2.7,2.7,0,0,0,1.308,3.737c2.572,1.389,2.973,2.557,2.973,2.557l-3.686.277s-.342,2.049,1.135,2.467l1.477.417Z",
    fill: "#9f7362"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10989",
    "data-name": "Group 10989"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10988",
    "data-name": "Group 10988"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10987",
    "data-name": "Group 10987"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10986",
    "data-name": "Group 10986"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6500",
    "data-name": "Path 6500",
    d: "M594.451,187.97l3.322.716.052.011.023.049a5.915,5.915,0,0,1,.65,2.953,5.439,5.439,0,0,1-1.533,3.281,12.827,12.827,0,0,1-3.3,2.113,8.319,8.319,0,0,0-2.529,1.812,3.919,3.919,0,0,0-.924,1.853c-.088.491-.03.772-.061.774-.01,0-.027-.066-.049-.2a2.445,2.445,0,0,1,0-.591,3.832,3.832,0,0,1,.878-1.969,8.186,8.186,0,0,1,2.561-1.917,13.137,13.137,0,0,0,3.214-2.081,5.246,5.246,0,0,0,1.47-3.1,5.843,5.843,0,0,0-.576-2.84l.075.061A18.463,18.463,0,0,1,594.451,187.97Z",
    fill: "#65463c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10993",
    "data-name": "Group 10993"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10992",
    "data-name": "Group 10992"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10991",
    "data-name": "Group 10991"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10990",
    "data-name": "Group 10990"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6501",
    "data-name": "Path 6501",
    d: "M601.729,188.411a6.312,6.312,0,0,1-.344-.778,3.333,3.333,0,0,0-1.358-1.415,6.8,6.8,0,0,0-1.9-.674,3.265,3.265,0,0,1-.836-.206,2.164,2.164,0,0,1,.87,0,5.391,5.391,0,0,1,2.015.624,3.46,3.46,0,0,1,.912.753,2.972,2.972,0,0,1,.489.831A1.642,1.642,0,0,1,601.729,188.411Z",
    fill: "#65463c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10997",
    "data-name": "Group 10997"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10996",
    "data-name": "Group 10996"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10995",
    "data-name": "Group 10995"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10994",
    "data-name": "Group 10994"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6502",
    "data-name": "Path 6502",
    d: "M601.3,184.318c-.076.044-.63-.886-1.572-1.8s-1.874-1.463-1.831-1.54a6.2,6.2,0,0,1,3.4,3.344Z",
    fill: "#65463c"
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterHero);
export default __webpack_public_path__ + "static/media/registerHero.4c9a0050541c8a50a4c7c27bfa028d3e.svg";
export { ForwardRef as ReactComponent };